import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  Upload: any;
};

export type AccountConnectionStatus = {
  __typename?: 'AccountConnectionStatus';
  accountId: Scalars['Int'];
  isValid: Scalars['Boolean'];
  lastValidated: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  needsReconnection: Scalars['Boolean'];
  platform: Platform;
};

export type AccountFollowerStats = {
  __typename?: 'AccountFollowerStats';
  accountName: Scalars['String'];
  followerCount: Scalars['Int'];
  lastSynced: Scalars['String'];
  platform: Platform;
};

export type AccountTrackingResponse = {
  __typename?: 'AccountTrackingResponse';
  account?: Maybe<FollowerTrackingAccount>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type AggregateMetrics = {
  __typename?: 'AggregateMetrics';
  avgEngagementRate: Scalars['Float'];
  avgFollowers: Scalars['Float'];
  avgPostFrequency: Scalars['Float'];
  hashtagTrends: Array<HashtagTrend>;
  totalCompetitors: Scalars['Int'];
};

export type AllPosts = {
  __typename?: 'AllPosts';
  old: Array<Maybe<Post>>;
  scheduled: Array<Maybe<Post>>;
};

export type AudienceInsights = {
  __typename?: 'AudienceInsights';
  engagementTrend: Array<DailyEngagement>;
  followerTiers: Array<FollowerTier>;
  platformBreakdown: Array<PlatformStat>;
  topTopics: Array<Scalars['String']>;
  totalCreators: Scalars['Int'];
  totalEngagements: Scalars['Int'];
};

export type AudienceMember = {
  __typename?: 'AudienceMember';
  commentFrequency: Scalars['Int'];
  followerCount?: Maybe<Scalars['Int']>;
  fullName?: Maybe<Scalars['String']>;
  isVerified: Scalars['Boolean'];
  profilePicUrl?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

export type BrandValue = {
  __typename?: 'BrandValue';
  accountName: Scalars['String'];
  engagement: Scalars['Int'];
  platform: Platform;
  pricePerPost: Scalars['Int'];
};

export type Campaign = {
  __typename?: 'Campaign';
  active: Scalars['Boolean'];
  createdAt: Scalars['Float'];
  hitsCount: Scalars['Float'];
  id: Scalars['ID'];
  keywords: Array<Scalars['String']>;
  name: Scalars['String'];
  platforms: Array<Platform>;
  type?: Maybe<CampaignType>;
};

export type CampaignExtractedData = {
  __typename?: 'CampaignExtractedData';
  followersInfo?: Maybe<FollowersFilterOutput>;
  isComplete?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  maxHits?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  platforms?: Maybe<Array<Scalars['String']>>;
  similarSearching?: Maybe<Scalars['Boolean']>;
};

export type CampaignFilter = {
  search: Scalars['String'];
};

export enum CampaignType {
  Brand = 'Brand',
  Competitor = 'Competitor',
  Query = 'Query'
}

export type CampaignVolumeData = {
  __typename?: 'CampaignVolumeData';
  campaignName: Scalars['String'];
  hits: Scalars['Int'];
};

export type CampaignsVolume = {
  __typename?: 'CampaignsVolume';
  data: Array<CampaignVolumeData>;
  platform: Platform;
};

export type ChatInput = {
  message: Scalars['String'];
  sessionId?: InputMaybe<Scalars['String']>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  content: Scalars['String'];
  role: Scalars['String'];
};

export type ChatResponse = {
  __typename?: 'ChatResponse';
  canCreateCampaign: Scalars['Boolean'];
  extractedData: CampaignExtractedData;
  response: Scalars['String'];
  sessionId: Scalars['String'];
};

export type CompetitorAccount = {
  __typename?: 'CompetitorAccount';
  accountUrl: Scalars['String'];
  avatarUrl?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  growthTrend: GrowthTrend;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  lastScraped: Scalars['String'];
  latestMetrics?: Maybe<CompetitorSnapshot>;
  platform: Platform;
  username: Scalars['String'];
};

export type CompetitorAccountInput = {
  platform: Platform;
  username: Scalars['String'];
};

export type CompetitorCampaignConfig = {
  __typename?: 'CompetitorCampaignConfig';
  autoRefreshEnabled: Scalars['Boolean'];
  autoRefreshInterval: Scalars['Int'];
  campaignId: Scalars['String'];
  contentAnalysisEnabled: Scalars['Boolean'];
  gapAnalysis: Scalars['Boolean'];
  id: Scalars['ID'];
  lastRefreshed: Scalars['String'];
  strategyDetection: Scalars['Boolean'];
};

export type CompetitorConfigInput = {
  autoRefreshEnabled?: InputMaybe<Scalars['Boolean']>;
  autoRefreshInterval?: InputMaybe<Scalars['Int']>;
  contentAnalysisEnabled?: InputMaybe<Scalars['Boolean']>;
  gapAnalysis?: InputMaybe<Scalars['Boolean']>;
  strategyDetection?: InputMaybe<Scalars['Boolean']>;
};

export type CompetitorContent = {
  __typename?: 'CompetitorContent';
  caption?: Maybe<Scalars['String']>;
  comments: Scalars['Int'];
  contentId: Scalars['String'];
  contentThemes: Array<Scalars['String']>;
  contentType: Scalars['String'];
  contentUrl: Scalars['String'];
  engagementRate: Scalars['Float'];
  fbLikeCount?: Maybe<Scalars['Int']>;
  fbPlayCount?: Maybe<Scalars['Int']>;
  hasAudio?: Maybe<Scalars['Boolean']>;
  hashtags: Array<Scalars['String']>;
  id: Scalars['ID'];
  isTopPerformer: Scalars['Boolean'];
  likes: Scalars['Int'];
  mentions: Array<Scalars['String']>;
  performanceScore: Scalars['Float'];
  platform: Platform;
  postedAt: Scalars['String'];
  saves?: Maybe<Scalars['Int']>;
  scrapedAt: Scalars['String'];
  shares: Scalars['Int'];
  strategy?: Maybe<Scalars['JSON']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  videoDuration?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Int']>;
};

export type CompetitorDashboard = {
  __typename?: 'CompetitorDashboard';
  aggregateMetrics: AggregateMetrics;
  competitors: Array<CompetitorAccount>;
  config: CompetitorCampaignConfig;
  insights: Array<CompetitorInsight>;
  topSavedContent?: Maybe<Array<CompetitorContent>>;
  topSharedContent?: Maybe<Array<CompetitorContent>>;
  userAccounts: Array<MediaAccountInfo>;
  yourPerformance?: Maybe<UserPerformance>;
};

export type CompetitorInsight = {
  __typename?: 'CompetitorInsight';
  affectedCompetitors: Array<Scalars['String']>;
  description: Scalars['String'];
  generatedAt: Scalars['String'];
  id: Scalars['ID'];
  insightType: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDismissed: Scalars['Boolean'];
  metrics: Scalars['JSON'];
  priority: Scalars['String'];
  recommendations: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type CompetitorSnapshot = {
  __typename?: 'CompetitorSnapshot';
  averageEngagement: Scalars['Float'];
  engagementGrowth: Scalars['Float'];
  engagementRate: Scalars['Float'];
  followers: Scalars['Int'];
  followersGrowth: Scalars['Int'];
  following: Scalars['Int'];
  id: Scalars['ID'];
  postFrequency: Scalars['Float'];
  postsGrowth: Scalars['Int'];
  timestamp: Scalars['String'];
  totalPosts: Scalars['Int'];
};

export type Connect = {
  __typename?: 'Connect';
  accessToken: Scalars['String'];
  expires?: Maybe<Scalars['Int']>;
  refreshToken?: Maybe<Scalars['String']>;
};

export type CreateListeningTopicInput = {
  description: Scalars['String'];
  maxFollowers?: InputMaybe<Scalars['Int']>;
  minFollowers?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  platforms: Array<Platform>;
  seedKeywords?: InputMaybe<Scalars['JSON']>;
};

export type Creator = {
  __typename?: 'Creator';
  avatarUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DailyEngagement = {
  __typename?: 'DailyEngagement';
  count: Scalars['Int'];
  date: Scalars['String'];
};

export type DashboardHitsVolumeReturn = {
  __typename?: 'DashboardHitsVolumeReturn';
  campaignsVolume: Array<CampaignsVolume>;
  hitsVolume: Array<HitsVolume>;
};

export type DashboardMetrics = {
  __typename?: 'DashboardMetrics';
  avgEngagementPerPost: Scalars['Float'];
  engagementRate: Scalars['Float'];
  platformBreakdown: Array<PlatformMetrics>;
  totalComments: Scalars['Int'];
  totalEngagement: Scalars['Int'];
  totalHits: Scalars['Int'];
  totalLikes: Scalars['Int'];
  totalShares: Scalars['Int'];
};

export type EditInstagramToolObject = {
  commentReply: Array<InputMaybe<Scalars['String']>>;
  keyword: Scalars['String'];
  message: Array<Scalars['String']>;
  shouldReply: Scalars['Boolean'];
  title: Scalars['String'];
};

export type EngagementStats = {
  __typename?: 'EngagementStats';
  streakDays: Scalars['Int'];
  thisMonth: Scalars['Int'];
  thisWeek: Scalars['Int'];
  today: Scalars['Int'];
  total: Scalars['Int'];
};

export type EngagementTimeSeries = {
  __typename?: 'EngagementTimeSeries';
  dataPoints: Array<EngagementTimeSeriesDataPoint>;
  granularity: TimeSeriesGranularity;
};

export type EngagementTimeSeriesDataPoint = {
  __typename?: 'EngagementTimeSeriesDataPoint';
  avgEngagement: Scalars['Float'];
  period: Scalars['String'];
  periodEnd: Scalars['String'];
  periodStart: Scalars['String'];
  totalComments: Scalars['Int'];
  totalLikes: Scalars['Int'];
  totalPosts: Scalars['Int'];
  totalShares: Scalars['Int'];
  totalViews: Scalars['Int'];
};

export type EpisodePerformance = {
  __typename?: 'EpisodePerformance';
  contentCount: Scalars['Int'];
  createdAt: Scalars['String'];
  engagementCount: Scalars['Int'];
  topicId: Scalars['String'];
  topicName: Scalars['String'];
};

export type FlatHitsResult = {
  __typename?: 'FlatHitsResult';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  hits: Array<Hit>;
};

export type FollowerAnalytics = {
  __typename?: 'FollowerAnalytics';
  accounts: Array<FollowerAnalyticsAccount>;
  recentFollowers: Array<FollowerInfo>;
  recentUnfollowers: Array<FollowerInfo>;
  snapshots: Array<FollowerAnalyticsSnapshot>;
  summary: FollowerAnalyticsSummary;
};

export type FollowerAnalyticsAccount = {
  __typename?: 'FollowerAnalyticsAccount';
  currentFollowerCount: Scalars['Int'];
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  lastSnapshotAt?: Maybe<Scalars['DateTime']>;
  platform: Platform;
  totalNewFollows: Scalars['Int'];
  totalUnfollows: Scalars['Int'];
  username: Scalars['String'];
};

export type FollowerAnalyticsSnapshot = {
  __typename?: 'FollowerAnalyticsSnapshot';
  accountId: Scalars['String'];
  followerCount: Scalars['Int'];
  id: Scalars['ID'];
  netChange: Scalars['Int'];
  newFollowers: Scalars['Int'];
  platform: Platform;
  snapshotAt: Scalars['DateTime'];
  unfollowers: Scalars['Int'];
};

export type FollowerAnalyticsSummary = {
  __typename?: 'FollowerAnalyticsSummary';
  growthRate: Scalars['Float'];
  netChange: Scalars['Int'];
  totalFollowers: Scalars['Int'];
  totalGained: Scalars['Int'];
  totalLost: Scalars['Int'];
};

export type FollowerDetails = {
  __typename?: 'FollowerDetails';
  bio?: Maybe<Scalars['String']>;
  commentsSummary?: Maybe<Scalars['String']>;
  platform: Scalars['String'];
  profileImage?: Maybe<Scalars['String']>;
  profileSummary?: Maybe<Scalars['String']>;
  stats: FollowerStats;
  tags: Array<Hashtag>;
  username: Scalars['String'];
};

export type FollowerInfo = {
  __typename?: 'FollowerInfo';
  avatarUrl?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  followedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  platform: Platform;
  unfollowedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type FollowerStats = {
  __typename?: 'FollowerStats';
  comments: Scalars['Int'];
  followers: Scalars['String'];
  following: Scalars['String'];
  likes: Scalars['Int'];
  posts: Scalars['String'];
};

export type FollowerStatsInput = {
  comments: Scalars['Int'];
  followers: Scalars['String'];
  following: Scalars['String'];
  likes: Scalars['Int'];
  posts: Scalars['String'];
};

export type FollowerSyncResult = {
  __typename?: 'FollowerSyncResult';
  accountName: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  followerCount: Scalars['Int'];
  platform: Platform;
  success: Scalars['Boolean'];
};

export type FollowerTier = {
  __typename?: 'FollowerTier';
  count: Scalars['Int'];
  percentage: Scalars['Float'];
  tier: Scalars['String'];
};

export type FollowerTrackingAccount = {
  __typename?: 'FollowerTrackingAccount';
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  platform: Platform;
  username: Scalars['String'];
};

export type FollowerTrackingConfig = {
  __typename?: 'FollowerTrackingConfig';
  id: Scalars['String'];
  retentionDays: Scalars['Int'];
  snapshotFrequency: Scalars['Int'];
  trackingEnabled: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type FollowerTrackingResponse = {
  __typename?: 'FollowerTrackingResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
  tracking?: Maybe<FollowerTrackingConfig>;
};

export type FollowersFilterInfo = {
  from: Scalars['Int'];
  operator: Scalars['String'];
  to: Scalars['Int'];
};

export type FollowersFilterOutput = {
  __typename?: 'FollowersFilterOutput';
  from: Scalars['Int'];
  operator: Scalars['String'];
  to: Scalars['Int'];
};

export type FollowersObject = {
  __typename?: 'FollowersObject';
  avatar?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type GeneratedKeywords = {
  __typename?: 'GeneratedKeywords';
  keywords: Scalars['JSON'];
};

export type GrowthTrend = {
  __typename?: 'GrowthTrend';
  direction: Scalars['String'];
  percentage: Scalars['Float'];
  timeframe: Scalars['String'];
};

export type Hashtag = {
  __typename?: 'Hashtag';
  count: Scalars['Int'];
  name: Scalars['String'];
};

export type HashtagMetrics = {
  __typename?: 'HashtagMetrics';
  engagement?: Maybe<Scalars['Float']>;
  growth: Scalars['Float'];
  volume: Scalars['Int'];
};

export type HashtagTrend = {
  __typename?: 'HashtagTrend';
  count: Scalars['Int'];
  hashtag: Scalars['String'];
  trend: Scalars['String'];
};

export type Hit = {
  __typename?: 'Hit';
  campaignId: Scalars['ID'];
  campaignName?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  creator: Creator;
  date?: Maybe<Scalars['String']>;
  generateCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  interactedWith: Scalars['Boolean'];
  interaction: HitInteraction;
  keywords: Array<Scalars['String']>;
  markedUnhelpful: Scalars['Boolean'];
  name: Scalars['String'];
  platforms: Array<Platform>;
  postURL: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  uq_index: Scalars['Int'];
  videoUrl?: Maybe<Scalars['String']>;
};

export type HitFilter = {
  campaignId: Scalars['Int'];
  categories?: InputMaybe<Array<Scalars['String']>>;
  endDateRange?: InputMaybe<Scalars['String']>;
  interacted?: InputMaybe<Scalars['Boolean']>;
  likes?: InputMaybe<Array<Scalars['String']>>;
  platforms?: InputMaybe<Array<Scalars['String']>>;
  shouldClassify?: InputMaybe<Scalars['Boolean']>;
  socialNetwork?: InputMaybe<Scalars['String']>;
  startDateRange?: InputMaybe<Scalars['String']>;
};

export type HitInteraction = {
  __typename?: 'HitInteraction';
  bio?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['Int']>;
  followers?: Maybe<Scalars['Int']>;
  following?: Maybe<Scalars['Int']>;
  positive: Scalars['Int'];
  postCount?: Maybe<Scalars['Int']>;
  shared?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type HitVolumeData = {
  __typename?: 'HitVolumeData';
  count: Scalars['Int'];
  platform: Platform;
};

export type HitsVolume = {
  __typename?: 'HitsVolume';
  data: Array<HitVolumeData>;
  date: Scalars['String'];
};

export type InstagramInsights = {
  __typename?: 'InstagramInsights';
  endDate: Scalars['String'];
  id: Scalars['Int'];
  impressions: Scalars['Int'];
  profile_views: Scalars['Int'];
  reach: Scalars['Int'];
  startDate: Scalars['String'];
};

export type InstagramPost = {
  __typename?: 'InstagramPost';
  caption?: Maybe<PostCaption>;
  comment_count?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  like_count?: Maybe<Scalars['Int']>;
};

export type InstagramToolsResponse = {
  __typename?: 'InstagramToolsResponse';
  commentReply: Array<Maybe<Scalars['String']>>;
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  keyword: Scalars['String'];
  message: Array<Scalars['String']>;
  shouldReply: Scalars['Boolean'];
  status: ToolStatus;
  title: Scalars['String'];
  triggered: Scalars['Int'];
};

export type ListeningTopic = {
  __typename?: 'ListeningTopic';
  contentCount: Scalars['Int'];
  createdAt: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  lastScrapedAt?: Maybe<Scalars['String']>;
  maxFollowers?: Maybe<Scalars['Int']>;
  minFollowers?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  platforms: Array<Platform>;
  seedKeywords: Scalars['JSON'];
  updatedAt: Scalars['String'];
};

export type ListeningTopicFeedInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<Platform>;
  topicId: Scalars['ID'];
};

export type ListeningTopicFeedResult = {
  __typename?: 'ListeningTopicFeedResult';
  content: Array<NicheContent>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type Loading = {
  __typename?: 'Loading';
  facebook: Scalars['Boolean'];
  instagram: Scalars['Boolean'];
  reddit: Scalars['Boolean'];
  tiktok: Scalars['Boolean'];
  youtube: Scalars['Boolean'];
};

export type MediaAccountInfo = {
  __typename?: 'MediaAccountInfo';
  accountName: Scalars['String'];
  id: Scalars['Int'];
  platform: Platform;
};

export type MediaAccounts = {
  __typename?: 'MediaAccounts';
  accessToken: Scalars['String'];
  accountName: Scalars['String'];
  apiKeyAddedAt?: Maybe<Scalars['String']>;
  comments_disabled?: Maybe<Scalars['Boolean']>;
  duet_disabled?: Maybe<Scalars['Boolean']>;
  followerCount?: Maybe<Scalars['Int']>;
  hasApiKey: Scalars['Boolean'];
  id: Scalars['Int'];
  igUserId?: Maybe<Scalars['String']>;
  lastFollowerSync?: Maybe<Scalars['String']>;
  max_video_duration?: Maybe<Scalars['Int']>;
  nickname?: Maybe<Scalars['String']>;
  platform: Platform;
  privacy_level_options?: Maybe<Array<Scalars['String']>>;
  stitch_disabled?: Maybe<Scalars['Boolean']>;
};

export type Membership = {
  __typename?: 'Membership';
  id: Scalars['ID'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAccountToFollowerTracking: AccountTrackingResponse;
  addCompetitor?: Maybe<CompetitorAccount>;
  addMediaAccount: MediaAccounts;
  analyzeFollowers: Scalars['Boolean'];
  archiveHit: Scalars['Boolean'];
  bulkGenerateSummary: Scalars['Boolean'];
  calculateSuperFans: SuperFanStats;
  campaignCreate: Campaign;
  campaignDelete: Scalars['Boolean'];
  cancelPost: Scalars['Boolean'];
  changeToolStatus: Scalars['Boolean'];
  chat: ChatResponse;
  clearChatSession: Scalars['Boolean'];
  createCampaignFromChat: Campaign;
  createHashtags: Scalars['Boolean'];
  createHitGeneration: Scalars['Boolean'];
  createInstagramAutomationTool: Scalars['Boolean'];
  createInstagramInsights: Scalars['Boolean'];
  createListeningTopic: ListeningTopic;
  createSubscription: Scalars['Boolean'];
  createTargetCreators: Scalars['Boolean'];
  createVibes: Scalars['Boolean'];
  createWeeklyContext: Scalars['Boolean'];
  deleteInstagramTool: Scalars['Boolean'];
  deleteListeningTopic: Scalars['Boolean'];
  deleteUserAccount: Scalars['Boolean'];
  disableFollowerTracking: FollowerTrackingResponse;
  dismissInsight: Scalars['Boolean'];
  editInstagramTool: Scalars['Boolean'];
  enableFollowerTracking: FollowerTrackingResponse;
  exploreAudience: Array<AudienceMember>;
  facebookAddUserAccessKey: Scalars['Boolean'];
  facebookEdit: Scalars['Boolean'];
  facebookReact: Scalars['Boolean'];
  facebookReply: Scalars['Boolean'];
  fetchFollowerDetails: Array<FollowerDetails>;
  fetchSimilarAccounts: Array<SimilarAccount>;
  fetchUserPosts: Array<InstagramPost>;
  generateCommentsSummary: Scalars['String'];
  generateGuestPitch: Scalars['String'];
  generateProfileSummary: Scalars['String'];
  getBrandValues: Scalars['Boolean'];
  hideTopicContent: Scalars['Boolean'];
  hitMarkUnhelpful: Hit;
  instagramAddUserAccessKey: Scalars['Boolean'];
  instagramEdit: Scalars['Boolean'];
  instagramReact: Scalars['Boolean'];
  instagramReply: Scalars['Boolean'];
  interactedWithHit: Scalars['Boolean'];
  markTopicContentInteracted: Scalars['Boolean'];
  membershipChange: Membership;
  notificationMarkSeen: Notification;
  publishFacebook: Scalars['Boolean'];
  publishInstagram: Scalars['Boolean'];
  publishTikTok: Scalars['Boolean'];
  recordSuperFanAction: SuperFanAction;
  redditAddUserAccessKey: Scalars['Boolean'];
  redditEdit: Scalars['Boolean'];
  redditReact: Scalars['Boolean'];
  redditReply: Scalars['Boolean'];
  refreshAllCompetitors: Scalars['Boolean'];
  refreshCompetitor?: Maybe<CompetitorAccount>;
  refreshListeningTopic: Scalars['Boolean'];
  refreshTargetCreators: Scalars['Boolean'];
  refreshTargetFollowers: Scalars['Boolean'];
  removeAccountFromFollowerTracking: AccountTrackingResponse;
  removeCompetitor: Scalars['Boolean'];
  removeMediaAccount: Scalars['Boolean'];
  removeYouTubeApiKey: Scalars['Boolean'];
  saveContentComment: Scalars['Boolean'];
  saveYouTubeApiKey: YouTubeApiKeyResult;
  schedulePost: Scalars['Boolean'];
  syncFollowerCounts: Array<AccountFollowerStats>;
  syncFollowerCountsTracking: Array<FollowerSyncResult>;
  syncFollowerTrackingAccounts: SyncFollowerTrackingResult;
  syncPostEngagement: Array<SyncPostEngagementResult>;
  toggleCompetitorActive?: Maybe<CompetitorAccount>;
  twitterAddUserAccessKey: Scalars['Boolean'];
  twitterEdit: Scalars['Boolean'];
  twitterReact: Scalars['Boolean'];
  twitterReply: Scalars['Boolean'];
  updateCampaignResults: Scalars['Boolean'];
  updateGuestStatus: Scalars['Boolean'];
  updateListeningTopic: ListeningTopic;
  updateSubscription: Scalars['Boolean'];
  validateAccountConnection: AccountConnectionStatus;
  youtubeAddUserAccessKey: Scalars['Boolean'];
  youtubeEdit: Scalars['Boolean'];
  youtubeReact: Scalars['Boolean'];
  youtubeReply: Scalars['Boolean'];
};


export type MutationAddAccountToFollowerTrackingArgs = {
  mediaAccountId: Scalars['Int'];
};


export type MutationAddCompetitorArgs = {
  configId: Scalars['String'];
  platform: Platform;
  username: Scalars['String'];
};


export type MutationAddMediaAccountArgs = {
  accessToken: Scalars['String'];
  platform: Platform;
  refreshToken?: InputMaybe<Scalars['String']>;
};


export type MutationAnalyzeFollowersArgs = {
  accountId: Scalars['Int'];
};


export type MutationArchiveHitArgs = {
  campaignId: Scalars['ID'];
  hitId: Scalars['String'];
};


export type MutationBulkGenerateSummaryArgs = {
  campaignId: Scalars['ID'];
  data?: InputMaybe<Scalars['String']>;
};


export type MutationCalculateSuperFansArgs = {
  mediaAccountId: Scalars['Int'];
};


export type MutationCampaignCreateArgs = {
  campaignType?: InputMaybe<CampaignType>;
  competitorAccounts?: InputMaybe<Array<CompetitorAccountInput>>;
  competitorConfig?: InputMaybe<CompetitorConfigInput>;
  followersInfo: FollowersFilterInfo;
  hitsPerDay: Scalars['Int'];
  name: Scalars['String'];
  platforms: Array<Platform>;
  queryTree?: InputMaybe<Scalars['String']>;
  similarSearching?: InputMaybe<Scalars['Boolean']>;
  userAccounts?: InputMaybe<Array<UserAccountSelectionInput>>;
};


export type MutationCampaignDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationCancelPostArgs = {
  postId: Scalars['Int'];
};


export type MutationChangeToolStatusArgs = {
  id: Scalars['Int'];
  status: ToolStatus;
};


export type MutationChatArgs = {
  input: ChatInput;
};


export type MutationClearChatSessionArgs = {
  sessionId: Scalars['String'];
};


export type MutationCreateCampaignFromChatArgs = {
  sessionId: Scalars['String'];
};


export type MutationCreateHashtagsArgs = {
  update?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateHitGenerationArgs = {
  campaignId: Scalars['Int'];
  count: Scalars['Int'];
  hitsId: Scalars['String'];
};


export type MutationCreateInstagramAutomationToolArgs = {
  accountId: Scalars['Int'];
  commentReply: Array<Scalars['String']>;
  keyword: Scalars['String'];
  message: Array<Scalars['String']>;
  platform?: InputMaybe<Platform>;
  post_id?: InputMaybe<Scalars['String']>;
  shouldReply: Scalars['Boolean'];
  title: Scalars['String'];
};


export type MutationCreateInstagramInsightsArgs = {
  accountId: Scalars['Int'];
};


export type MutationCreateListeningTopicArgs = {
  input: CreateListeningTopicInput;
};


export type MutationCreateSubscriptionArgs = {
  customer_id: Scalars['String'];
  endDate: Scalars['String'];
  planId: Scalars['String'];
  productId: Scalars['String'];
  productName: Scalars['String'];
  session_id: Scalars['String'];
  subscriptionId: Scalars['String'];
};


export type MutationCreateTargetCreatorsArgs = {
  creators: Array<Scalars['String']>;
};


export type MutationCreateVibesArgs = {
  data: Scalars['String'];
};


export type MutationCreateWeeklyContextArgs = {
  context: WeeklyContextInput;
};


export type MutationDeleteInstagramToolArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteListeningTopicArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserAccountArgs = {
  deleteUserRecord?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationDismissInsightArgs = {
  insightId: Scalars['String'];
};


export type MutationEditInstagramToolArgs = {
  data: EditInstagramToolObject;
  id: Scalars['Int'];
};


export type MutationEnableFollowerTrackingArgs = {
  retentionDays?: InputMaybe<Scalars['Int']>;
  snapshotFrequency?: InputMaybe<Scalars['Int']>;
};


export type MutationExploreAudienceArgs = {
  authorUsername: Scalars['String'];
};


export type MutationFacebookAddUserAccessKeyArgs = {
  key: Scalars['String'];
};


export type MutationFacebookEditArgs = {
  hitId: Scalars['ID'];
};


export type MutationFacebookReactArgs = {
  reaction: Scalars['String'];
};


export type MutationFacebookReplyArgs = {
  postId: Scalars['ID'];
};


export type MutationFetchFollowerDetailsArgs = {
  usernames: Array<Scalars['String']>;
};


export type MutationFetchSimilarAccountsArgs = {
  username: Scalars['String'];
};


export type MutationFetchUserPostsArgs = {
  username: Scalars['String'];
};


export type MutationGenerateCommentsSummaryArgs = {
  commentCount: Scalars['Int'];
  username: Scalars['String'];
};


export type MutationGenerateGuestPitchArgs = {
  authorUsername: Scalars['String'];
  podcastDescription: Scalars['String'];
  podcastName: Scalars['String'];
};


export type MutationGenerateProfileSummaryArgs = {
  stats: FollowerStatsInput;
  username: Scalars['String'];
};


export type MutationGetBrandValuesArgs = {
  accountId: Scalars['Int'];
};


export type MutationHideTopicContentArgs = {
  contentId: Scalars['ID'];
};


export type MutationHitMarkUnhelpfulArgs = {
  id: Scalars['ID'];
};


export type MutationInstagramAddUserAccessKeyArgs = {
  key: Scalars['String'];
};


export type MutationInstagramEditArgs = {
  hitId: Scalars['ID'];
};


export type MutationInstagramReactArgs = {
  reaction: Scalars['String'];
};


export type MutationInstagramReplyArgs = {
  postId: Scalars['ID'];
};


export type MutationInteractedWithHitArgs = {
  campaignId: Scalars['ID'];
  hitId: Scalars['String'];
};


export type MutationMarkTopicContentInteractedArgs = {
  contentId: Scalars['ID'];
};


export type MutationMembershipChangeArgs = {
  id: Scalars['ID'];
};


export type MutationNotificationMarkSeenArgs = {
  id: Scalars['ID'];
};


export type MutationPublishFacebookArgs = {
  accountId: Scalars['Int'];
  caption: Scalars['String'];
  isVideo: Scalars['Boolean'];
  mediaURL: Scalars['String'];
  published: Scalars['Boolean'];
  scheduledDate?: InputMaybe<Scalars['String']>;
};


export type MutationPublishInstagramArgs = {
  accountId: Scalars['Int'];
  caption?: InputMaybe<Scalars['String']>;
  mediaURLs: Array<Scalars['String']>;
  postType: PostType;
};


export type MutationPublishTikTokArgs = {
  accountId: Scalars['Int'];
  allow_comments: Scalars['Boolean'];
  allow_duet: Scalars['Boolean'];
  allow_stitch: Scalars['Boolean'];
  brand_content: Scalars['Boolean'];
  brand_organic: Scalars['Boolean'];
  caption?: InputMaybe<Scalars['String']>;
  mediaURL: Scalars['String'];
  privacy_level: Scalars['String'];
};


export type MutationRecordSuperFanActionArgs = {
  actionDescription?: InputMaybe<Scalars['String']>;
  actionType: Scalars['String'];
  actionValue: Scalars['Int'];
  followerMetricsId: Scalars['ID'];
  relatedPostId?: InputMaybe<Scalars['String']>;
  relatedPostUrl?: InputMaybe<Scalars['String']>;
};


export type MutationRedditAddUserAccessKeyArgs = {
  key: Scalars['String'];
};


export type MutationRedditEditArgs = {
  hitId: Scalars['ID'];
};


export type MutationRedditReactArgs = {
  reaction: Scalars['String'];
};


export type MutationRedditReplyArgs = {
  postId: Scalars['ID'];
};


export type MutationRefreshAllCompetitorsArgs = {
  configId: Scalars['String'];
};


export type MutationRefreshCompetitorArgs = {
  accountId: Scalars['String'];
};


export type MutationRefreshListeningTopicArgs = {
  id: Scalars['ID'];
};


export type MutationRefreshTargetCreatorsArgs = {
  creators: Array<Scalars['String']>;
};


export type MutationRefreshTargetFollowersArgs = {
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationRemoveAccountFromFollowerTrackingArgs = {
  accountId: Scalars['String'];
};


export type MutationRemoveCompetitorArgs = {
  accountId: Scalars['String'];
};


export type MutationRemoveMediaAccountArgs = {
  accountId: Scalars['Int'];
};


export type MutationRemoveYouTubeApiKeyArgs = {
  mediaAccountId: Scalars['Int'];
};


export type MutationSaveContentCommentArgs = {
  comment: Scalars['String'];
  contentId: Scalars['ID'];
};


export type MutationSaveYouTubeApiKeyArgs = {
  apiKey: Scalars['String'];
  mediaAccountId: Scalars['Int'];
};


export type MutationSchedulePostArgs = {
  allow_comments?: InputMaybe<Scalars['Boolean']>;
  allow_duet?: InputMaybe<Scalars['Boolean']>;
  allow_stitch?: InputMaybe<Scalars['Boolean']>;
  brand_content?: InputMaybe<Scalars['Boolean']>;
  brand_organic?: InputMaybe<Scalars['Boolean']>;
  caption?: InputMaybe<Scalars['String']>;
  imageMediaURL: Array<InputMaybe<Scalars['String']>>;
  mediaAccountId: Scalars['Int'];
  platform: Platform;
  postDate: Scalars['String'];
  postType: PostType;
  privacy_level?: InputMaybe<Scalars['String']>;
  videoMediaURL: Array<InputMaybe<Scalars['String']>>;
};


export type MutationToggleCompetitorActiveArgs = {
  accountId: Scalars['String'];
};


export type MutationTwitterAddUserAccessKeyArgs = {
  key: Scalars['String'];
};


export type MutationTwitterEditArgs = {
  hitId: Scalars['ID'];
};


export type MutationTwitterReactArgs = {
  reaction: Scalars['String'];
};


export type MutationTwitterReplyArgs = {
  postId: Scalars['ID'];
};


export type MutationUpdateCampaignResultsArgs = {
  maxHits: Scalars['Int'];
  platforms: Array<Platform>;
  queryTree: Scalars['String'];
  searchRequiermentID: Scalars['Int'];
};


export type MutationUpdateGuestStatusArgs = {
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};


export type MutationUpdateListeningTopicArgs = {
  input: UpdateListeningTopicInput;
};


export type MutationUpdateSubscriptionArgs = {
  endDate: Scalars['String'];
  subscriptionId: Scalars['String'];
  type: Scalars['String'];
};


export type MutationValidateAccountConnectionArgs = {
  accountId: Scalars['Int'];
};


export type MutationYoutubeAddUserAccessKeyArgs = {
  key: Scalars['String'];
};


export type MutationYoutubeEditArgs = {
  hitId: Scalars['ID'];
};


export type MutationYoutubeReactArgs = {
  reaction: Scalars['String'];
};


export type MutationYoutubeReplyArgs = {
  postId: Scalars['ID'];
};

export type NicheBrowseInput = {
  limit?: InputMaybe<Scalars['Int']>;
  nicheCategoryId: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<Platform>;
  sortBy?: InputMaybe<NicheSortBy>;
};

export type NicheBrowseResult = {
  __typename?: 'NicheBrowseResult';
  content: Array<NicheContent>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type NicheCategory = {
  __typename?: 'NicheCategory';
  contentCount: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  iconEmoji?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  slug: Scalars['String'];
};

export type NicheContent = {
  __typename?: 'NicheContent';
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName?: Maybe<Scalars['String']>;
  authorFollowerCount?: Maybe<Scalars['Int']>;
  authorUsername: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  comments: Scalars['Int'];
  contentId: Scalars['String'];
  contentType: Scalars['String'];
  contentUrl: Scalars['String'];
  hashtags: Array<Scalars['String']>;
  id: Scalars['ID'];
  interactedWith?: Maybe<Scalars['Boolean']>;
  likes: Scalars['Int'];
  mentions: Array<Scalars['String']>;
  nicheCategoryId?: Maybe<Scalars['String']>;
  platform: Platform;
  postedAt: Scalars['String'];
  preGeneratedComment?: Maybe<Scalars['String']>;
  relevanceScore?: Maybe<Scalars['Float']>;
  saves?: Maybe<Scalars['Int']>;
  scrapedAt: Scalars['String'];
  shares: Scalars['Int'];
  similarity?: Maybe<Scalars['Float']>;
  summary?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  views?: Maybe<Scalars['Int']>;
};

export type NicheSearchInput = {
  limit?: InputMaybe<Scalars['Int']>;
  minSimilarity?: InputMaybe<Scalars['Float']>;
  nicheCategoryId: Scalars['String'];
  platform?: InputMaybe<Platform>;
  query: Scalars['String'];
};

export type NicheSearchResult = {
  __typename?: 'NicheSearchResult';
  content: Array<NicheContent>;
  hasMore: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export enum NicheSortBy {
  Engagement = 'engagement',
  Popular = 'popular',
  Recent = 'recent'
}

export type Notification = {
  __typename?: 'Notification';
  body: Scalars['String'];
  id: Scalars['ID'];
  seen: Scalars['Boolean'];
};

export enum OauthPlatform {
  Instagram = 'Instagram',
  Reddit = 'Reddit',
  TikTok = 'TikTok',
  Youtube = 'Youtube'
}

export type Pagination = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};

export enum Platform {
  Bluesky = 'Bluesky',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Reddit = 'Reddit',
  TikTok = 'TikTok',
  Twitter = 'Twitter',
  Youtube = 'Youtube'
}

export type PlatformEngagementMetrics = {
  __typename?: 'PlatformEngagementMetrics';
  avgEngagement: Scalars['Float'];
  platform: Platform;
  totalComments: Scalars['Int'];
  totalLikes: Scalars['Int'];
  totalPosts: Scalars['Int'];
  totalShares: Scalars['Int'];
  totalViews: Scalars['Int'];
};

export type PlatformMetrics = {
  __typename?: 'PlatformMetrics';
  avgEngagement: Scalars['Float'];
  platform: Platform;
  totalComments: Scalars['Int'];
  totalHits: Scalars['Int'];
  totalLikes: Scalars['Int'];
  totalShares: Scalars['Int'];
};

export type PlatformStat = {
  __typename?: 'PlatformStat';
  count: Scalars['Int'];
  percentage: Scalars['Float'];
  platform: Scalars['String'];
};

export type Post = {
  __typename?: 'Post';
  accountName: Scalars['String'];
  caption: Scalars['String'];
  id: Scalars['Int'];
  imageMediaURLs: Array<Maybe<Scalars['String']>>;
  platform: Platform;
  postDate: Scalars['String'];
  postType: PostType;
  videoMediaURLs: Array<Maybe<Scalars['String']>>;
};

export type PostCaption = {
  __typename?: 'PostCaption';
  hashtags?: Maybe<Array<Scalars['String']>>;
  text?: Maybe<Scalars['String']>;
};

export type PostEngagement = {
  __typename?: 'PostEngagement';
  caption?: Maybe<Scalars['String']>;
  comments: Scalars['Int'];
  id: Scalars['Int'];
  lastSynced: Scalars['String'];
  likes: Scalars['Int'];
  platform: Platform;
  postId: Scalars['String'];
  postUrl?: Maybe<Scalars['String']>;
  postedAt: Scalars['String'];
  shares: Scalars['Int'];
  thumbnailUrl?: Maybe<Scalars['String']>;
  views: Scalars['Int'];
};

export enum PostType {
  Carousel = 'Carousel',
  Image = 'Image',
  Video = 'Video'
}

export type Query = {
  __typename?: 'Query';
  brandValue?: Maybe<BrandValue>;
  browseNicheContent: NicheBrowseResult;
  campaigns: Array<Campaign>;
  generateTopicKeywords: GeneratedKeywords;
  getActiveWeeklyContext?: Maybe<WeeklyContext>;
  getAllVibes: Array<Scalars['String']>;
  getAudienceInsights: AudienceInsights;
  getBulkGenerateSummaryVibe?: Maybe<Scalars['String']>;
  getChatHistory: Array<ChatMessage>;
  getCompetitorAccount?: Maybe<CompetitorAccount>;
  getCompetitorContent?: Maybe<Array<CompetitorContent>>;
  getCompetitorDashboard?: Maybe<CompetitorDashboard>;
  getCompetitorHistory?: Maybe<Array<CompetitorSnapshot>>;
  getCompetitorInsights?: Maybe<Array<CompetitorInsight>>;
  getCreatorPosts: Array<NicheContent>;
  getCreators: TargetCreators;
  getDashboardMetrics: DashboardMetrics;
  getEngagementStats: EngagementStats;
  getEngagementTimeSeries: EngagementTimeSeries;
  getEpisodePerformance: Array<EpisodePerformance>;
  getFollowerAnalytics: FollowerAnalytics;
  getFollowerStats: Array<AccountFollowerStats>;
  getHashtags: GetHashtagsResponse;
  getHitsVolume: DashboardHitsVolumeReturn;
  getInstagramInsights?: Maybe<InstagramInsights>;
  getInstagramTools: Array<InstagramToolsResponse>;
  getListeningTopic?: Maybe<ListeningTopic>;
  getListeningTopicFeed: ListeningTopicFeedResult;
  getListeningTopics: Array<ListeningTopic>;
  getNews: GetNewsResponse;
  getNicheCategories: Array<NicheCategory>;
  getNicheCategory?: Maybe<NicheCategory>;
  getPostEngagement: Array<PostEngagement>;
  getSubscription?: Maybe<Subscription>;
  getSuggestedProfiles: SuggestedProfilesResult;
  getSuperFan?: Maybe<SuperFan>;
  getSuperFanBreakdown: Array<SuperFanBreakdown>;
  getSuperFanStats: SuperFanStats;
  getSuperFans: Array<SuperFan>;
  getTargetFollowers?: Maybe<TargetFollowers>;
  getTargetFollowersResults: Array<Maybe<TargetCreatorsInfo>>;
  getUserEngagementMetrics: UserEngagementMetrics;
  getUserMedia: Array<Maybe<UserMediaResponse>>;
  getVibes: Array<Vibe>;
  getWeeklyContextHistory: Array<WeeklyContext>;
  getWeeklyContextStatus: WeeklyContextStatus;
  getYouTubeQuotaUsage?: Maybe<YouTubeQuotaUsage>;
  globalNicheSearch: NicheSearchResult;
  hits: FlatHitsResult;
  mediaAccounts: Array<MediaAccounts>;
  notifications: Array<Notification>;
  oauth: Connect;
  platforms: Array<Platform>;
  refreshContentInfo?: Maybe<RefreshContentInfo>;
  respond: Scalars['String'];
  scraping: Loading;
  searchNicheContent: NicheSearchResult;
  user?: Maybe<User>;
  userPosts: AllPosts;
};


export type QueryBrandValueArgs = {
  platform: Platform;
};


export type QueryBrowseNicheContentArgs = {
  input: NicheBrowseInput;
};


export type QueryCampaignsArgs = {
  filter?: InputMaybe<CampaignFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


export type QueryGenerateTopicKeywordsArgs = {
  description: Scalars['String'];
  platforms: Array<Platform>;
};


export type QueryGetBulkGenerateSummaryVibeArgs = {
  campaignId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetChatHistoryArgs = {
  sessionId: Scalars['String'];
};


export type QueryGetCompetitorAccountArgs = {
  accountId: Scalars['String'];
};


export type QueryGetCompetitorContentArgs = {
  accountId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryGetCompetitorDashboardArgs = {
  campaignId: Scalars['String'];
};


export type QueryGetCompetitorHistoryArgs = {
  accountId: Scalars['String'];
  days?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCompetitorInsightsArgs = {
  configId: Scalars['String'];
  priority?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryGetCreatorPostsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  username: Scalars['String'];
};


export type QueryGetEngagementTimeSeriesArgs = {
  granularity: TimeSeriesGranularity;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryGetFollowerAnalyticsArgs = {
  timeRange: Scalars['String'];
};


export type QueryGetInstagramToolsArgs = {
  platform?: InputMaybe<Platform>;
};


export type QueryGetListeningTopicArgs = {
  id: Scalars['ID'];
};


export type QueryGetListeningTopicFeedArgs = {
  input: ListeningTopicFeedInput;
};


export type QueryGetNicheCategoryArgs = {
  slug: Scalars['String'];
};


export type QueryGetPostEngagementArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<Platform>;
};


export type QueryGetSuggestedProfilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  topicId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetSuperFanArgs = {
  id: Scalars['ID'];
};


export type QueryGetSuperFanStatsArgs = {
  mediaAccountId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetSuperFansArgs = {
  filters?: InputMaybe<SuperFanFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  mediaAccountId?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetUserMediaArgs = {
  accountId: Scalars['Int'];
  platform: Platform;
};


export type QueryGetVibesArgs = {
  campaignId: Scalars['Int'];
};


export type QueryGetWeeklyContextHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryGetYouTubeQuotaUsageArgs = {
  mediaAccountId: Scalars['Int'];
};


export type QueryGlobalNicheSearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  platforms?: InputMaybe<Array<Platform>>;
  query: Scalars['String'];
};


export type QueryHitsArgs = {
  filter: HitFilter;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


export type QueryMediaAccountsArgs = {
  platform?: InputMaybe<Platform>;
};


export type QueryNotificationsArgs = {
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


export type QueryOauthArgs = {
  code: Scalars['String'];
  platform: OauthPlatform;
};


export type QueryPlatformsArgs = {
  id: Scalars['Int'];
};


export type QueryRefreshContentInfoArgs = {
  id: Scalars['Int'];
};


export type QueryRespondArgs = {
  content?: InputMaybe<Scalars['String']>;
  platform: Platform;
  videoId?: InputMaybe<Scalars['String']>;
};


export type QueryScrapingArgs = {
  filter: ScrapingFilter;
};


export type QuerySearchNicheContentArgs = {
  input: NicheSearchInput;
};

export type RefreshContentInfo = {
  __typename?: 'RefreshContentInfo';
  creationDate?: Maybe<Scalars['String']>;
  maxHits?: Maybe<Scalars['Int']>;
  queryTree?: Maybe<Scalars['String']>;
};

export type ScrapingFilter = {
  campaignId: Scalars['Int'];
};

export type SimilarAccount = {
  __typename?: 'SimilarAccount';
  follower_count?: Maybe<Scalars['Int']>;
  profile_pic_url?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

export type Sort = {
  date?: InputMaybe<SortOrder>;
  interactions?: InputMaybe<SortOrder>;
};

export enum SortOrder {
  Asc = 'ASC',
  Default = 'DEFAULT',
  Desc = 'DESC'
}

export type Subscription = {
  __typename?: 'Subscription';
  canAccessAnalytics?: Maybe<Scalars['Boolean']>;
  canUseAdvancedFeatures?: Maybe<Scalars['Boolean']>;
  customerId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  planDisplayName?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  status?: Maybe<SubscriptionStatus>;
  stripeCheckoutSessionId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Free = 'FREE'
}

export type SuggestedProfile = {
  __typename?: 'SuggestedProfile';
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName?: Maybe<Scalars['String']>;
  authorUsername: Scalars['String'];
  avgComments: Scalars['Int'];
  avgLikes: Scalars['Int'];
  commentFrequency?: Maybe<Scalars['Int']>;
  discoveredVia?: Maybe<Scalars['String']>;
  engagementRate?: Maybe<Scalars['Float']>;
  followerCount?: Maybe<Scalars['Int']>;
  guestNotes?: Maybe<Scalars['String']>;
  guestStatus?: Maybe<Scalars['String']>;
  isGuestCandidate?: Maybe<Scalars['Boolean']>;
  lastEngagedAt?: Maybe<Scalars['String']>;
  lastPostedAt?: Maybe<Scalars['String']>;
  latestContentUrl?: Maybe<Scalars['String']>;
  postCount: Scalars['Int'];
  primaryPlatform?: Maybe<Scalars['String']>;
  profileScore: Scalars['Float'];
  timesEngaged: Scalars['Int'];
  topicAppearances: Scalars['Int'];
  topicNames?: Maybe<Array<Scalars['String']>>;
  totalComments: Scalars['Int'];
  totalLikes: Scalars['Int'];
};

export type SuggestedProfilesResult = {
  __typename?: 'SuggestedProfilesResult';
  profiles: Array<SuggestedProfile>;
  totalCount: Scalars['Int'];
};

export type SuperFan = {
  __typename?: 'SuperFan';
  consistencyScore: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  daysSinceFirst: Scalars['Int'];
  depthScore: Scalars['Float'];
  firstInteraction?: Maybe<Scalars['DateTime']>;
  followerAvatarUrl?: Maybe<Scalars['String']>;
  followerDisplayName?: Maybe<Scalars['String']>;
  followerPlatformId: Scalars['String'];
  followerUsername: Scalars['String'];
  hasSpecialActions: Scalars['Boolean'];
  id: Scalars['ID'];
  lastCalculated: Scalars['DateTime'];
  lastInteraction?: Maybe<Scalars['DateTime']>;
  mediaAccountId: Scalars['Int'];
  overallScore: Scalars['Float'];
  platform: Platform;
  postsCommented: Scalars['Int'];
  postsLiked: Scalars['Int'];
  postsSaved: Scalars['Int'];
  postsShared: Scalars['Int'];
  recencyScore: Scalars['Float'];
  specialActions: Array<SuperFanAction>;
  tier: SuperFanTier;
  totalComments: Scalars['Int'];
  totalLikes: Scalars['Int'];
  totalSaves: Scalars['Int'];
  totalShares: Scalars['Int'];
  userId: Scalars['String'];
};

export type SuperFanAction = {
  __typename?: 'SuperFanAction';
  actionDescription?: Maybe<Scalars['String']>;
  actionType: Scalars['String'];
  actionValue: Scalars['Int'];
  detectedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  relatedPostId?: Maybe<Scalars['String']>;
  relatedPostUrl?: Maybe<Scalars['String']>;
};

export type SuperFanBreakdown = {
  __typename?: 'SuperFanBreakdown';
  activeFans: Scalars['Int'];
  avgScore: Scalars['Float'];
  megaFans: Scalars['Int'];
  platform: Platform;
  superFans: Scalars['Int'];
  totalFans: Scalars['Int'];
};

export type SuperFanFilters = {
  hasSpecialActions?: InputMaybe<Scalars['Boolean']>;
  minScore?: InputMaybe<Scalars['Float']>;
  platform?: InputMaybe<Platform>;
  tier?: InputMaybe<SuperFanTier>;
};

export type SuperFanStats = {
  __typename?: 'SuperFanStats';
  activeFans: Scalars['Int'];
  avgConsistencyScore: Scalars['Float'];
  avgDepthScore: Scalars['Float'];
  avgRecencyScore: Scalars['Float'];
  casualFans: Scalars['Int'];
  megaFans: Scalars['Int'];
  superFans: Scalars['Int'];
  topSuperFans: Array<SuperFan>;
  totalSuperFans: Scalars['Int'];
};

export enum SuperFanTier {
  ActiveFan = 'ACTIVE_FAN',
  CasualFan = 'CASUAL_FAN',
  MegaFan = 'MEGA_FAN',
  SuperFan = 'SUPER_FAN'
}

export type SyncFollowerTrackingResult = {
  __typename?: 'SyncFollowerTrackingResult';
  added: Array<Scalars['String']>;
  message: Scalars['String'];
  removed: Array<Scalars['String']>;
  unchanged: Array<Scalars['String']>;
};

export type SyncPostEngagementResult = {
  __typename?: 'SyncPostEngagementResult';
  accountName: Scalars['String'];
  lastSynced: Scalars['String'];
  platform: Platform;
  postsSynced: Scalars['Int'];
};

export type TargetCreators = {
  __typename?: 'TargetCreators';
  createdAt?: Maybe<Scalars['String']>;
  creators: Array<Scalars['String']>;
  info: Array<Maybe<TargetCreatorsInfo>>;
};

export type TargetCreatorsInfo = {
  __typename?: 'TargetCreatorsInfo';
  TargetCreatorsId?: Maybe<Scalars['Int']>;
  avatarUrl?: Maybe<Scalars['String']>;
  commentsCount?: Maybe<Scalars['Int']>;
  followersCount?: Maybe<Scalars['Int']>;
  hashtags: Array<Maybe<Scalars['String']>>;
  id?: Maybe<Scalars['Int']>;
  likesCount?: Maybe<Scalars['Int']>;
  relatedProfiles: Array<Maybe<Scalars['String']>>;
  resultDate?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  taggedUsers: Array<Maybe<Scalars['String']>>;
  username?: Maybe<Scalars['String']>;
};

export type TargetFollowers = {
  __typename?: 'TargetFollowers';
  accountName: Scalars['String'];
  account_id: Scalars['Int'];
  activeFollowers: Array<Maybe<FollowersObject>>;
  avatarUrl: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isProcessing: Scalars['Boolean'];
  popularFollowers: Array<Maybe<FollowersObject>>;
  processingStatus: Scalars['String'];
  progress: Scalars['Int'];
  resultsDate: Scalars['String'];
  similarFollowers: Array<FollowersObject>;
};

export enum TimeSeriesGranularity {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum ToolStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type TrendingHashtag = {
  __typename?: 'TrendingHashtag';
  metrics: HashtagMetrics;
  tag: Scalars['String'];
};

export type TrendingHashtagsResponse = {
  __typename?: 'TrendingHashtagsResponse';
  facebook: Array<TrendingHashtag>;
  instagram: Array<Maybe<TrendingHashtag>>;
  reddit: Array<TrendingHashtag>;
  tiktok: Array<Maybe<TrendingHashtag>>;
  youtube: Array<Maybe<TrendingHashtag>>;
};

export type UpdateListeningTopicInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  maxFollowers?: InputMaybe<Scalars['Int']>;
  minFollowers?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  platforms?: InputMaybe<Array<Platform>>;
  seedKeywords?: InputMaybe<Scalars['JSON']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  id: Scalars['ID'];
  info?: Maybe<UserInfo>;
  name?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  usage?: Maybe<UserUsage>;
  username: Scalars['String'];
};

export type UserAccountSelectionInput = {
  accountId: Scalars['Int'];
  platform: Platform;
};

export type UserConnectedAccount = {
  __typename?: 'UserConnectedAccount';
  avatarUrl?: Maybe<Scalars['String']>;
  connectedAt?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  platform: Platform;
  username: Scalars['String'];
};

export type UserEngagementMetrics = {
  __typename?: 'UserEngagementMetrics';
  avgCommentsPerPost: Scalars['Float'];
  avgEngagementPerPost: Scalars['Float'];
  avgLikesPerPost: Scalars['Float'];
  platformBreakdown: Array<PlatformEngagementMetrics>;
  recentPosts: Array<PostEngagement>;
  totalComments: Scalars['Int'];
  totalLikes: Scalars['Int'];
  totalPosts: Scalars['Int'];
  totalShares: Scalars['Int'];
  totalViews: Scalars['Int'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  customerId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
};

export type UserMediaResponse = {
  __typename?: 'UserMediaResponse';
  caption: Scalars['String'];
  id: Scalars['String'];
  media_type: Scalars['String'];
  media_url: Scalars['String'];
  timestamp: Scalars['String'];
};

export type UserMutation = {
  __typename?: 'UserMutation';
  changeEmail: User;
  changeImage: User;
  changePassword: User;
};


export type UserMutationChangeEmailArgs = {
  id: Scalars['ID'];
};


export type UserMutationChangeImageArgs = {
  id: Scalars['ID'];
};


export type UserMutationChangePasswordArgs = {
  id: Scalars['ID'];
};

export type UserPerformance = {
  __typename?: 'UserPerformance';
  engagementRate: Scalars['Float'];
  followers: Scalars['Int'];
  percentile: Scalars['Float'];
  postFrequency: Scalars['Float'];
  rankVsCompetitors: Scalars['Int'];
};

export type UserUsage = {
  __typename?: 'UserUsage';
  aiCreditsRemaining: Scalars['Int'];
  aiCreditsUsed: Scalars['Int'];
  currentMonth: Scalars['String'];
  itemsCreated: Scalars['Int'];
  itemsRemaining: Scalars['Int'];
  maxAICreditsPerMonth: Scalars['Int'];
  maxItemsPerMonth: Scalars['Int'];
};

export type Vibe = {
  __typename?: 'Vibe';
  comment: Scalars['String'];
  id: Scalars['String'];
};

export type WeeklyContext = {
  __typename?: 'WeeklyContext';
  context: Scalars['JSON'];
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  updatedAt: Scalars['String'];
  weekStart: Scalars['String'];
};

export type WeeklyContextInput = {
  activities?: InputMaybe<Array<Scalars['String']>>;
  books?: InputMaybe<Array<Scalars['String']>>;
  freeform?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<Scalars['String']>>;
  topics?: InputMaybe<Array<Scalars['String']>>;
};

export type WeeklyContextStatus = {
  __typename?: 'WeeklyContextStatus';
  currentContext?: Maybe<WeeklyContext>;
  hasCurrentWeek: Scalars['Boolean'];
  lastUpdated?: Maybe<Scalars['String']>;
};

export type YouTubeApiKeyResult = {
  __typename?: 'YouTubeApiKeyResult';
  hasApiKey: Scalars['Boolean'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type YouTubeQuotaUsage = {
  __typename?: 'YouTubeQuotaUsage';
  limit: Scalars['Int'];
  percentage: Scalars['Float'];
  used: Scalars['Int'];
};

export type GetHashtagsResponse = {
  __typename?: 'getHashtagsResponse';
  createdAt?: Maybe<Scalars['String']>;
  trends?: Maybe<TrendingHashtagsResponse>;
};

export type GetNewsResponse = {
  __typename?: 'getNewsResponse';
  news: Array<Maybe<NewsFormat>>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type NewsFormat = {
  __typename?: 'newsFormat';
  article_id: Scalars['String'];
  link: Scalars['String'];
  pubDate: Scalars['String'];
  source_id: Scalars['String'];
  title: Scalars['String'];
};

export type GetCampaignsQueryVariables = Exact<{
  filter?: InputMaybe<CampaignFilter>;
}>;


export type GetCampaignsQuery = { __typename?: 'Query', campaigns: Array<{ __typename?: 'Campaign', id: string, name: string, keywords: Array<string>, createdAt: number, hitsCount: number, platforms: Array<Platform>, type?: CampaignType | null }> };

export type GetRefreshContentInfoQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetRefreshContentInfoQuery = { __typename?: 'Query', refreshContentInfo?: { __typename?: 'RefreshContentInfo', queryTree?: string | null, creationDate?: string | null, maxHits?: number | null } | null };

export type GetPlatformsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPlatformsQuery = { __typename?: 'Query', platforms: Array<Platform> };

export type GetCompetitorDashboardQueryVariables = Exact<{
  campaignId: Scalars['String'];
}>;


export type GetCompetitorDashboardQuery = { __typename?: 'Query', getCompetitorDashboard?: { __typename?: 'CompetitorDashboard', config: { __typename?: 'CompetitorCampaignConfig', id: string, autoRefreshEnabled: boolean, autoRefreshInterval: number, lastRefreshed: string }, competitors: Array<{ __typename?: 'CompetitorAccount', id: string, username: string, platform: Platform, displayName?: string | null, avatarUrl?: string | null, accountUrl: string, isActive: boolean, latestMetrics?: { __typename?: 'CompetitorSnapshot', followers: number, engagementRate: number, postFrequency: number, followersGrowth: number } | null, growthTrend: { __typename?: 'GrowthTrend', direction: string, percentage: number, timeframe: string } }>, insights: Array<{ __typename?: 'CompetitorInsight', id: string, insightType: string, title: string, description: string, priority: string, recommendations: Array<string>, generatedAt: string }>, aggregateMetrics: { __typename?: 'AggregateMetrics', totalCompetitors: number, avgFollowers: number, avgEngagementRate: number, avgPostFrequency: number, hashtagTrends: Array<{ __typename?: 'HashtagTrend', hashtag: string, count: number, trend: string }> }, topSavedContent?: Array<{ __typename?: 'CompetitorContent', id: string, contentId: string, caption?: string | null, thumbnailUrl?: string | null, likes: number, comments: number, shares: number, saves?: number | null, fbLikeCount?: number | null, postedAt: string }> | null, topSharedContent?: Array<{ __typename?: 'CompetitorContent', id: string, contentId: string, caption?: string | null, thumbnailUrl?: string | null, likes: number, comments: number, shares: number, saves?: number | null, fbLikeCount?: number | null, postedAt: string }> | null, yourPerformance?: { __typename?: 'UserPerformance', followers: number, engagementRate: number, postFrequency: number, rankVsCompetitors: number, percentile: number } | null, userAccounts: Array<{ __typename?: 'MediaAccountInfo', id: number, platform: Platform, accountName: string }> } | null };

export type GetCompetitorInsightsQueryVariables = Exact<{
  configId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['String']>;
}>;


export type GetCompetitorInsightsQuery = { __typename?: 'Query', getCompetitorInsights?: Array<{ __typename?: 'CompetitorInsight', id: string, insightType: string, title: string, description: string, priority: string, recommendations: Array<string>, generatedAt: string }> | null };

export type GetCompetitorContentQueryVariables = Exact<{
  accountId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type GetCompetitorContentQuery = { __typename?: 'Query', getCompetitorContent?: Array<{ __typename?: 'CompetitorContent', id: string, platform: Platform, contentId: string, contentType: string, caption?: string | null, contentUrl: string, thumbnailUrl?: string | null, likes: number, comments: number, shares: number, views?: number | null, saves?: number | null, hashtags: Array<string>, mentions: Array<string>, contentThemes: Array<string>, engagementRate: number, isTopPerformer: boolean, performanceScore: number, postedAt: string, fbLikeCount?: number | null, fbPlayCount?: number | null, videoDuration?: number | null, hasAudio?: boolean | null }> | null };

export type CreateCampaignMutationVariables = Exact<{
  name: Scalars['String'];
  hitsPerDay: Scalars['Int'];
  platforms: Array<Platform> | Platform;
  queryTree?: InputMaybe<Scalars['String']>;
  similarSearching?: InputMaybe<Scalars['Boolean']>;
  followersInfo: FollowersFilterInfo;
  campaignType?: InputMaybe<CampaignType>;
  competitorConfig?: InputMaybe<CompetitorConfigInput>;
  competitorAccounts?: InputMaybe<Array<CompetitorAccountInput> | CompetitorAccountInput>;
  userAccounts?: InputMaybe<Array<UserAccountSelectionInput> | UserAccountSelectionInput>;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', campaignCreate: { __typename?: 'Campaign', id: string, name: string, keywords: Array<string>, platforms: Array<Platform>, type?: CampaignType | null } };

export type CampaignDeleteMutationVariables = Exact<{
  campaignDeleteId: Scalars['ID'];
}>;


export type CampaignDeleteMutation = { __typename?: 'Mutation', campaignDelete: boolean };

export type UpdateCampaignResultsMutationVariables = Exact<{
  platforms: Array<Platform> | Platform;
  queryTree: Scalars['String'];
  searchRequiermentID: Scalars['Int'];
  maxHits: Scalars['Int'];
}>;


export type UpdateCampaignResultsMutation = { __typename?: 'Mutation', updateCampaignResults: boolean };

export type InteractedWithHitMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  hitId: Scalars['String'];
}>;


export type InteractedWithHitMutation = { __typename?: 'Mutation', interactedWithHit: boolean };

export type ArchiveHitMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  hitId: Scalars['String'];
}>;


export type ArchiveHitMutation = { __typename?: 'Mutation', archiveHit: boolean };

export type AddCompetitorMutationVariables = Exact<{
  configId: Scalars['String'];
  platform: Platform;
  username: Scalars['String'];
}>;


export type AddCompetitorMutation = { __typename?: 'Mutation', addCompetitor?: { __typename?: 'CompetitorAccount', id: string, username: string, platform: Platform, displayName?: string | null, avatarUrl?: string | null, isActive: boolean } | null };

export type RemoveCompetitorMutationVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type RemoveCompetitorMutation = { __typename?: 'Mutation', removeCompetitor: boolean };

export type RefreshCompetitorMutationVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type RefreshCompetitorMutation = { __typename?: 'Mutation', refreshCompetitor?: { __typename?: 'CompetitorAccount', id: string, username: string, lastScraped: string } | null };

export type RefreshAllCompetitorsMutationVariables = Exact<{
  configId: Scalars['String'];
}>;


export type RefreshAllCompetitorsMutation = { __typename?: 'Mutation', refreshAllCompetitors: boolean };

export type DismissInsightMutationVariables = Exact<{
  insightId: Scalars['String'];
}>;


export type DismissInsightMutation = { __typename?: 'Mutation', dismissInsight: boolean };

export type ToggleCompetitorActiveMutationVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type ToggleCompetitorActiveMutation = { __typename?: 'Mutation', toggleCompetitorActive?: { __typename?: 'CompetitorAccount', id: string, isActive: boolean } | null };

export type GetChatHistoryQueryVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type GetChatHistoryQuery = { __typename?: 'Query', getChatHistory: Array<{ __typename?: 'ChatMessage', role: string, content: string }> };

export type ChatMutationVariables = Exact<{
  input: ChatInput;
}>;


export type ChatMutation = { __typename?: 'Mutation', chat: { __typename?: 'ChatResponse', sessionId: string, response: string, canCreateCampaign: boolean, extractedData: { __typename?: 'CampaignExtractedData', name?: string | null, keywords?: Array<string> | null, platforms?: Array<string> | null, maxHits?: number | null, similarSearching?: boolean | null, isComplete?: boolean | null, followersInfo?: { __typename?: 'FollowersFilterOutput', operator: string, from: number, to: number } | null } } };

export type CreateCampaignFromChatMutationVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type CreateCampaignFromChatMutation = { __typename?: 'Mutation', createCampaignFromChat: { __typename?: 'Campaign', id: string, name: string, keywords: Array<string>, platforms: Array<Platform> } };

export type ClearChatSessionMutationVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type ClearChatSessionMutation = { __typename?: 'Mutation', clearChatSession: boolean };

export type GetDashboardMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardMetricsQuery = { __typename?: 'Query', getDashboardMetrics: { __typename?: 'DashboardMetrics', totalEngagement: number, totalLikes: number, totalComments: number, totalShares: number, totalHits: number, avgEngagementPerPost: number, engagementRate: number, platformBreakdown: Array<{ __typename?: 'PlatformMetrics', platform: Platform, totalHits: number, totalLikes: number, totalComments: number, totalShares: number, avgEngagement: number }> } };

export type SyncPostEngagementMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncPostEngagementMutation = { __typename?: 'Mutation', syncPostEngagement: Array<{ __typename?: 'SyncPostEngagementResult', platform: Platform, accountName: string, postsSynced: number, lastSynced: string }> };

export type GetUserEngagementMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserEngagementMetricsQuery = { __typename?: 'Query', getUserEngagementMetrics: { __typename?: 'UserEngagementMetrics', totalPosts: number, totalLikes: number, totalComments: number, totalShares: number, totalViews: number, avgEngagementPerPost: number, avgLikesPerPost: number, avgCommentsPerPost: number, platformBreakdown: Array<{ __typename?: 'PlatformEngagementMetrics', platform: Platform, totalPosts: number, totalLikes: number, totalComments: number, totalShares: number, totalViews: number, avgEngagement: number }> } };

export type GetEngagementTimeSeriesQueryVariables = Exact<{
  granularity: TimeSeriesGranularity;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetEngagementTimeSeriesQuery = { __typename?: 'Query', getEngagementTimeSeries: { __typename?: 'EngagementTimeSeries', granularity: TimeSeriesGranularity, dataPoints: Array<{ __typename?: 'EngagementTimeSeriesDataPoint', period: string, periodStart: string, periodEnd: string, totalPosts: number, totalLikes: number, totalComments: number, totalShares: number, totalViews: number, avgEngagement: number }> } };

export type GetFollowerAnalyticsQueryVariables = Exact<{
  timeRange: Scalars['String'];
}>;


export type GetFollowerAnalyticsQuery = { __typename?: 'Query', getFollowerAnalytics: { __typename?: 'FollowerAnalytics', accounts: Array<{ __typename?: 'FollowerAnalyticsAccount', id: string, platform: Platform, username: string, displayName?: string | null, currentFollowerCount: number, totalUnfollows: number, totalNewFollows: number, lastSnapshotAt?: any | null, isActive: boolean }>, snapshots: Array<{ __typename?: 'FollowerAnalyticsSnapshot', id: string, accountId: string, platform: Platform, followerCount: number, newFollowers: number, unfollowers: number, netChange: number, snapshotAt: any }>, recentFollowers: Array<{ __typename?: 'FollowerInfo', id: string, username: string, displayName?: string | null, avatarUrl?: string | null, platform: Platform, followedAt?: any | null }>, recentUnfollowers: Array<{ __typename?: 'FollowerInfo', id: string, username: string, displayName?: string | null, avatarUrl?: string | null, platform: Platform, unfollowedAt?: any | null }>, summary: { __typename?: 'FollowerAnalyticsSummary', totalFollowers: number, totalGained: number, totalLost: number, netChange: number, growthRate: number } } };

export type EnableFollowerTrackingMutationVariables = Exact<{
  snapshotFrequency?: InputMaybe<Scalars['Int']>;
  retentionDays?: InputMaybe<Scalars['Int']>;
}>;


export type EnableFollowerTrackingMutation = { __typename?: 'Mutation', enableFollowerTracking: { __typename?: 'FollowerTrackingResponse', success: boolean, message: string, tracking?: { __typename?: 'FollowerTrackingConfig', id: string, trackingEnabled: boolean, snapshotFrequency: number, retentionDays: number } | null } };

export type DisableFollowerTrackingMutationVariables = Exact<{ [key: string]: never; }>;


export type DisableFollowerTrackingMutation = { __typename?: 'Mutation', disableFollowerTracking: { __typename?: 'FollowerTrackingResponse', success: boolean, message: string } };

export type SyncFollowerCountsTrackingMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncFollowerCountsTrackingMutation = { __typename?: 'Mutation', syncFollowerCountsTracking: Array<{ __typename?: 'FollowerSyncResult', platform: Platform, accountName: string, followerCount: number, success: boolean, error?: string | null }> };

export type SyncFollowerTrackingAccountsMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncFollowerTrackingAccountsMutation = { __typename?: 'Mutation', syncFollowerTrackingAccounts: { __typename?: 'SyncFollowerTrackingResult', added: Array<string>, removed: Array<string>, unchanged: Array<string>, message: string } };

export type GetHitsQueryVariables = Exact<{
  filter: HitFilter;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
}>;


export type GetHitsQuery = { __typename?: 'Query', hits: { __typename?: 'FlatHitsResult', hasNextPage: boolean, hasPreviousPage: boolean, hits: Array<{ __typename?: 'Hit', uq_index: number, id: string, name: string, markedUnhelpful: boolean, campaignId: string, content?: string | null, platforms: Array<Platform>, keywords: Array<string>, campaignName?: string | null, date?: string | null, thumbnail?: string | null, videoUrl?: string | null, postURL: string, summary?: string | null, generateCount?: number | null, interactedWith: boolean, creator: { __typename?: 'Creator', name: string, avatarUrl?: string | null }, interaction: { __typename?: 'HitInteraction', positive: number, shared?: number | null, followers?: number | null, tag?: string | null, following?: number | null, postCount?: number | null, bio?: string | null, verified?: boolean | null, comment?: number | null } }> } };

export type GetScrapingStatusQueryVariables = Exact<{
  filter: ScrapingFilter;
}>;


export type GetScrapingStatusQuery = { __typename?: 'Query', scraping: { __typename?: 'Loading', instagram: boolean, youtube: boolean, reddit: boolean, tiktok: boolean, facebook: boolean } };

export type GetHitsVolumeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHitsVolumeQuery = { __typename?: 'Query', getHitsVolume: { __typename?: 'DashboardHitsVolumeReturn', hitsVolume: Array<{ __typename?: 'HitsVolume', date: string, data: Array<{ __typename?: 'HitVolumeData', platform: Platform, count: number }> }>, campaignsVolume: Array<{ __typename?: 'CampaignsVolume', platform: Platform, data: Array<{ __typename?: 'CampaignVolumeData', campaignName: string, hits: number }> }> } };

export type CreateHitGenerationMutationVariables = Exact<{
  campaignId: Scalars['Int'];
  hitsId: Scalars['String'];
  count: Scalars['Int'];
}>;


export type CreateHitGenerationMutation = { __typename?: 'Mutation', createHitGeneration: boolean };

export type BulkGenerateSummaryMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  data: Scalars['String'];
}>;


export type BulkGenerateSummaryMutation = { __typename?: 'Mutation', bulkGenerateSummary: boolean };

export type GetBulkGenerateSummaryVibeQueryVariables = Exact<{
  campaignId?: InputMaybe<Scalars['Int']>;
}>;


export type GetBulkGenerateSummaryVibeQuery = { __typename?: 'Query', getBulkGenerateSummaryVibe?: string | null };

export type GetVibesQueryVariables = Exact<{
  campaignId: Scalars['Int'];
}>;


export type GetVibesQuery = { __typename?: 'Query', getVibes: Array<{ __typename?: 'Vibe', id: string, comment: string }> };

export type CreateVibesMutationVariables = Exact<{
  data: Scalars['String'];
}>;


export type CreateVibesMutation = { __typename?: 'Mutation', createVibes: boolean };

export type GetAllVibesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllVibesQuery = { __typename?: 'Query', getAllVibes: Array<string> };

export type GetUserMediaQueryVariables = Exact<{
  accountId: Scalars['Int'];
  platform: Platform;
}>;


export type GetUserMediaQuery = { __typename?: 'Query', getUserMedia: Array<{ __typename?: 'UserMediaResponse', media_url: string, caption: string, timestamp: string, id: string, media_type: string } | null> };

export type CreateInstagramAutomationToolMutationVariables = Exact<{
  message: Array<Scalars['String']> | Scalars['String'];
  accountId: Scalars['Int'];
  keyword: Scalars['String'];
  shouldReply: Scalars['Boolean'];
  commentReply: Array<Scalars['String']> | Scalars['String'];
  post_id?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  platform?: InputMaybe<Platform>;
}>;


export type CreateInstagramAutomationToolMutation = { __typename?: 'Mutation', createInstagramAutomationTool: boolean };

export type GetInstagramToolsQueryVariables = Exact<{
  platform?: InputMaybe<Platform>;
}>;


export type GetInstagramToolsQuery = { __typename?: 'Query', getInstagramTools: Array<{ __typename?: 'InstagramToolsResponse', id: number, message: Array<string>, keyword: string, shouldReply: boolean, commentReply: Array<string | null>, status: ToolStatus, triggered: number, createdAt: string, title: string }> };

export type ChangeToolStatusMutationVariables = Exact<{
  status: ToolStatus;
  id: Scalars['Int'];
}>;


export type ChangeToolStatusMutation = { __typename?: 'Mutation', changeToolStatus: boolean };

export type DeleteInstagramToolMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteInstagramToolMutation = { __typename?: 'Mutation', deleteInstagramTool: boolean };

export type EditInstagramToolMutationVariables = Exact<{
  id: Scalars['Int'];
  data: EditInstagramToolObject;
}>;


export type EditInstagramToolMutation = { __typename?: 'Mutation', editInstagramTool: boolean };

export type GetBrandValuesMutationVariables = Exact<{
  accountId: Scalars['Int'];
}>;


export type GetBrandValuesMutation = { __typename?: 'Mutation', getBrandValues: boolean };

export type BrandValueQueryVariables = Exact<{
  platform: Platform;
}>;


export type BrandValueQuery = { __typename?: 'Query', brandValue?: { __typename?: 'BrandValue', accountName: string, platform: Platform, engagement: number, pricePerPost: number } | null };

export type SaveYouTubeApiKeyMutationVariables = Exact<{
  mediaAccountId: Scalars['Int'];
  apiKey: Scalars['String'];
}>;


export type SaveYouTubeApiKeyMutation = { __typename?: 'Mutation', saveYouTubeApiKey: { __typename?: 'YouTubeApiKeyResult', success: boolean, message: string, hasApiKey: boolean } };

export type RemoveYouTubeApiKeyMutationVariables = Exact<{
  mediaAccountId: Scalars['Int'];
}>;


export type RemoveYouTubeApiKeyMutation = { __typename?: 'Mutation', removeYouTubeApiKey: boolean };

export type GetYouTubeQuotaUsageQueryVariables = Exact<{
  mediaAccountId: Scalars['Int'];
}>;


export type GetYouTubeQuotaUsageQuery = { __typename?: 'Query', getYouTubeQuotaUsage?: { __typename?: 'YouTubeQuotaUsage', used: number, limit: number, percentage: number } | null };

export type GetListeningTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListeningTopicsQuery = { __typename?: 'Query', getListeningTopics: Array<{ __typename?: 'ListeningTopic', id: string, name: string, description: string, platforms: Array<Platform>, seedKeywords: any, minFollowers?: number | null, maxFollowers?: number | null, isActive: boolean, lastScrapedAt?: string | null, contentCount: number, createdAt: string, updatedAt: string }> };

export type GetListeningTopicQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetListeningTopicQuery = { __typename?: 'Query', getListeningTopic?: { __typename?: 'ListeningTopic', id: string, name: string, description: string, platforms: Array<Platform>, seedKeywords: any, minFollowers?: number | null, maxFollowers?: number | null, isActive: boolean, lastScrapedAt?: string | null, contentCount: number, createdAt: string, updatedAt: string } | null };

export type GetListeningTopicFeedQueryVariables = Exact<{
  input: ListeningTopicFeedInput;
}>;


export type GetListeningTopicFeedQuery = { __typename?: 'Query', getListeningTopicFeed: { __typename?: 'ListeningTopicFeedResult', totalCount: number, hasMore: boolean, content: Array<{ __typename?: 'NicheContent', id: string, platform: Platform, contentId: string, caption?: string | null, summary?: string | null, authorUsername: string, authorDisplayName?: string | null, authorAvatarUrl?: string | null, contentUrl: string, thumbnailUrl?: string | null, contentType: string, likes: number, comments: number, shares: number, views?: number | null, hashtags: Array<string>, mentions: Array<string>, authorFollowerCount?: number | null, preGeneratedComment?: string | null, postedAt: string, scrapedAt: string, similarity?: number | null, relevanceScore?: number | null, interactedWith?: boolean | null }> } };

export type GetEngagementStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEngagementStatsQuery = { __typename?: 'Query', getEngagementStats: { __typename?: 'EngagementStats', today: number, thisWeek: number, thisMonth: number, total: number, streakDays: number } };

export type GetCreatorPostsQueryVariables = Exact<{
  username: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetCreatorPostsQuery = { __typename?: 'Query', getCreatorPosts: Array<{ __typename?: 'NicheContent', id: string, platform: Platform, contentId: string, caption?: string | null, summary?: string | null, authorUsername: string, authorDisplayName?: string | null, authorAvatarUrl?: string | null, contentUrl: string, thumbnailUrl?: string | null, contentType: string, likes: number, comments: number, shares: number, views?: number | null, hashtags: Array<string>, mentions: Array<string>, postedAt: string, scrapedAt: string, similarity?: number | null, interactedWith?: boolean | null }> };

export type GetSuggestedProfilesQueryVariables = Exact<{
  topicId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetSuggestedProfilesQuery = { __typename?: 'Query', getSuggestedProfiles: { __typename?: 'SuggestedProfilesResult', totalCount: number, profiles: Array<{ __typename?: 'SuggestedProfile', authorUsername: string, authorDisplayName?: string | null, authorAvatarUrl?: string | null, followerCount?: number | null, primaryPlatform?: string | null, postCount: number, topicAppearances: number, avgLikes: number, avgComments: number, totalLikes: number, totalComments: number, timesEngaged: number, lastEngagedAt?: string | null, latestContentUrl?: string | null, profileScore: number, engagementRate?: number | null, topicNames?: Array<string> | null, lastPostedAt?: string | null, isGuestCandidate?: boolean | null, guestStatus?: string | null, guestNotes?: string | null, discoveredVia?: string | null, commentFrequency?: number | null }> } };

export type GenerateTopicKeywordsQueryVariables = Exact<{
  description: Scalars['String'];
  platforms: Array<Platform> | Platform;
}>;


export type GenerateTopicKeywordsQuery = { __typename?: 'Query', generateTopicKeywords: { __typename?: 'GeneratedKeywords', keywords: any } };

export type CreateListeningTopicMutationVariables = Exact<{
  input: CreateListeningTopicInput;
}>;


export type CreateListeningTopicMutation = { __typename?: 'Mutation', createListeningTopic: { __typename?: 'ListeningTopic', id: string, name: string, description: string, platforms: Array<Platform>, seedKeywords: any, isActive: boolean, contentCount: number, createdAt: string, updatedAt: string } };

export type UpdateListeningTopicMutationVariables = Exact<{
  input: UpdateListeningTopicInput;
}>;


export type UpdateListeningTopicMutation = { __typename?: 'Mutation', updateListeningTopic: { __typename?: 'ListeningTopic', id: string, name: string, description: string, platforms: Array<Platform>, seedKeywords: any, isActive: boolean, contentCount: number, createdAt: string, updatedAt: string } };

export type DeleteListeningTopicMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteListeningTopicMutation = { __typename?: 'Mutation', deleteListeningTopic: boolean };

export type RefreshListeningTopicMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefreshListeningTopicMutation = { __typename?: 'Mutation', refreshListeningTopic: boolean };

export type MarkTopicContentInteractedMutationVariables = Exact<{
  contentId: Scalars['ID'];
}>;


export type MarkTopicContentInteractedMutation = { __typename?: 'Mutation', markTopicContentInteracted: boolean };

export type HideTopicContentMutationVariables = Exact<{
  contentId: Scalars['ID'];
}>;


export type HideTopicContentMutation = { __typename?: 'Mutation', hideTopicContent: boolean };

export type SaveContentCommentMutationVariables = Exact<{
  contentId: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type SaveContentCommentMutation = { __typename?: 'Mutation', saveContentComment: boolean };

export type ExploreAudienceMutationVariables = Exact<{
  authorUsername: Scalars['String'];
}>;


export type ExploreAudienceMutation = { __typename?: 'Mutation', exploreAudience: Array<{ __typename?: 'AudienceMember', username: string, fullName?: string | null, profilePicUrl?: string | null, followerCount?: number | null, commentFrequency: number, isVerified: boolean }> };

export type UpdateGuestStatusMutationVariables = Exact<{
  username: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
}>;


export type UpdateGuestStatusMutation = { __typename?: 'Mutation', updateGuestStatus: boolean };

export type GenerateGuestPitchMutationVariables = Exact<{
  authorUsername: Scalars['String'];
  podcastName: Scalars['String'];
  podcastDescription: Scalars['String'];
}>;


export type GenerateGuestPitchMutation = { __typename?: 'Mutation', generateGuestPitch: string };

export type GetAudienceInsightsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAudienceInsightsQuery = { __typename?: 'Query', getAudienceInsights: { __typename?: 'AudienceInsights', totalCreators: number, totalEngagements: number, topTopics: Array<string>, platformBreakdown: Array<{ __typename?: 'PlatformStat', platform: string, count: number, percentage: number }>, followerTiers: Array<{ __typename?: 'FollowerTier', tier: string, count: number, percentage: number }>, engagementTrend: Array<{ __typename?: 'DailyEngagement', date: string, count: number }> } };

export type GetEpisodePerformanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEpisodePerformanceQuery = { __typename?: 'Query', getEpisodePerformance: Array<{ __typename?: 'EpisodePerformance', topicId: string, topicName: string, contentCount: number, engagementCount: number, createdAt: string }> };

export type GetNicheCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNicheCategoriesQuery = { __typename?: 'Query', getNicheCategories: Array<{ __typename?: 'NicheCategory', id: string, slug: string, displayName: string, description?: string | null, iconEmoji?: string | null, isActive: boolean, contentCount: number }> };

export type GetNicheCategoryQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetNicheCategoryQuery = { __typename?: 'Query', getNicheCategory?: { __typename?: 'NicheCategory', id: string, slug: string, displayName: string, description?: string | null, iconEmoji?: string | null, isActive: boolean, contentCount: number } | null };

export type SearchNicheContentQueryVariables = Exact<{
  input: NicheSearchInput;
}>;


export type SearchNicheContentQuery = { __typename?: 'Query', searchNicheContent: { __typename?: 'NicheSearchResult', totalCount: number, hasMore: boolean, content: Array<{ __typename?: 'NicheContent', id: string, nicheCategoryId?: string | null, platform: Platform, contentId: string, caption?: string | null, summary?: string | null, authorUsername: string, authorDisplayName?: string | null, authorAvatarUrl?: string | null, contentUrl: string, thumbnailUrl?: string | null, contentType: string, likes: number, comments: number, shares: number, views?: number | null, saves?: number | null, hashtags: Array<string>, mentions: Array<string>, postedAt: string, scrapedAt: string, similarity?: number | null }> } };

export type BrowseNicheContentQueryVariables = Exact<{
  input: NicheBrowseInput;
}>;


export type BrowseNicheContentQuery = { __typename?: 'Query', browseNicheContent: { __typename?: 'NicheBrowseResult', totalCount: number, hasMore: boolean, content: Array<{ __typename?: 'NicheContent', id: string, nicheCategoryId?: string | null, platform: Platform, contentId: string, caption?: string | null, summary?: string | null, authorUsername: string, authorDisplayName?: string | null, authorAvatarUrl?: string | null, contentUrl: string, thumbnailUrl?: string | null, contentType: string, likes: number, comments: number, shares: number, views?: number | null, saves?: number | null, hashtags: Array<string>, mentions: Array<string>, postedAt: string, scrapedAt: string, similarity?: number | null }> } };

export type GlobalNicheSearchQueryVariables = Exact<{
  query: Scalars['String'];
  platforms?: InputMaybe<Array<Platform> | Platform>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GlobalNicheSearchQuery = { __typename?: 'Query', globalNicheSearch: { __typename?: 'NicheSearchResult', totalCount: number, hasMore: boolean, content: Array<{ __typename?: 'NicheContent', id: string, nicheCategoryId?: string | null, platform: Platform, contentId: string, caption?: string | null, summary?: string | null, authorUsername: string, authorDisplayName?: string | null, authorAvatarUrl?: string | null, contentUrl: string, thumbnailUrl?: string | null, contentType: string, likes: number, comments: number, shares: number, views?: number | null, saves?: number | null, hashtags: Array<string>, mentions: Array<string>, postedAt: string, scrapedAt: string, similarity?: number | null }> } };

export type GetOauthTokensQueryVariables = Exact<{
  code: Scalars['String'];
  platform: OauthPlatform;
}>;


export type GetOauthTokensQuery = { __typename?: 'Query', oauth: { __typename?: 'Connect', accessToken: string, refreshToken?: string | null } };

export type AddMediaAccountMutationVariables = Exact<{
  accessToken: Scalars['String'];
  platform: Platform;
  refreshToken?: InputMaybe<Scalars['String']>;
}>;


export type AddMediaAccountMutation = { __typename?: 'Mutation', addMediaAccount: { __typename?: 'MediaAccounts', id: number, accountName: string, platform: Platform, igUserId?: string | null, nickname?: string | null, privacy_level_options?: Array<string> | null, max_video_duration?: number | null, comments_disabled?: boolean | null, duet_disabled?: boolean | null, stitch_disabled?: boolean | null } };

export type RemoveMediaAccountMutationVariables = Exact<{
  accountId: Scalars['Int'];
}>;


export type RemoveMediaAccountMutation = { __typename?: 'Mutation', removeMediaAccount: boolean };

export type ValidateAccountConnectionMutationVariables = Exact<{
  accountId: Scalars['Int'];
}>;


export type ValidateAccountConnectionMutation = { __typename?: 'Mutation', validateAccountConnection: { __typename?: 'AccountConnectionStatus', accountId: number, platform: Platform, isValid: boolean, lastValidated: string, needsReconnection: boolean, message?: string | null } };

export type PublishInstagramMutationVariables = Exact<{
  mediaURLs: Array<Scalars['String']> | Scalars['String'];
  caption?: InputMaybe<Scalars['String']>;
  accountId: Scalars['Int'];
  postType: PostType;
}>;


export type PublishInstagramMutation = { __typename?: 'Mutation', publishInstagram: boolean };

export type PublishFacebookMutationVariables = Exact<{
  accountId: Scalars['Int'];
  caption: Scalars['String'];
  mediaURL: Scalars['String'];
  published: Scalars['Boolean'];
  isVideo: Scalars['Boolean'];
  scheduledDate?: InputMaybe<Scalars['String']>;
}>;


export type PublishFacebookMutation = { __typename?: 'Mutation', publishFacebook: boolean };

export type PublishTikTokMutationVariables = Exact<{
  mediaURL: Scalars['String'];
  caption?: InputMaybe<Scalars['String']>;
  accountId: Scalars['Int'];
  privacy_level: Scalars['String'];
  allow_comments: Scalars['Boolean'];
  allow_duet: Scalars['Boolean'];
  allow_stitch: Scalars['Boolean'];
  brand_content: Scalars['Boolean'];
  brand_organic: Scalars['Boolean'];
}>;


export type PublishTikTokMutation = { __typename?: 'Mutation', publishTikTok: boolean };

export type CreateScheduledPostMutationVariables = Exact<{
  videoMediaURL: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  imageMediaURL: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  platform: Platform;
  postType: PostType;
  postDate: Scalars['String'];
  mediaAccountId: Scalars['Int'];
  privacy_level?: InputMaybe<Scalars['String']>;
  allow_comments?: InputMaybe<Scalars['Boolean']>;
  allow_duet?: InputMaybe<Scalars['Boolean']>;
  allow_stitch?: InputMaybe<Scalars['Boolean']>;
  brand_organic?: InputMaybe<Scalars['Boolean']>;
  brand_content?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateScheduledPostMutation = { __typename?: 'Mutation', schedulePost: boolean };

export type MediaAccountsQueryVariables = Exact<{
  platform?: InputMaybe<Platform>;
}>;


export type MediaAccountsQuery = { __typename?: 'Query', mediaAccounts: Array<{ __typename?: 'MediaAccounts', id: number, igUserId?: string | null, accountName: string, platform: Platform, nickname?: string | null, privacy_level_options?: Array<string> | null, max_video_duration?: number | null, comments_disabled?: boolean | null, duet_disabled?: boolean | null, stitch_disabled?: boolean | null, followerCount?: number | null, lastFollowerSync?: string | null, hasApiKey: boolean, apiKeyAddedAt?: string | null }> };

export type SyncFollowerCountsMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncFollowerCountsMutation = { __typename?: 'Mutation', syncFollowerCounts: Array<{ __typename?: 'AccountFollowerStats', platform: Platform, accountName: string, followerCount: number, lastSynced: string }> };

export type UserPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPostsQuery = { __typename?: 'Query', userPosts: { __typename?: 'AllPosts', old: Array<{ __typename?: 'Post', id: number, platform: Platform, postDate: string, caption: string, imageMediaURLs: Array<string | null>, videoMediaURLs: Array<string | null>, postType: PostType, accountName: string } | null>, scheduled: Array<{ __typename?: 'Post', id: number, platform: Platform, postDate: string, caption: string, imageMediaURLs: Array<string | null>, videoMediaURLs: Array<string | null>, postType: PostType, accountName: string } | null> } };

export type CancelPostMutationVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type CancelPostMutation = { __typename?: 'Mutation', cancelPost: boolean };

export type GetResponseQueryVariables = Exact<{
  videoId?: InputMaybe<Scalars['String']>;
  platform: Platform;
  content?: InputMaybe<Scalars['String']>;
}>;


export type GetResponseQuery = { __typename?: 'Query', respond: string };

export type CreateSubscriptionMutationVariables = Exact<{
  session_id: Scalars['String'];
  planId: Scalars['String'];
  productId: Scalars['String'];
  subscriptionId: Scalars['String'];
  productName: Scalars['String'];
  customer_id: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: boolean };

export type UpdateSubscriptionMutationVariables = Exact<{
  type: Scalars['String'];
  endDate: Scalars['String'];
  subscriptionId: Scalars['String'];
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription: boolean };

export type GetSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionQuery = { __typename?: 'Query', getSubscription?: { __typename?: 'Subscription', planName?: string | null, status?: SubscriptionStatus | null, stripeCheckoutSessionId?: string | null, stripeSubscriptionId?: string | null, planId?: string | null, productId?: string | null, endDate?: string | null, customerId?: string | null } | null };

export type GetSuperFansQueryVariables = Exact<{
  mediaAccountId?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<SuperFanFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetSuperFansQuery = { __typename?: 'Query', getSuperFans: Array<{ __typename?: 'SuperFan', id: string, followerPlatformId: string, followerUsername: string, followerDisplayName?: string | null, followerAvatarUrl?: string | null, platform: Platform, totalLikes: number, totalComments: number, totalShares: number, totalSaves: number, postsLiked: number, postsCommented: number, postsShared: number, postsSaved: number, firstInteraction?: any | null, lastInteraction?: any | null, daysSinceFirst: number, consistencyScore: number, depthScore: number, recencyScore: number, overallScore: number, tier: SuperFanTier, hasSpecialActions: boolean, lastCalculated: any, specialActions: Array<{ __typename?: 'SuperFanAction', id: string, actionType: string, actionDescription?: string | null, actionValue: number, relatedPostId?: string | null, relatedPostUrl?: string | null, detectedAt: any }> }> };

export type GetSuperFanStatsQueryVariables = Exact<{
  mediaAccountId?: InputMaybe<Scalars['Int']>;
}>;


export type GetSuperFanStatsQuery = { __typename?: 'Query', getSuperFanStats: { __typename?: 'SuperFanStats', totalSuperFans: number, megaFans: number, superFans: number, activeFans: number, casualFans: number, avgConsistencyScore: number, avgDepthScore: number, avgRecencyScore: number, topSuperFans: Array<{ __typename?: 'SuperFan', id: string, followerPlatformId: string, followerUsername: string, followerDisplayName?: string | null, followerAvatarUrl?: string | null, platform: Platform, totalLikes: number, totalComments: number, totalShares: number, totalSaves: number, consistencyScore: number, depthScore: number, recencyScore: number, overallScore: number, tier: SuperFanTier, lastInteraction?: any | null }> } };

export type GetSuperFanBreakdownQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuperFanBreakdownQuery = { __typename?: 'Query', getSuperFanBreakdown: Array<{ __typename?: 'SuperFanBreakdown', platform: Platform, totalFans: number, megaFans: number, superFans: number, activeFans: number, avgScore: number }> };

export type CalculateSuperFansMutationVariables = Exact<{
  mediaAccountId: Scalars['Int'];
}>;


export type CalculateSuperFansMutation = { __typename?: 'Mutation', calculateSuperFans: { __typename?: 'SuperFanStats', totalSuperFans: number, megaFans: number, superFans: number, activeFans: number, casualFans: number, avgConsistencyScore: number, avgDepthScore: number, avgRecencyScore: number, topSuperFans: Array<{ __typename?: 'SuperFan', id: string, followerUsername: string, overallScore: number, tier: SuperFanTier }> } };

export type RecordSuperFanActionMutationVariables = Exact<{
  followerMetricsId: Scalars['ID'];
  actionType: Scalars['String'];
  actionDescription?: InputMaybe<Scalars['String']>;
  actionValue: Scalars['Int'];
  relatedPostId?: InputMaybe<Scalars['String']>;
  relatedPostUrl?: InputMaybe<Scalars['String']>;
}>;


export type RecordSuperFanActionMutation = { __typename?: 'Mutation', recordSuperFanAction: { __typename?: 'SuperFanAction', id: string, actionType: string, actionDescription?: string | null, actionValue: number, detectedAt: any } };

export type CreateHashtagsMutationVariables = Exact<{
  update?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateHashtagsMutation = { __typename?: 'Mutation', createHashtags: boolean };

export type GetHashtagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHashtagsQuery = { __typename?: 'Query', getHashtags: { __typename?: 'getHashtagsResponse', createdAt?: string | null, trends?: { __typename?: 'TrendingHashtagsResponse', youtube: Array<{ __typename?: 'TrendingHashtag', tag: string, metrics: { __typename?: 'HashtagMetrics', volume: number, growth: number, engagement?: number | null } } | null>, instagram: Array<{ __typename?: 'TrendingHashtag', tag: string, metrics: { __typename?: 'HashtagMetrics', volume: number, growth: number, engagement?: number | null } } | null>, tiktok: Array<{ __typename?: 'TrendingHashtag', tag: string, metrics: { __typename?: 'HashtagMetrics', volume: number, growth: number, engagement?: number | null } } | null>, facebook: Array<{ __typename?: 'TrendingHashtag', tag: string, metrics: { __typename?: 'HashtagMetrics', volume: number, growth: number, engagement?: number | null } }>, reddit: Array<{ __typename?: 'TrendingHashtag', tag: string, metrics: { __typename?: 'HashtagMetrics', volume: number, growth: number, engagement?: number | null } }> } | null } };

export type GetNewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsQuery = { __typename?: 'Query', getNews: { __typename?: 'getNewsResponse', updatedAt?: string | null, news: Array<{ __typename?: 'newsFormat', article_id: string, title: string, link: string, pubDate: string, source_id: string } | null> } };

export type CreateTargetCreatorsMutationVariables = Exact<{
  creators: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateTargetCreatorsMutation = { __typename?: 'Mutation', createTargetCreators: boolean };

export type GetCreatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreatorsQuery = { __typename?: 'Query', getCreators: { __typename?: 'TargetCreators', creators: Array<string>, createdAt?: string | null, info: Array<{ __typename?: 'TargetCreatorsInfo', id?: number | null, resultDate?: string | null, username?: string | null, avatarUrl?: string | null, hashtags: Array<string | null>, followersCount?: number | null, likesCount?: number | null, commentsCount?: number | null, summary?: string | null, relatedProfiles: Array<string | null>, taggedUsers: Array<string | null> } | null> } };

export type GetTargetFollowersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTargetFollowersQuery = { __typename?: 'Query', getTargetFollowers?: { __typename?: 'TargetFollowers', id: number, resultsDate: string, avatarUrl: string, accountName: string, account_id: number, isProcessing: boolean, processingStatus: string, progress: number, errorMessage?: string | null, popularFollowers: Array<{ __typename?: 'FollowersObject', username?: string | null, avatar?: string | null } | null>, activeFollowers: Array<{ __typename?: 'FollowersObject', username?: string | null, avatar?: string | null } | null>, similarFollowers: Array<{ __typename?: 'FollowersObject', username?: string | null, avatar?: string | null }> } | null };

export type AnalyzeFollowersMutationVariables = Exact<{
  accountId: Scalars['Int'];
}>;


export type AnalyzeFollowersMutation = { __typename?: 'Mutation', analyzeFollowers: boolean };

export type GetTargetResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTargetResultsQuery = { __typename?: 'Query', getTargetFollowersResults: Array<{ __typename?: 'TargetCreatorsInfo', id?: number | null, resultDate?: string | null, username?: string | null, avatarUrl?: string | null, hashtags: Array<string | null>, followersCount?: number | null, likesCount?: number | null, commentsCount?: number | null, summary?: string | null, relatedProfiles: Array<string | null>, taggedUsers: Array<string | null> } | null> };

export type CreateInstagramInsightsMutationVariables = Exact<{
  accountId: Scalars['Int'];
}>;


export type CreateInstagramInsightsMutation = { __typename?: 'Mutation', createInstagramInsights: boolean };

export type GetInstagramInsightsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstagramInsightsQuery = { __typename?: 'Query', getInstagramInsights?: { __typename?: 'InstagramInsights', id: number, startDate: string, endDate: string, reach: number, impressions: number, profile_views: number } | null };

export type RefreshTargetFollowersMutationVariables = Exact<{
  id: Scalars['Int'];
  accountId: Scalars['Int'];
}>;


export type RefreshTargetFollowersMutation = { __typename?: 'Mutation', refreshTargetFollowers: boolean };

export type RefreshTargetCreatorsMutationVariables = Exact<{
  creators: Array<Scalars['String']> | Scalars['String'];
}>;


export type RefreshTargetCreatorsMutation = { __typename?: 'Mutation', refreshTargetCreators: boolean };

export type FetchFollowerDetailsMutationVariables = Exact<{
  usernames: Array<Scalars['String']> | Scalars['String'];
}>;


export type FetchFollowerDetailsMutation = { __typename?: 'Mutation', fetchFollowerDetails: Array<{ __typename?: 'FollowerDetails', username: string, platform: string, bio?: string | null, profileImage?: string | null, profileSummary?: string | null, commentsSummary?: string | null, tags: Array<{ __typename?: 'Hashtag', name: string, count: number }>, stats: { __typename?: 'FollowerStats', followers: string, posts: string, following: string, likes: number, comments: number } }> };

export type FetchSimilarAccountsMutationVariables = Exact<{
  username: Scalars['String'];
}>;


export type FetchSimilarAccountsMutation = { __typename?: 'Mutation', fetchSimilarAccounts: Array<{ __typename?: 'SimilarAccount', username: string, follower_count?: number | null, profile_pic_url?: string | null }> };

export type FetchUserPostsMutationVariables = Exact<{
  username: Scalars['String'];
}>;


export type FetchUserPostsMutation = { __typename?: 'Mutation', fetchUserPosts: Array<{ __typename?: 'InstagramPost', id: string, like_count?: number | null, comment_count?: number | null, caption?: { __typename?: 'PostCaption', text?: string | null, hashtags?: Array<string> | null } | null }> };

export type GenerateProfileSummaryMutationVariables = Exact<{
  username: Scalars['String'];
  stats: FollowerStatsInput;
}>;


export type GenerateProfileSummaryMutation = { __typename?: 'Mutation', generateProfileSummary: string };

export type GenerateCommentsSummaryMutationVariables = Exact<{
  username: Scalars['String'];
  commentCount: Scalars['Int'];
}>;


export type GenerateCommentsSummaryMutation = { __typename?: 'Mutation', generateCommentsSummary: string };

export type CommonUserInformationFragment = { __typename?: 'User', id: string, name?: string | null, username: string, email: string, emailVerified: boolean, info?: { __typename?: 'UserInfo', customerId?: string | null, subscriptionId?: string | null } | null };

export type UserSubscriptionInfoFragment = { __typename?: 'Subscription', planId?: string | null, planName?: string | null, planDisplayName?: string | null, status?: SubscriptionStatus | null, endDate?: string | null, stripeCheckoutSessionId?: string | null, stripeSubscriptionId?: string | null, productId?: string | null, customerId?: string | null, canUseAdvancedFeatures?: boolean | null, canAccessAnalytics?: boolean | null };

export type UserUsageInfoFragment = { __typename?: 'UserUsage', currentMonth: string, itemsCreated: number, maxItemsPerMonth: number, itemsRemaining: number, aiCreditsUsed: number, maxAICreditsPerMonth: number, aiCreditsRemaining: number };

export type FullUserInformationFragment = { __typename?: 'User', id: string, name?: string | null, username: string, email: string, emailVerified: boolean, subscription?: { __typename?: 'Subscription', planId?: string | null, planName?: string | null, planDisplayName?: string | null, status?: SubscriptionStatus | null, endDate?: string | null, stripeCheckoutSessionId?: string | null, stripeSubscriptionId?: string | null, productId?: string | null, customerId?: string | null, canUseAdvancedFeatures?: boolean | null, canAccessAnalytics?: boolean | null } | null, usage?: { __typename?: 'UserUsage', currentMonth: string, itemsCreated: number, maxItemsPerMonth: number, itemsRemaining: number, aiCreditsUsed: number, maxAICreditsPerMonth: number, aiCreditsRemaining: number } | null, info?: { __typename?: 'UserInfo', customerId?: string | null, subscriptionId?: string | null } | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name?: string | null, username: string, email: string, emailVerified: boolean, subscription?: { __typename?: 'Subscription', planId?: string | null, planName?: string | null, planDisplayName?: string | null, status?: SubscriptionStatus | null, endDate?: string | null, stripeCheckoutSessionId?: string | null, stripeSubscriptionId?: string | null, productId?: string | null, customerId?: string | null, canUseAdvancedFeatures?: boolean | null, canAccessAnalytics?: boolean | null } | null, usage?: { __typename?: 'UserUsage', currentMonth: string, itemsCreated: number, maxItemsPerMonth: number, itemsRemaining: number, aiCreditsUsed: number, maxAICreditsPerMonth: number, aiCreditsRemaining: number } | null, info?: { __typename?: 'UserInfo', customerId?: string | null, subscriptionId?: string | null } | null } | null };

export type GetUserBasicQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserBasicQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name?: string | null, username: string, email: string, emailVerified: boolean, info?: { __typename?: 'UserInfo', customerId?: string | null, subscriptionId?: string | null } | null } | null };

export type GetUserWithSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserWithSubscriptionQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name?: string | null, username: string, email: string, emailVerified: boolean, subscription?: { __typename?: 'Subscription', planId?: string | null, planName?: string | null, planDisplayName?: string | null, status?: SubscriptionStatus | null, endDate?: string | null, stripeCheckoutSessionId?: string | null, stripeSubscriptionId?: string | null, productId?: string | null, customerId?: string | null, canUseAdvancedFeatures?: boolean | null, canAccessAnalytics?: boolean | null } | null, info?: { __typename?: 'UserInfo', customerId?: string | null, subscriptionId?: string | null } | null } | null };

export type GetUserWithUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserWithUsageQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name?: string | null, username: string, email: string, emailVerified: boolean, usage?: { __typename?: 'UserUsage', currentMonth: string, itemsCreated: number, maxItemsPerMonth: number, itemsRemaining: number, aiCreditsUsed: number, maxAICreditsPerMonth: number, aiCreditsRemaining: number } | null, info?: { __typename?: 'UserInfo', customerId?: string | null, subscriptionId?: string | null } | null } | null };

export type GetWeeklyContextStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWeeklyContextStatusQuery = { __typename?: 'Query', getWeeklyContextStatus: { __typename?: 'WeeklyContextStatus', hasCurrentWeek: boolean, lastUpdated?: string | null, currentContext?: { __typename?: 'WeeklyContext', id: number, weekStart: string, context: any, createdAt: string, updatedAt: string, isActive: boolean } | null } };

export type GetActiveWeeklyContextQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveWeeklyContextQuery = { __typename?: 'Query', getActiveWeeklyContext?: { __typename?: 'WeeklyContext', id: number, weekStart: string, context: any, createdAt: string, updatedAt: string, isActive: boolean } | null };

export type GetWeeklyContextHistoryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetWeeklyContextHistoryQuery = { __typename?: 'Query', getWeeklyContextHistory: Array<{ __typename?: 'WeeklyContext', id: number, weekStart: string, context: any, createdAt: string, updatedAt: string, isActive: boolean }> };

export type CreateWeeklyContextMutationVariables = Exact<{
  context: WeeklyContextInput;
}>;


export type CreateWeeklyContextMutation = { __typename?: 'Mutation', createWeeklyContext: boolean };

export const CommonUserInformationFragmentDoc = gql`
    fragment CommonUserInformation on User {
  id
  name
  username
  email
  emailVerified
  info {
    customerId
    subscriptionId
  }
}
    `;
export const UserSubscriptionInfoFragmentDoc = gql`
    fragment UserSubscriptionInfo on Subscription {
  planId
  planName
  planDisplayName
  status
  endDate
  stripeCheckoutSessionId
  stripeSubscriptionId
  productId
  customerId
  canUseAdvancedFeatures
  canAccessAnalytics
}
    `;
export const UserUsageInfoFragmentDoc = gql`
    fragment UserUsageInfo on UserUsage {
  currentMonth
  itemsCreated
  maxItemsPerMonth
  itemsRemaining
  aiCreditsUsed
  maxAICreditsPerMonth
  aiCreditsRemaining
}
    `;
export const FullUserInformationFragmentDoc = gql`
    fragment FullUserInformation on User {
  ...CommonUserInformation
  subscription {
    ...UserSubscriptionInfo
  }
  usage {
    ...UserUsageInfo
  }
}
    ${CommonUserInformationFragmentDoc}
${UserSubscriptionInfoFragmentDoc}
${UserUsageInfoFragmentDoc}`;
export const GetCampaignsDocument = gql`
    query GetCampaigns($filter: CampaignFilter) {
  campaigns(filter: $filter) {
    id
    name
    keywords
    createdAt
    hitsCount
    platforms
    type
  }
}
    `;

/**
 * __useGetCampaignsQuery__
 *
 * To run a query within a React component, call `useGetCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
      }
export function useGetCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
        }
export type GetCampaignsQueryHookResult = ReturnType<typeof useGetCampaignsQuery>;
export type GetCampaignsLazyQueryHookResult = ReturnType<typeof useGetCampaignsLazyQuery>;
export type GetCampaignsQueryResult = Apollo.QueryResult<GetCampaignsQuery, GetCampaignsQueryVariables>;
export const GetRefreshContentInfoDocument = gql`
    query getRefreshContentInfo($id: Int!) {
  refreshContentInfo(id: $id) {
    queryTree
    creationDate
    maxHits
  }
}
    `;

/**
 * __useGetRefreshContentInfoQuery__
 *
 * To run a query within a React component, call `useGetRefreshContentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefreshContentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefreshContentInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRefreshContentInfoQuery(baseOptions: Apollo.QueryHookOptions<GetRefreshContentInfoQuery, GetRefreshContentInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefreshContentInfoQuery, GetRefreshContentInfoQueryVariables>(GetRefreshContentInfoDocument, options);
      }
export function useGetRefreshContentInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefreshContentInfoQuery, GetRefreshContentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefreshContentInfoQuery, GetRefreshContentInfoQueryVariables>(GetRefreshContentInfoDocument, options);
        }
export type GetRefreshContentInfoQueryHookResult = ReturnType<typeof useGetRefreshContentInfoQuery>;
export type GetRefreshContentInfoLazyQueryHookResult = ReturnType<typeof useGetRefreshContentInfoLazyQuery>;
export type GetRefreshContentInfoQueryResult = Apollo.QueryResult<GetRefreshContentInfoQuery, GetRefreshContentInfoQueryVariables>;
export const GetPlatformsDocument = gql`
    query getPlatforms($id: Int!) {
  platforms(id: $id)
}
    `;

/**
 * __useGetPlatformsQuery__
 *
 * To run a query within a React component, call `useGetPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlatformsQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformsQuery, GetPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformsQuery, GetPlatformsQueryVariables>(GetPlatformsDocument, options);
      }
export function useGetPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformsQuery, GetPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformsQuery, GetPlatformsQueryVariables>(GetPlatformsDocument, options);
        }
export type GetPlatformsQueryHookResult = ReturnType<typeof useGetPlatformsQuery>;
export type GetPlatformsLazyQueryHookResult = ReturnType<typeof useGetPlatformsLazyQuery>;
export type GetPlatformsQueryResult = Apollo.QueryResult<GetPlatformsQuery, GetPlatformsQueryVariables>;
export const GetCompetitorDashboardDocument = gql`
    query GetCompetitorDashboard($campaignId: String!) {
  getCompetitorDashboard(campaignId: $campaignId) {
    config {
      id
      autoRefreshEnabled
      autoRefreshInterval
      lastRefreshed
    }
    competitors {
      id
      username
      platform
      displayName
      avatarUrl
      accountUrl
      isActive
      latestMetrics {
        followers
        engagementRate
        postFrequency
        followersGrowth
      }
      growthTrend {
        direction
        percentage
        timeframe
      }
    }
    insights {
      id
      insightType
      title
      description
      priority
      recommendations
      generatedAt
    }
    aggregateMetrics {
      totalCompetitors
      avgFollowers
      avgEngagementRate
      avgPostFrequency
      hashtagTrends {
        hashtag
        count
        trend
      }
    }
    topSavedContent {
      id
      contentId
      caption
      thumbnailUrl
      likes
      comments
      shares
      saves
      fbLikeCount
      postedAt
    }
    topSharedContent {
      id
      contentId
      caption
      thumbnailUrl
      likes
      comments
      shares
      saves
      fbLikeCount
      postedAt
    }
    yourPerformance {
      followers
      engagementRate
      postFrequency
      rankVsCompetitors
      percentile
    }
    userAccounts {
      id
      platform
      accountName
    }
  }
}
    `;

/**
 * __useGetCompetitorDashboardQuery__
 *
 * To run a query within a React component, call `useGetCompetitorDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorDashboardQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCompetitorDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorDashboardQuery, GetCompetitorDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorDashboardQuery, GetCompetitorDashboardQueryVariables>(GetCompetitorDashboardDocument, options);
      }
export function useGetCompetitorDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorDashboardQuery, GetCompetitorDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorDashboardQuery, GetCompetitorDashboardQueryVariables>(GetCompetitorDashboardDocument, options);
        }
export type GetCompetitorDashboardQueryHookResult = ReturnType<typeof useGetCompetitorDashboardQuery>;
export type GetCompetitorDashboardLazyQueryHookResult = ReturnType<typeof useGetCompetitorDashboardLazyQuery>;
export type GetCompetitorDashboardQueryResult = Apollo.QueryResult<GetCompetitorDashboardQuery, GetCompetitorDashboardQueryVariables>;
export const GetCompetitorInsightsDocument = gql`
    query GetCompetitorInsights($configId: String!, $type: String, $priority: String) {
  getCompetitorInsights(configId: $configId, type: $type, priority: $priority) {
    id
    insightType
    title
    description
    priority
    recommendations
    generatedAt
  }
}
    `;

/**
 * __useGetCompetitorInsightsQuery__
 *
 * To run a query within a React component, call `useGetCompetitorInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorInsightsQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *      type: // value for 'type'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function useGetCompetitorInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorInsightsQuery, GetCompetitorInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorInsightsQuery, GetCompetitorInsightsQueryVariables>(GetCompetitorInsightsDocument, options);
      }
export function useGetCompetitorInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorInsightsQuery, GetCompetitorInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorInsightsQuery, GetCompetitorInsightsQueryVariables>(GetCompetitorInsightsDocument, options);
        }
export type GetCompetitorInsightsQueryHookResult = ReturnType<typeof useGetCompetitorInsightsQuery>;
export type GetCompetitorInsightsLazyQueryHookResult = ReturnType<typeof useGetCompetitorInsightsLazyQuery>;
export type GetCompetitorInsightsQueryResult = Apollo.QueryResult<GetCompetitorInsightsQuery, GetCompetitorInsightsQueryVariables>;
export const GetCompetitorContentDocument = gql`
    query GetCompetitorContent($accountId: String!, $limit: Int, $sortBy: String) {
  getCompetitorContent(accountId: $accountId, limit: $limit, sortBy: $sortBy) {
    id
    platform
    contentId
    contentType
    caption
    contentUrl
    thumbnailUrl
    likes
    comments
    shares
    views
    saves
    hashtags
    mentions
    contentThemes
    engagementRate
    isTopPerformer
    performanceScore
    postedAt
    fbLikeCount
    fbPlayCount
    videoDuration
    hasAudio
  }
}
    `;

/**
 * __useGetCompetitorContentQuery__
 *
 * To run a query within a React component, call `useGetCompetitorContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorContentQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetCompetitorContentQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorContentQuery, GetCompetitorContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorContentQuery, GetCompetitorContentQueryVariables>(GetCompetitorContentDocument, options);
      }
export function useGetCompetitorContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorContentQuery, GetCompetitorContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorContentQuery, GetCompetitorContentQueryVariables>(GetCompetitorContentDocument, options);
        }
export type GetCompetitorContentQueryHookResult = ReturnType<typeof useGetCompetitorContentQuery>;
export type GetCompetitorContentLazyQueryHookResult = ReturnType<typeof useGetCompetitorContentLazyQuery>;
export type GetCompetitorContentQueryResult = Apollo.QueryResult<GetCompetitorContentQuery, GetCompetitorContentQueryVariables>;
export const CreateCampaignDocument = gql`
    mutation CreateCampaign($name: String!, $hitsPerDay: Int!, $platforms: [Platform!]!, $queryTree: String, $similarSearching: Boolean, $followersInfo: FollowersFilterInfo!, $campaignType: CampaignType, $competitorConfig: CompetitorConfigInput, $competitorAccounts: [CompetitorAccountInput!], $userAccounts: [UserAccountSelectionInput!]) {
  campaignCreate(
    name: $name
    hitsPerDay: $hitsPerDay
    platforms: $platforms
    queryTree: $queryTree
    similarSearching: $similarSearching
    followersInfo: $followersInfo
    campaignType: $campaignType
    competitorConfig: $competitorConfig
    competitorAccounts: $competitorAccounts
    userAccounts: $userAccounts
  ) {
    id
    name
    keywords
    platforms
    type
  }
}
    `;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      name: // value for 'name'
 *      hitsPerDay: // value for 'hitsPerDay'
 *      platforms: // value for 'platforms'
 *      queryTree: // value for 'queryTree'
 *      similarSearching: // value for 'similarSearching'
 *      followersInfo: // value for 'followersInfo'
 *      campaignType: // value for 'campaignType'
 *      competitorConfig: // value for 'competitorConfig'
 *      competitorAccounts: // value for 'competitorAccounts'
 *      userAccounts: // value for 'userAccounts'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const CampaignDeleteDocument = gql`
    mutation CampaignDelete($campaignDeleteId: ID!) {
  campaignDelete(id: $campaignDeleteId)
}
    `;
export type CampaignDeleteMutationFn = Apollo.MutationFunction<CampaignDeleteMutation, CampaignDeleteMutationVariables>;

/**
 * __useCampaignDeleteMutation__
 *
 * To run a mutation, you first call `useCampaignDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDeleteMutation, { data, loading, error }] = useCampaignDeleteMutation({
 *   variables: {
 *      campaignDeleteId: // value for 'campaignDeleteId'
 *   },
 * });
 */
export function useCampaignDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDeleteMutation, CampaignDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDeleteMutation, CampaignDeleteMutationVariables>(CampaignDeleteDocument, options);
      }
export type CampaignDeleteMutationHookResult = ReturnType<typeof useCampaignDeleteMutation>;
export type CampaignDeleteMutationResult = Apollo.MutationResult<CampaignDeleteMutation>;
export type CampaignDeleteMutationOptions = Apollo.BaseMutationOptions<CampaignDeleteMutation, CampaignDeleteMutationVariables>;
export const UpdateCampaignResultsDocument = gql`
    mutation UpdateCampaignResults($platforms: [Platform!]!, $queryTree: String!, $searchRequiermentID: Int!, $maxHits: Int!) {
  updateCampaignResults(
    platforms: $platforms
    queryTree: $queryTree
    searchRequiermentID: $searchRequiermentID
    maxHits: $maxHits
  )
}
    `;
export type UpdateCampaignResultsMutationFn = Apollo.MutationFunction<UpdateCampaignResultsMutation, UpdateCampaignResultsMutationVariables>;

/**
 * __useUpdateCampaignResultsMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignResultsMutation, { data, loading, error }] = useUpdateCampaignResultsMutation({
 *   variables: {
 *      platforms: // value for 'platforms'
 *      queryTree: // value for 'queryTree'
 *      searchRequiermentID: // value for 'searchRequiermentID'
 *      maxHits: // value for 'maxHits'
 *   },
 * });
 */
export function useUpdateCampaignResultsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignResultsMutation, UpdateCampaignResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignResultsMutation, UpdateCampaignResultsMutationVariables>(UpdateCampaignResultsDocument, options);
      }
export type UpdateCampaignResultsMutationHookResult = ReturnType<typeof useUpdateCampaignResultsMutation>;
export type UpdateCampaignResultsMutationResult = Apollo.MutationResult<UpdateCampaignResultsMutation>;
export type UpdateCampaignResultsMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignResultsMutation, UpdateCampaignResultsMutationVariables>;
export const InteractedWithHitDocument = gql`
    mutation InteractedWithHit($campaignId: ID!, $hitId: String!) {
  interactedWithHit(campaignId: $campaignId, hitId: $hitId)
}
    `;
export type InteractedWithHitMutationFn = Apollo.MutationFunction<InteractedWithHitMutation, InteractedWithHitMutationVariables>;

/**
 * __useInteractedWithHitMutation__
 *
 * To run a mutation, you first call `useInteractedWithHitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInteractedWithHitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interactedWithHitMutation, { data, loading, error }] = useInteractedWithHitMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      hitId: // value for 'hitId'
 *   },
 * });
 */
export function useInteractedWithHitMutation(baseOptions?: Apollo.MutationHookOptions<InteractedWithHitMutation, InteractedWithHitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InteractedWithHitMutation, InteractedWithHitMutationVariables>(InteractedWithHitDocument, options);
      }
export type InteractedWithHitMutationHookResult = ReturnType<typeof useInteractedWithHitMutation>;
export type InteractedWithHitMutationResult = Apollo.MutationResult<InteractedWithHitMutation>;
export type InteractedWithHitMutationOptions = Apollo.BaseMutationOptions<InteractedWithHitMutation, InteractedWithHitMutationVariables>;
export const ArchiveHitDocument = gql`
    mutation ArchiveHit($campaignId: ID!, $hitId: String!) {
  archiveHit(campaignId: $campaignId, hitId: $hitId)
}
    `;
export type ArchiveHitMutationFn = Apollo.MutationFunction<ArchiveHitMutation, ArchiveHitMutationVariables>;

/**
 * __useArchiveHitMutation__
 *
 * To run a mutation, you first call `useArchiveHitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveHitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveHitMutation, { data, loading, error }] = useArchiveHitMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      hitId: // value for 'hitId'
 *   },
 * });
 */
export function useArchiveHitMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveHitMutation, ArchiveHitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveHitMutation, ArchiveHitMutationVariables>(ArchiveHitDocument, options);
      }
export type ArchiveHitMutationHookResult = ReturnType<typeof useArchiveHitMutation>;
export type ArchiveHitMutationResult = Apollo.MutationResult<ArchiveHitMutation>;
export type ArchiveHitMutationOptions = Apollo.BaseMutationOptions<ArchiveHitMutation, ArchiveHitMutationVariables>;
export const AddCompetitorDocument = gql`
    mutation AddCompetitor($configId: String!, $platform: Platform!, $username: String!) {
  addCompetitor(configId: $configId, platform: $platform, username: $username) {
    id
    username
    platform
    displayName
    avatarUrl
    isActive
  }
}
    `;
export type AddCompetitorMutationFn = Apollo.MutationFunction<AddCompetitorMutation, AddCompetitorMutationVariables>;

/**
 * __useAddCompetitorMutation__
 *
 * To run a mutation, you first call `useAddCompetitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompetitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompetitorMutation, { data, loading, error }] = useAddCompetitorMutation({
 *   variables: {
 *      configId: // value for 'configId'
 *      platform: // value for 'platform'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useAddCompetitorMutation(baseOptions?: Apollo.MutationHookOptions<AddCompetitorMutation, AddCompetitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompetitorMutation, AddCompetitorMutationVariables>(AddCompetitorDocument, options);
      }
export type AddCompetitorMutationHookResult = ReturnType<typeof useAddCompetitorMutation>;
export type AddCompetitorMutationResult = Apollo.MutationResult<AddCompetitorMutation>;
export type AddCompetitorMutationOptions = Apollo.BaseMutationOptions<AddCompetitorMutation, AddCompetitorMutationVariables>;
export const RemoveCompetitorDocument = gql`
    mutation RemoveCompetitor($accountId: String!) {
  removeCompetitor(accountId: $accountId)
}
    `;
export type RemoveCompetitorMutationFn = Apollo.MutationFunction<RemoveCompetitorMutation, RemoveCompetitorMutationVariables>;

/**
 * __useRemoveCompetitorMutation__
 *
 * To run a mutation, you first call `useRemoveCompetitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompetitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompetitorMutation, { data, loading, error }] = useRemoveCompetitorMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRemoveCompetitorMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompetitorMutation, RemoveCompetitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompetitorMutation, RemoveCompetitorMutationVariables>(RemoveCompetitorDocument, options);
      }
export type RemoveCompetitorMutationHookResult = ReturnType<typeof useRemoveCompetitorMutation>;
export type RemoveCompetitorMutationResult = Apollo.MutationResult<RemoveCompetitorMutation>;
export type RemoveCompetitorMutationOptions = Apollo.BaseMutationOptions<RemoveCompetitorMutation, RemoveCompetitorMutationVariables>;
export const RefreshCompetitorDocument = gql`
    mutation RefreshCompetitor($accountId: String!) {
  refreshCompetitor(accountId: $accountId) {
    id
    username
    lastScraped
  }
}
    `;
export type RefreshCompetitorMutationFn = Apollo.MutationFunction<RefreshCompetitorMutation, RefreshCompetitorMutationVariables>;

/**
 * __useRefreshCompetitorMutation__
 *
 * To run a mutation, you first call `useRefreshCompetitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCompetitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCompetitorMutation, { data, loading, error }] = useRefreshCompetitorMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRefreshCompetitorMutation(baseOptions?: Apollo.MutationHookOptions<RefreshCompetitorMutation, RefreshCompetitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshCompetitorMutation, RefreshCompetitorMutationVariables>(RefreshCompetitorDocument, options);
      }
export type RefreshCompetitorMutationHookResult = ReturnType<typeof useRefreshCompetitorMutation>;
export type RefreshCompetitorMutationResult = Apollo.MutationResult<RefreshCompetitorMutation>;
export type RefreshCompetitorMutationOptions = Apollo.BaseMutationOptions<RefreshCompetitorMutation, RefreshCompetitorMutationVariables>;
export const RefreshAllCompetitorsDocument = gql`
    mutation RefreshAllCompetitors($configId: String!) {
  refreshAllCompetitors(configId: $configId)
}
    `;
export type RefreshAllCompetitorsMutationFn = Apollo.MutationFunction<RefreshAllCompetitorsMutation, RefreshAllCompetitorsMutationVariables>;

/**
 * __useRefreshAllCompetitorsMutation__
 *
 * To run a mutation, you first call `useRefreshAllCompetitorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAllCompetitorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAllCompetitorsMutation, { data, loading, error }] = useRefreshAllCompetitorsMutation({
 *   variables: {
 *      configId: // value for 'configId'
 *   },
 * });
 */
export function useRefreshAllCompetitorsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshAllCompetitorsMutation, RefreshAllCompetitorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshAllCompetitorsMutation, RefreshAllCompetitorsMutationVariables>(RefreshAllCompetitorsDocument, options);
      }
export type RefreshAllCompetitorsMutationHookResult = ReturnType<typeof useRefreshAllCompetitorsMutation>;
export type RefreshAllCompetitorsMutationResult = Apollo.MutationResult<RefreshAllCompetitorsMutation>;
export type RefreshAllCompetitorsMutationOptions = Apollo.BaseMutationOptions<RefreshAllCompetitorsMutation, RefreshAllCompetitorsMutationVariables>;
export const DismissInsightDocument = gql`
    mutation DismissInsight($insightId: String!) {
  dismissInsight(insightId: $insightId)
}
    `;
export type DismissInsightMutationFn = Apollo.MutationFunction<DismissInsightMutation, DismissInsightMutationVariables>;

/**
 * __useDismissInsightMutation__
 *
 * To run a mutation, you first call `useDismissInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissInsightMutation, { data, loading, error }] = useDismissInsightMutation({
 *   variables: {
 *      insightId: // value for 'insightId'
 *   },
 * });
 */
export function useDismissInsightMutation(baseOptions?: Apollo.MutationHookOptions<DismissInsightMutation, DismissInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissInsightMutation, DismissInsightMutationVariables>(DismissInsightDocument, options);
      }
export type DismissInsightMutationHookResult = ReturnType<typeof useDismissInsightMutation>;
export type DismissInsightMutationResult = Apollo.MutationResult<DismissInsightMutation>;
export type DismissInsightMutationOptions = Apollo.BaseMutationOptions<DismissInsightMutation, DismissInsightMutationVariables>;
export const ToggleCompetitorActiveDocument = gql`
    mutation ToggleCompetitorActive($accountId: String!) {
  toggleCompetitorActive(accountId: $accountId) {
    id
    isActive
  }
}
    `;
export type ToggleCompetitorActiveMutationFn = Apollo.MutationFunction<ToggleCompetitorActiveMutation, ToggleCompetitorActiveMutationVariables>;

/**
 * __useToggleCompetitorActiveMutation__
 *
 * To run a mutation, you first call `useToggleCompetitorActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCompetitorActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCompetitorActiveMutation, { data, loading, error }] = useToggleCompetitorActiveMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useToggleCompetitorActiveMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCompetitorActiveMutation, ToggleCompetitorActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCompetitorActiveMutation, ToggleCompetitorActiveMutationVariables>(ToggleCompetitorActiveDocument, options);
      }
export type ToggleCompetitorActiveMutationHookResult = ReturnType<typeof useToggleCompetitorActiveMutation>;
export type ToggleCompetitorActiveMutationResult = Apollo.MutationResult<ToggleCompetitorActiveMutation>;
export type ToggleCompetitorActiveMutationOptions = Apollo.BaseMutationOptions<ToggleCompetitorActiveMutation, ToggleCompetitorActiveMutationVariables>;
export const GetChatHistoryDocument = gql`
    query GetChatHistory($sessionId: String!) {
  getChatHistory(sessionId: $sessionId) {
    role
    content
  }
}
    `;

/**
 * __useGetChatHistoryQuery__
 *
 * To run a query within a React component, call `useGetChatHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatHistoryQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetChatHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetChatHistoryQuery, GetChatHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatHistoryQuery, GetChatHistoryQueryVariables>(GetChatHistoryDocument, options);
      }
export function useGetChatHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatHistoryQuery, GetChatHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatHistoryQuery, GetChatHistoryQueryVariables>(GetChatHistoryDocument, options);
        }
export type GetChatHistoryQueryHookResult = ReturnType<typeof useGetChatHistoryQuery>;
export type GetChatHistoryLazyQueryHookResult = ReturnType<typeof useGetChatHistoryLazyQuery>;
export type GetChatHistoryQueryResult = Apollo.QueryResult<GetChatHistoryQuery, GetChatHistoryQueryVariables>;
export const ChatDocument = gql`
    mutation Chat($input: ChatInput!) {
  chat(input: $input) {
    sessionId
    response
    extractedData {
      name
      keywords
      platforms
      maxHits
      similarSearching
      followersInfo {
        operator
        from
        to
      }
      isComplete
    }
    canCreateCampaign
  }
}
    `;
export type ChatMutationFn = Apollo.MutationFunction<ChatMutation, ChatMutationVariables>;

/**
 * __useChatMutation__
 *
 * To run a mutation, you first call `useChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatMutation, { data, loading, error }] = useChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatMutation(baseOptions?: Apollo.MutationHookOptions<ChatMutation, ChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatMutation, ChatMutationVariables>(ChatDocument, options);
      }
export type ChatMutationHookResult = ReturnType<typeof useChatMutation>;
export type ChatMutationResult = Apollo.MutationResult<ChatMutation>;
export type ChatMutationOptions = Apollo.BaseMutationOptions<ChatMutation, ChatMutationVariables>;
export const CreateCampaignFromChatDocument = gql`
    mutation CreateCampaignFromChat($sessionId: String!) {
  createCampaignFromChat(sessionId: $sessionId) {
    id
    name
    keywords
    platforms
  }
}
    `;
export type CreateCampaignFromChatMutationFn = Apollo.MutationFunction<CreateCampaignFromChatMutation, CreateCampaignFromChatMutationVariables>;

/**
 * __useCreateCampaignFromChatMutation__
 *
 * To run a mutation, you first call `useCreateCampaignFromChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignFromChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignFromChatMutation, { data, loading, error }] = useCreateCampaignFromChatMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useCreateCampaignFromChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignFromChatMutation, CreateCampaignFromChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignFromChatMutation, CreateCampaignFromChatMutationVariables>(CreateCampaignFromChatDocument, options);
      }
export type CreateCampaignFromChatMutationHookResult = ReturnType<typeof useCreateCampaignFromChatMutation>;
export type CreateCampaignFromChatMutationResult = Apollo.MutationResult<CreateCampaignFromChatMutation>;
export type CreateCampaignFromChatMutationOptions = Apollo.BaseMutationOptions<CreateCampaignFromChatMutation, CreateCampaignFromChatMutationVariables>;
export const ClearChatSessionDocument = gql`
    mutation ClearChatSession($sessionId: String!) {
  clearChatSession(sessionId: $sessionId)
}
    `;
export type ClearChatSessionMutationFn = Apollo.MutationFunction<ClearChatSessionMutation, ClearChatSessionMutationVariables>;

/**
 * __useClearChatSessionMutation__
 *
 * To run a mutation, you first call `useClearChatSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearChatSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearChatSessionMutation, { data, loading, error }] = useClearChatSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useClearChatSessionMutation(baseOptions?: Apollo.MutationHookOptions<ClearChatSessionMutation, ClearChatSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearChatSessionMutation, ClearChatSessionMutationVariables>(ClearChatSessionDocument, options);
      }
export type ClearChatSessionMutationHookResult = ReturnType<typeof useClearChatSessionMutation>;
export type ClearChatSessionMutationResult = Apollo.MutationResult<ClearChatSessionMutation>;
export type ClearChatSessionMutationOptions = Apollo.BaseMutationOptions<ClearChatSessionMutation, ClearChatSessionMutationVariables>;
export const GetDashboardMetricsDocument = gql`
    query GetDashboardMetrics {
  getDashboardMetrics {
    totalEngagement
    totalLikes
    totalComments
    totalShares
    totalHits
    avgEngagementPerPost
    engagementRate
    platformBreakdown {
      platform
      totalHits
      totalLikes
      totalComments
      totalShares
      avgEngagement
    }
  }
}
    `;

/**
 * __useGetDashboardMetricsQuery__
 *
 * To run a query within a React component, call `useGetDashboardMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardMetricsQuery, GetDashboardMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardMetricsQuery, GetDashboardMetricsQueryVariables>(GetDashboardMetricsDocument, options);
      }
export function useGetDashboardMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardMetricsQuery, GetDashboardMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardMetricsQuery, GetDashboardMetricsQueryVariables>(GetDashboardMetricsDocument, options);
        }
export type GetDashboardMetricsQueryHookResult = ReturnType<typeof useGetDashboardMetricsQuery>;
export type GetDashboardMetricsLazyQueryHookResult = ReturnType<typeof useGetDashboardMetricsLazyQuery>;
export type GetDashboardMetricsQueryResult = Apollo.QueryResult<GetDashboardMetricsQuery, GetDashboardMetricsQueryVariables>;
export const SyncPostEngagementDocument = gql`
    mutation SyncPostEngagement {
  syncPostEngagement {
    platform
    accountName
    postsSynced
    lastSynced
  }
}
    `;
export type SyncPostEngagementMutationFn = Apollo.MutationFunction<SyncPostEngagementMutation, SyncPostEngagementMutationVariables>;

/**
 * __useSyncPostEngagementMutation__
 *
 * To run a mutation, you first call `useSyncPostEngagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPostEngagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPostEngagementMutation, { data, loading, error }] = useSyncPostEngagementMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncPostEngagementMutation(baseOptions?: Apollo.MutationHookOptions<SyncPostEngagementMutation, SyncPostEngagementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPostEngagementMutation, SyncPostEngagementMutationVariables>(SyncPostEngagementDocument, options);
      }
export type SyncPostEngagementMutationHookResult = ReturnType<typeof useSyncPostEngagementMutation>;
export type SyncPostEngagementMutationResult = Apollo.MutationResult<SyncPostEngagementMutation>;
export type SyncPostEngagementMutationOptions = Apollo.BaseMutationOptions<SyncPostEngagementMutation, SyncPostEngagementMutationVariables>;
export const GetUserEngagementMetricsDocument = gql`
    query GetUserEngagementMetrics {
  getUserEngagementMetrics {
    totalPosts
    totalLikes
    totalComments
    totalShares
    totalViews
    avgEngagementPerPost
    avgLikesPerPost
    avgCommentsPerPost
    platformBreakdown {
      platform
      totalPosts
      totalLikes
      totalComments
      totalShares
      totalViews
      avgEngagement
    }
  }
}
    `;

/**
 * __useGetUserEngagementMetricsQuery__
 *
 * To run a query within a React component, call `useGetUserEngagementMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEngagementMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEngagementMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserEngagementMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserEngagementMetricsQuery, GetUserEngagementMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEngagementMetricsQuery, GetUserEngagementMetricsQueryVariables>(GetUserEngagementMetricsDocument, options);
      }
export function useGetUserEngagementMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEngagementMetricsQuery, GetUserEngagementMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEngagementMetricsQuery, GetUserEngagementMetricsQueryVariables>(GetUserEngagementMetricsDocument, options);
        }
export type GetUserEngagementMetricsQueryHookResult = ReturnType<typeof useGetUserEngagementMetricsQuery>;
export type GetUserEngagementMetricsLazyQueryHookResult = ReturnType<typeof useGetUserEngagementMetricsLazyQuery>;
export type GetUserEngagementMetricsQueryResult = Apollo.QueryResult<GetUserEngagementMetricsQuery, GetUserEngagementMetricsQueryVariables>;
export const GetEngagementTimeSeriesDocument = gql`
    query GetEngagementTimeSeries($granularity: TimeSeriesGranularity!, $limit: Int) {
  getEngagementTimeSeries(granularity: $granularity, limit: $limit) {
    granularity
    dataPoints {
      period
      periodStart
      periodEnd
      totalPosts
      totalLikes
      totalComments
      totalShares
      totalViews
      avgEngagement
    }
  }
}
    `;

/**
 * __useGetEngagementTimeSeriesQuery__
 *
 * To run a query within a React component, call `useGetEngagementTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementTimeSeriesQuery({
 *   variables: {
 *      granularity: // value for 'granularity'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetEngagementTimeSeriesQuery(baseOptions: Apollo.QueryHookOptions<GetEngagementTimeSeriesQuery, GetEngagementTimeSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEngagementTimeSeriesQuery, GetEngagementTimeSeriesQueryVariables>(GetEngagementTimeSeriesDocument, options);
      }
export function useGetEngagementTimeSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEngagementTimeSeriesQuery, GetEngagementTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEngagementTimeSeriesQuery, GetEngagementTimeSeriesQueryVariables>(GetEngagementTimeSeriesDocument, options);
        }
export type GetEngagementTimeSeriesQueryHookResult = ReturnType<typeof useGetEngagementTimeSeriesQuery>;
export type GetEngagementTimeSeriesLazyQueryHookResult = ReturnType<typeof useGetEngagementTimeSeriesLazyQuery>;
export type GetEngagementTimeSeriesQueryResult = Apollo.QueryResult<GetEngagementTimeSeriesQuery, GetEngagementTimeSeriesQueryVariables>;
export const GetFollowerAnalyticsDocument = gql`
    query GetFollowerAnalytics($timeRange: String!) {
  getFollowerAnalytics(timeRange: $timeRange) {
    accounts {
      id
      platform
      username
      displayName
      currentFollowerCount
      totalUnfollows
      totalNewFollows
      lastSnapshotAt
      isActive
    }
    snapshots {
      id
      accountId
      platform
      followerCount
      newFollowers
      unfollowers
      netChange
      snapshotAt
    }
    recentFollowers {
      id
      username
      displayName
      avatarUrl
      platform
      followedAt
    }
    recentUnfollowers {
      id
      username
      displayName
      avatarUrl
      platform
      unfollowedAt
    }
    summary {
      totalFollowers
      totalGained
      totalLost
      netChange
      growthRate
    }
  }
}
    `;

/**
 * __useGetFollowerAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetFollowerAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowerAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowerAnalyticsQuery({
 *   variables: {
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useGetFollowerAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetFollowerAnalyticsQuery, GetFollowerAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFollowerAnalyticsQuery, GetFollowerAnalyticsQueryVariables>(GetFollowerAnalyticsDocument, options);
      }
export function useGetFollowerAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFollowerAnalyticsQuery, GetFollowerAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFollowerAnalyticsQuery, GetFollowerAnalyticsQueryVariables>(GetFollowerAnalyticsDocument, options);
        }
export type GetFollowerAnalyticsQueryHookResult = ReturnType<typeof useGetFollowerAnalyticsQuery>;
export type GetFollowerAnalyticsLazyQueryHookResult = ReturnType<typeof useGetFollowerAnalyticsLazyQuery>;
export type GetFollowerAnalyticsQueryResult = Apollo.QueryResult<GetFollowerAnalyticsQuery, GetFollowerAnalyticsQueryVariables>;
export const EnableFollowerTrackingDocument = gql`
    mutation EnableFollowerTracking($snapshotFrequency: Int, $retentionDays: Int) {
  enableFollowerTracking(
    snapshotFrequency: $snapshotFrequency
    retentionDays: $retentionDays
  ) {
    success
    message
    tracking {
      id
      trackingEnabled
      snapshotFrequency
      retentionDays
    }
  }
}
    `;
export type EnableFollowerTrackingMutationFn = Apollo.MutationFunction<EnableFollowerTrackingMutation, EnableFollowerTrackingMutationVariables>;

/**
 * __useEnableFollowerTrackingMutation__
 *
 * To run a mutation, you first call `useEnableFollowerTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableFollowerTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableFollowerTrackingMutation, { data, loading, error }] = useEnableFollowerTrackingMutation({
 *   variables: {
 *      snapshotFrequency: // value for 'snapshotFrequency'
 *      retentionDays: // value for 'retentionDays'
 *   },
 * });
 */
export function useEnableFollowerTrackingMutation(baseOptions?: Apollo.MutationHookOptions<EnableFollowerTrackingMutation, EnableFollowerTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableFollowerTrackingMutation, EnableFollowerTrackingMutationVariables>(EnableFollowerTrackingDocument, options);
      }
export type EnableFollowerTrackingMutationHookResult = ReturnType<typeof useEnableFollowerTrackingMutation>;
export type EnableFollowerTrackingMutationResult = Apollo.MutationResult<EnableFollowerTrackingMutation>;
export type EnableFollowerTrackingMutationOptions = Apollo.BaseMutationOptions<EnableFollowerTrackingMutation, EnableFollowerTrackingMutationVariables>;
export const DisableFollowerTrackingDocument = gql`
    mutation DisableFollowerTracking {
  disableFollowerTracking {
    success
    message
  }
}
    `;
export type DisableFollowerTrackingMutationFn = Apollo.MutationFunction<DisableFollowerTrackingMutation, DisableFollowerTrackingMutationVariables>;

/**
 * __useDisableFollowerTrackingMutation__
 *
 * To run a mutation, you first call `useDisableFollowerTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableFollowerTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableFollowerTrackingMutation, { data, loading, error }] = useDisableFollowerTrackingMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableFollowerTrackingMutation(baseOptions?: Apollo.MutationHookOptions<DisableFollowerTrackingMutation, DisableFollowerTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableFollowerTrackingMutation, DisableFollowerTrackingMutationVariables>(DisableFollowerTrackingDocument, options);
      }
export type DisableFollowerTrackingMutationHookResult = ReturnType<typeof useDisableFollowerTrackingMutation>;
export type DisableFollowerTrackingMutationResult = Apollo.MutationResult<DisableFollowerTrackingMutation>;
export type DisableFollowerTrackingMutationOptions = Apollo.BaseMutationOptions<DisableFollowerTrackingMutation, DisableFollowerTrackingMutationVariables>;
export const SyncFollowerCountsTrackingDocument = gql`
    mutation SyncFollowerCountsTracking {
  syncFollowerCountsTracking {
    platform
    accountName
    followerCount
    success
    error
  }
}
    `;
export type SyncFollowerCountsTrackingMutationFn = Apollo.MutationFunction<SyncFollowerCountsTrackingMutation, SyncFollowerCountsTrackingMutationVariables>;

/**
 * __useSyncFollowerCountsTrackingMutation__
 *
 * To run a mutation, you first call `useSyncFollowerCountsTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncFollowerCountsTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncFollowerCountsTrackingMutation, { data, loading, error }] = useSyncFollowerCountsTrackingMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncFollowerCountsTrackingMutation(baseOptions?: Apollo.MutationHookOptions<SyncFollowerCountsTrackingMutation, SyncFollowerCountsTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncFollowerCountsTrackingMutation, SyncFollowerCountsTrackingMutationVariables>(SyncFollowerCountsTrackingDocument, options);
      }
export type SyncFollowerCountsTrackingMutationHookResult = ReturnType<typeof useSyncFollowerCountsTrackingMutation>;
export type SyncFollowerCountsTrackingMutationResult = Apollo.MutationResult<SyncFollowerCountsTrackingMutation>;
export type SyncFollowerCountsTrackingMutationOptions = Apollo.BaseMutationOptions<SyncFollowerCountsTrackingMutation, SyncFollowerCountsTrackingMutationVariables>;
export const SyncFollowerTrackingAccountsDocument = gql`
    mutation SyncFollowerTrackingAccounts {
  syncFollowerTrackingAccounts {
    added
    removed
    unchanged
    message
  }
}
    `;
export type SyncFollowerTrackingAccountsMutationFn = Apollo.MutationFunction<SyncFollowerTrackingAccountsMutation, SyncFollowerTrackingAccountsMutationVariables>;

/**
 * __useSyncFollowerTrackingAccountsMutation__
 *
 * To run a mutation, you first call `useSyncFollowerTrackingAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncFollowerTrackingAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncFollowerTrackingAccountsMutation, { data, loading, error }] = useSyncFollowerTrackingAccountsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncFollowerTrackingAccountsMutation(baseOptions?: Apollo.MutationHookOptions<SyncFollowerTrackingAccountsMutation, SyncFollowerTrackingAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncFollowerTrackingAccountsMutation, SyncFollowerTrackingAccountsMutationVariables>(SyncFollowerTrackingAccountsDocument, options);
      }
export type SyncFollowerTrackingAccountsMutationHookResult = ReturnType<typeof useSyncFollowerTrackingAccountsMutation>;
export type SyncFollowerTrackingAccountsMutationResult = Apollo.MutationResult<SyncFollowerTrackingAccountsMutation>;
export type SyncFollowerTrackingAccountsMutationOptions = Apollo.BaseMutationOptions<SyncFollowerTrackingAccountsMutation, SyncFollowerTrackingAccountsMutationVariables>;
export const GetHitsDocument = gql`
    query GetHits($filter: HitFilter!, $pagination: Pagination, $sort: Sort) {
  hits(filter: $filter, pagination: $pagination, sort: $sort) {
    hits {
      uq_index
      id
      name
      markedUnhelpful
      campaignId
      content
      platforms
      keywords
      campaignName
      date
      thumbnail
      videoUrl
      postURL
      summary
      generateCount
      creator {
        name
        avatarUrl
      }
      interaction {
        positive
        shared
        followers
        tag
        following
        postCount
        bio
        verified
        comment
      }
      interactedWith
    }
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useGetHitsQuery__
 *
 * To run a query within a React component, call `useGetHitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHitsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetHitsQuery(baseOptions: Apollo.QueryHookOptions<GetHitsQuery, GetHitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHitsQuery, GetHitsQueryVariables>(GetHitsDocument, options);
      }
export function useGetHitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHitsQuery, GetHitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHitsQuery, GetHitsQueryVariables>(GetHitsDocument, options);
        }
export type GetHitsQueryHookResult = ReturnType<typeof useGetHitsQuery>;
export type GetHitsLazyQueryHookResult = ReturnType<typeof useGetHitsLazyQuery>;
export type GetHitsQueryResult = Apollo.QueryResult<GetHitsQuery, GetHitsQueryVariables>;
export const GetScrapingStatusDocument = gql`
    query getScrapingStatus($filter: ScrapingFilter!) {
  scraping(filter: $filter) {
    instagram
    youtube
    reddit
    tiktok
    facebook
  }
}
    `;

/**
 * __useGetScrapingStatusQuery__
 *
 * To run a query within a React component, call `useGetScrapingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScrapingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScrapingStatusQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetScrapingStatusQuery(baseOptions: Apollo.QueryHookOptions<GetScrapingStatusQuery, GetScrapingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScrapingStatusQuery, GetScrapingStatusQueryVariables>(GetScrapingStatusDocument, options);
      }
export function useGetScrapingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScrapingStatusQuery, GetScrapingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScrapingStatusQuery, GetScrapingStatusQueryVariables>(GetScrapingStatusDocument, options);
        }
export type GetScrapingStatusQueryHookResult = ReturnType<typeof useGetScrapingStatusQuery>;
export type GetScrapingStatusLazyQueryHookResult = ReturnType<typeof useGetScrapingStatusLazyQuery>;
export type GetScrapingStatusQueryResult = Apollo.QueryResult<GetScrapingStatusQuery, GetScrapingStatusQueryVariables>;
export const GetHitsVolumeDocument = gql`
    query getHitsVolume {
  getHitsVolume {
    hitsVolume {
      date
      data {
        platform
        count
      }
    }
    campaignsVolume {
      platform
      data {
        campaignName
        hits
      }
    }
  }
}
    `;

/**
 * __useGetHitsVolumeQuery__
 *
 * To run a query within a React component, call `useGetHitsVolumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHitsVolumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHitsVolumeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHitsVolumeQuery(baseOptions?: Apollo.QueryHookOptions<GetHitsVolumeQuery, GetHitsVolumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHitsVolumeQuery, GetHitsVolumeQueryVariables>(GetHitsVolumeDocument, options);
      }
export function useGetHitsVolumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHitsVolumeQuery, GetHitsVolumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHitsVolumeQuery, GetHitsVolumeQueryVariables>(GetHitsVolumeDocument, options);
        }
export type GetHitsVolumeQueryHookResult = ReturnType<typeof useGetHitsVolumeQuery>;
export type GetHitsVolumeLazyQueryHookResult = ReturnType<typeof useGetHitsVolumeLazyQuery>;
export type GetHitsVolumeQueryResult = Apollo.QueryResult<GetHitsVolumeQuery, GetHitsVolumeQueryVariables>;
export const CreateHitGenerationDocument = gql`
    mutation CreateHitGeneration($campaignId: Int!, $hitsId: String!, $count: Int!) {
  createHitGeneration(campaignId: $campaignId, hitsId: $hitsId, count: $count)
}
    `;
export type CreateHitGenerationMutationFn = Apollo.MutationFunction<CreateHitGenerationMutation, CreateHitGenerationMutationVariables>;

/**
 * __useCreateHitGenerationMutation__
 *
 * To run a mutation, you first call `useCreateHitGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHitGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHitGenerationMutation, { data, loading, error }] = useCreateHitGenerationMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      hitsId: // value for 'hitsId'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useCreateHitGenerationMutation(baseOptions?: Apollo.MutationHookOptions<CreateHitGenerationMutation, CreateHitGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHitGenerationMutation, CreateHitGenerationMutationVariables>(CreateHitGenerationDocument, options);
      }
export type CreateHitGenerationMutationHookResult = ReturnType<typeof useCreateHitGenerationMutation>;
export type CreateHitGenerationMutationResult = Apollo.MutationResult<CreateHitGenerationMutation>;
export type CreateHitGenerationMutationOptions = Apollo.BaseMutationOptions<CreateHitGenerationMutation, CreateHitGenerationMutationVariables>;
export const BulkGenerateSummaryDocument = gql`
    mutation BulkGenerateSummary($campaignId: ID!, $data: String!) {
  bulkGenerateSummary(campaignId: $campaignId, data: $data)
}
    `;
export type BulkGenerateSummaryMutationFn = Apollo.MutationFunction<BulkGenerateSummaryMutation, BulkGenerateSummaryMutationVariables>;

/**
 * __useBulkGenerateSummaryMutation__
 *
 * To run a mutation, you first call `useBulkGenerateSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkGenerateSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkGenerateSummaryMutation, { data, loading, error }] = useBulkGenerateSummaryMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkGenerateSummaryMutation(baseOptions?: Apollo.MutationHookOptions<BulkGenerateSummaryMutation, BulkGenerateSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkGenerateSummaryMutation, BulkGenerateSummaryMutationVariables>(BulkGenerateSummaryDocument, options);
      }
export type BulkGenerateSummaryMutationHookResult = ReturnType<typeof useBulkGenerateSummaryMutation>;
export type BulkGenerateSummaryMutationResult = Apollo.MutationResult<BulkGenerateSummaryMutation>;
export type BulkGenerateSummaryMutationOptions = Apollo.BaseMutationOptions<BulkGenerateSummaryMutation, BulkGenerateSummaryMutationVariables>;
export const GetBulkGenerateSummaryVibeDocument = gql`
    query GetBulkGenerateSummaryVibe($campaignId: Int) {
  getBulkGenerateSummaryVibe(campaignId: $campaignId)
}
    `;

/**
 * __useGetBulkGenerateSummaryVibeQuery__
 *
 * To run a query within a React component, call `useGetBulkGenerateSummaryVibeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkGenerateSummaryVibeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkGenerateSummaryVibeQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetBulkGenerateSummaryVibeQuery(baseOptions?: Apollo.QueryHookOptions<GetBulkGenerateSummaryVibeQuery, GetBulkGenerateSummaryVibeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkGenerateSummaryVibeQuery, GetBulkGenerateSummaryVibeQueryVariables>(GetBulkGenerateSummaryVibeDocument, options);
      }
export function useGetBulkGenerateSummaryVibeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkGenerateSummaryVibeQuery, GetBulkGenerateSummaryVibeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkGenerateSummaryVibeQuery, GetBulkGenerateSummaryVibeQueryVariables>(GetBulkGenerateSummaryVibeDocument, options);
        }
export type GetBulkGenerateSummaryVibeQueryHookResult = ReturnType<typeof useGetBulkGenerateSummaryVibeQuery>;
export type GetBulkGenerateSummaryVibeLazyQueryHookResult = ReturnType<typeof useGetBulkGenerateSummaryVibeLazyQuery>;
export type GetBulkGenerateSummaryVibeQueryResult = Apollo.QueryResult<GetBulkGenerateSummaryVibeQuery, GetBulkGenerateSummaryVibeQueryVariables>;
export const GetVibesDocument = gql`
    query GetVibes($campaignId: Int!) {
  getVibes(campaignId: $campaignId) {
    id
    comment
  }
}
    `;

/**
 * __useGetVibesQuery__
 *
 * To run a query within a React component, call `useGetVibesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVibesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVibesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetVibesQuery(baseOptions: Apollo.QueryHookOptions<GetVibesQuery, GetVibesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVibesQuery, GetVibesQueryVariables>(GetVibesDocument, options);
      }
export function useGetVibesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVibesQuery, GetVibesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVibesQuery, GetVibesQueryVariables>(GetVibesDocument, options);
        }
export type GetVibesQueryHookResult = ReturnType<typeof useGetVibesQuery>;
export type GetVibesLazyQueryHookResult = ReturnType<typeof useGetVibesLazyQuery>;
export type GetVibesQueryResult = Apollo.QueryResult<GetVibesQuery, GetVibesQueryVariables>;
export const CreateVibesDocument = gql`
    mutation createVibes($data: String!) {
  createVibes(data: $data)
}
    `;
export type CreateVibesMutationFn = Apollo.MutationFunction<CreateVibesMutation, CreateVibesMutationVariables>;

/**
 * __useCreateVibesMutation__
 *
 * To run a mutation, you first call `useCreateVibesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVibesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVibesMutation, { data, loading, error }] = useCreateVibesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateVibesMutation(baseOptions?: Apollo.MutationHookOptions<CreateVibesMutation, CreateVibesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVibesMutation, CreateVibesMutationVariables>(CreateVibesDocument, options);
      }
export type CreateVibesMutationHookResult = ReturnType<typeof useCreateVibesMutation>;
export type CreateVibesMutationResult = Apollo.MutationResult<CreateVibesMutation>;
export type CreateVibesMutationOptions = Apollo.BaseMutationOptions<CreateVibesMutation, CreateVibesMutationVariables>;
export const GetAllVibesDocument = gql`
    query GetAllVibes {
  getAllVibes
}
    `;

/**
 * __useGetAllVibesQuery__
 *
 * To run a query within a React component, call `useGetAllVibesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVibesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVibesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllVibesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllVibesQuery, GetAllVibesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllVibesQuery, GetAllVibesQueryVariables>(GetAllVibesDocument, options);
      }
export function useGetAllVibesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllVibesQuery, GetAllVibesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllVibesQuery, GetAllVibesQueryVariables>(GetAllVibesDocument, options);
        }
export type GetAllVibesQueryHookResult = ReturnType<typeof useGetAllVibesQuery>;
export type GetAllVibesLazyQueryHookResult = ReturnType<typeof useGetAllVibesLazyQuery>;
export type GetAllVibesQueryResult = Apollo.QueryResult<GetAllVibesQuery, GetAllVibesQueryVariables>;
export const GetUserMediaDocument = gql`
    query getUserMedia($accountId: Int!, $platform: Platform!) {
  getUserMedia(accountId: $accountId, platform: $platform) {
    media_url
    caption
    timestamp
    id
    media_type
  }
}
    `;

/**
 * __useGetUserMediaQuery__
 *
 * To run a query within a React component, call `useGetUserMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserMediaQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetUserMediaQuery(baseOptions: Apollo.QueryHookOptions<GetUserMediaQuery, GetUserMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserMediaQuery, GetUserMediaQueryVariables>(GetUserMediaDocument, options);
      }
export function useGetUserMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserMediaQuery, GetUserMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserMediaQuery, GetUserMediaQueryVariables>(GetUserMediaDocument, options);
        }
export type GetUserMediaQueryHookResult = ReturnType<typeof useGetUserMediaQuery>;
export type GetUserMediaLazyQueryHookResult = ReturnType<typeof useGetUserMediaLazyQuery>;
export type GetUserMediaQueryResult = Apollo.QueryResult<GetUserMediaQuery, GetUserMediaQueryVariables>;
export const CreateInstagramAutomationToolDocument = gql`
    mutation createInstagramAutomationTool($message: [String!]!, $accountId: Int!, $keyword: String!, $shouldReply: Boolean!, $commentReply: [String!]!, $post_id: String, $title: String!, $platform: Platform) {
  createInstagramAutomationTool(
    message: $message
    accountId: $accountId
    keyword: $keyword
    shouldReply: $shouldReply
    commentReply: $commentReply
    post_id: $post_id
    title: $title
    platform: $platform
  )
}
    `;
export type CreateInstagramAutomationToolMutationFn = Apollo.MutationFunction<CreateInstagramAutomationToolMutation, CreateInstagramAutomationToolMutationVariables>;

/**
 * __useCreateInstagramAutomationToolMutation__
 *
 * To run a mutation, you first call `useCreateInstagramAutomationToolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstagramAutomationToolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstagramAutomationToolMutation, { data, loading, error }] = useCreateInstagramAutomationToolMutation({
 *   variables: {
 *      message: // value for 'message'
 *      accountId: // value for 'accountId'
 *      keyword: // value for 'keyword'
 *      shouldReply: // value for 'shouldReply'
 *      commentReply: // value for 'commentReply'
 *      post_id: // value for 'post_id'
 *      title: // value for 'title'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useCreateInstagramAutomationToolMutation(baseOptions?: Apollo.MutationHookOptions<CreateInstagramAutomationToolMutation, CreateInstagramAutomationToolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInstagramAutomationToolMutation, CreateInstagramAutomationToolMutationVariables>(CreateInstagramAutomationToolDocument, options);
      }
export type CreateInstagramAutomationToolMutationHookResult = ReturnType<typeof useCreateInstagramAutomationToolMutation>;
export type CreateInstagramAutomationToolMutationResult = Apollo.MutationResult<CreateInstagramAutomationToolMutation>;
export type CreateInstagramAutomationToolMutationOptions = Apollo.BaseMutationOptions<CreateInstagramAutomationToolMutation, CreateInstagramAutomationToolMutationVariables>;
export const GetInstagramToolsDocument = gql`
    query getInstagramTools($platform: Platform) {
  getInstagramTools(platform: $platform) {
    id
    message
    keyword
    shouldReply
    commentReply
    status
    triggered
    createdAt
    title
  }
}
    `;

/**
 * __useGetInstagramToolsQuery__
 *
 * To run a query within a React component, call `useGetInstagramToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstagramToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstagramToolsQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetInstagramToolsQuery(baseOptions?: Apollo.QueryHookOptions<GetInstagramToolsQuery, GetInstagramToolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstagramToolsQuery, GetInstagramToolsQueryVariables>(GetInstagramToolsDocument, options);
      }
export function useGetInstagramToolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstagramToolsQuery, GetInstagramToolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstagramToolsQuery, GetInstagramToolsQueryVariables>(GetInstagramToolsDocument, options);
        }
export type GetInstagramToolsQueryHookResult = ReturnType<typeof useGetInstagramToolsQuery>;
export type GetInstagramToolsLazyQueryHookResult = ReturnType<typeof useGetInstagramToolsLazyQuery>;
export type GetInstagramToolsQueryResult = Apollo.QueryResult<GetInstagramToolsQuery, GetInstagramToolsQueryVariables>;
export const ChangeToolStatusDocument = gql`
    mutation changeToolStatus($status: ToolStatus!, $id: Int!) {
  changeToolStatus(status: $status, id: $id)
}
    `;
export type ChangeToolStatusMutationFn = Apollo.MutationFunction<ChangeToolStatusMutation, ChangeToolStatusMutationVariables>;

/**
 * __useChangeToolStatusMutation__
 *
 * To run a mutation, you first call `useChangeToolStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeToolStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeToolStatusMutation, { data, loading, error }] = useChangeToolStatusMutation({
 *   variables: {
 *      status: // value for 'status'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChangeToolStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeToolStatusMutation, ChangeToolStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeToolStatusMutation, ChangeToolStatusMutationVariables>(ChangeToolStatusDocument, options);
      }
export type ChangeToolStatusMutationHookResult = ReturnType<typeof useChangeToolStatusMutation>;
export type ChangeToolStatusMutationResult = Apollo.MutationResult<ChangeToolStatusMutation>;
export type ChangeToolStatusMutationOptions = Apollo.BaseMutationOptions<ChangeToolStatusMutation, ChangeToolStatusMutationVariables>;
export const DeleteInstagramToolDocument = gql`
    mutation deleteInstagramTool($id: Int!) {
  deleteInstagramTool(id: $id)
}
    `;
export type DeleteInstagramToolMutationFn = Apollo.MutationFunction<DeleteInstagramToolMutation, DeleteInstagramToolMutationVariables>;

/**
 * __useDeleteInstagramToolMutation__
 *
 * To run a mutation, you first call `useDeleteInstagramToolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInstagramToolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInstagramToolMutation, { data, loading, error }] = useDeleteInstagramToolMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInstagramToolMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInstagramToolMutation, DeleteInstagramToolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInstagramToolMutation, DeleteInstagramToolMutationVariables>(DeleteInstagramToolDocument, options);
      }
export type DeleteInstagramToolMutationHookResult = ReturnType<typeof useDeleteInstagramToolMutation>;
export type DeleteInstagramToolMutationResult = Apollo.MutationResult<DeleteInstagramToolMutation>;
export type DeleteInstagramToolMutationOptions = Apollo.BaseMutationOptions<DeleteInstagramToolMutation, DeleteInstagramToolMutationVariables>;
export const EditInstagramToolDocument = gql`
    mutation editInstagramTool($id: Int!, $data: EditInstagramToolObject!) {
  editInstagramTool(id: $id, data: $data)
}
    `;
export type EditInstagramToolMutationFn = Apollo.MutationFunction<EditInstagramToolMutation, EditInstagramToolMutationVariables>;

/**
 * __useEditInstagramToolMutation__
 *
 * To run a mutation, you first call `useEditInstagramToolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditInstagramToolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editInstagramToolMutation, { data, loading, error }] = useEditInstagramToolMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEditInstagramToolMutation(baseOptions?: Apollo.MutationHookOptions<EditInstagramToolMutation, EditInstagramToolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditInstagramToolMutation, EditInstagramToolMutationVariables>(EditInstagramToolDocument, options);
      }
export type EditInstagramToolMutationHookResult = ReturnType<typeof useEditInstagramToolMutation>;
export type EditInstagramToolMutationResult = Apollo.MutationResult<EditInstagramToolMutation>;
export type EditInstagramToolMutationOptions = Apollo.BaseMutationOptions<EditInstagramToolMutation, EditInstagramToolMutationVariables>;
export const GetBrandValuesDocument = gql`
    mutation getBrandValues($accountId: Int!) {
  getBrandValues(accountId: $accountId)
}
    `;
export type GetBrandValuesMutationFn = Apollo.MutationFunction<GetBrandValuesMutation, GetBrandValuesMutationVariables>;

/**
 * __useGetBrandValuesMutation__
 *
 * To run a mutation, you first call `useGetBrandValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetBrandValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getBrandValuesMutation, { data, loading, error }] = useGetBrandValuesMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetBrandValuesMutation(baseOptions?: Apollo.MutationHookOptions<GetBrandValuesMutation, GetBrandValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetBrandValuesMutation, GetBrandValuesMutationVariables>(GetBrandValuesDocument, options);
      }
export type GetBrandValuesMutationHookResult = ReturnType<typeof useGetBrandValuesMutation>;
export type GetBrandValuesMutationResult = Apollo.MutationResult<GetBrandValuesMutation>;
export type GetBrandValuesMutationOptions = Apollo.BaseMutationOptions<GetBrandValuesMutation, GetBrandValuesMutationVariables>;
export const BrandValueDocument = gql`
    query BrandValue($platform: Platform!) {
  brandValue(platform: $platform) {
    accountName
    platform
    engagement
    pricePerPost
  }
}
    `;

/**
 * __useBrandValueQuery__
 *
 * To run a query within a React component, call `useBrandValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandValueQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useBrandValueQuery(baseOptions: Apollo.QueryHookOptions<BrandValueQuery, BrandValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandValueQuery, BrandValueQueryVariables>(BrandValueDocument, options);
      }
export function useBrandValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandValueQuery, BrandValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandValueQuery, BrandValueQueryVariables>(BrandValueDocument, options);
        }
export type BrandValueQueryHookResult = ReturnType<typeof useBrandValueQuery>;
export type BrandValueLazyQueryHookResult = ReturnType<typeof useBrandValueLazyQuery>;
export type BrandValueQueryResult = Apollo.QueryResult<BrandValueQuery, BrandValueQueryVariables>;
export const SaveYouTubeApiKeyDocument = gql`
    mutation saveYouTubeApiKey($mediaAccountId: Int!, $apiKey: String!) {
  saveYouTubeApiKey(mediaAccountId: $mediaAccountId, apiKey: $apiKey) {
    success
    message
    hasApiKey
  }
}
    `;
export type SaveYouTubeApiKeyMutationFn = Apollo.MutationFunction<SaveYouTubeApiKeyMutation, SaveYouTubeApiKeyMutationVariables>;

/**
 * __useSaveYouTubeApiKeyMutation__
 *
 * To run a mutation, you first call `useSaveYouTubeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveYouTubeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveYouTubeApiKeyMutation, { data, loading, error }] = useSaveYouTubeApiKeyMutation({
 *   variables: {
 *      mediaAccountId: // value for 'mediaAccountId'
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useSaveYouTubeApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<SaveYouTubeApiKeyMutation, SaveYouTubeApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveYouTubeApiKeyMutation, SaveYouTubeApiKeyMutationVariables>(SaveYouTubeApiKeyDocument, options);
      }
export type SaveYouTubeApiKeyMutationHookResult = ReturnType<typeof useSaveYouTubeApiKeyMutation>;
export type SaveYouTubeApiKeyMutationResult = Apollo.MutationResult<SaveYouTubeApiKeyMutation>;
export type SaveYouTubeApiKeyMutationOptions = Apollo.BaseMutationOptions<SaveYouTubeApiKeyMutation, SaveYouTubeApiKeyMutationVariables>;
export const RemoveYouTubeApiKeyDocument = gql`
    mutation removeYouTubeApiKey($mediaAccountId: Int!) {
  removeYouTubeApiKey(mediaAccountId: $mediaAccountId)
}
    `;
export type RemoveYouTubeApiKeyMutationFn = Apollo.MutationFunction<RemoveYouTubeApiKeyMutation, RemoveYouTubeApiKeyMutationVariables>;

/**
 * __useRemoveYouTubeApiKeyMutation__
 *
 * To run a mutation, you first call `useRemoveYouTubeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveYouTubeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeYouTubeApiKeyMutation, { data, loading, error }] = useRemoveYouTubeApiKeyMutation({
 *   variables: {
 *      mediaAccountId: // value for 'mediaAccountId'
 *   },
 * });
 */
export function useRemoveYouTubeApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveYouTubeApiKeyMutation, RemoveYouTubeApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveYouTubeApiKeyMutation, RemoveYouTubeApiKeyMutationVariables>(RemoveYouTubeApiKeyDocument, options);
      }
export type RemoveYouTubeApiKeyMutationHookResult = ReturnType<typeof useRemoveYouTubeApiKeyMutation>;
export type RemoveYouTubeApiKeyMutationResult = Apollo.MutationResult<RemoveYouTubeApiKeyMutation>;
export type RemoveYouTubeApiKeyMutationOptions = Apollo.BaseMutationOptions<RemoveYouTubeApiKeyMutation, RemoveYouTubeApiKeyMutationVariables>;
export const GetYouTubeQuotaUsageDocument = gql`
    query getYouTubeQuotaUsage($mediaAccountId: Int!) {
  getYouTubeQuotaUsage(mediaAccountId: $mediaAccountId) {
    used
    limit
    percentage
  }
}
    `;

/**
 * __useGetYouTubeQuotaUsageQuery__
 *
 * To run a query within a React component, call `useGetYouTubeQuotaUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYouTubeQuotaUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYouTubeQuotaUsageQuery({
 *   variables: {
 *      mediaAccountId: // value for 'mediaAccountId'
 *   },
 * });
 */
export function useGetYouTubeQuotaUsageQuery(baseOptions: Apollo.QueryHookOptions<GetYouTubeQuotaUsageQuery, GetYouTubeQuotaUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYouTubeQuotaUsageQuery, GetYouTubeQuotaUsageQueryVariables>(GetYouTubeQuotaUsageDocument, options);
      }
export function useGetYouTubeQuotaUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYouTubeQuotaUsageQuery, GetYouTubeQuotaUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYouTubeQuotaUsageQuery, GetYouTubeQuotaUsageQueryVariables>(GetYouTubeQuotaUsageDocument, options);
        }
export type GetYouTubeQuotaUsageQueryHookResult = ReturnType<typeof useGetYouTubeQuotaUsageQuery>;
export type GetYouTubeQuotaUsageLazyQueryHookResult = ReturnType<typeof useGetYouTubeQuotaUsageLazyQuery>;
export type GetYouTubeQuotaUsageQueryResult = Apollo.QueryResult<GetYouTubeQuotaUsageQuery, GetYouTubeQuotaUsageQueryVariables>;
export const GetListeningTopicsDocument = gql`
    query GetListeningTopics {
  getListeningTopics {
    id
    name
    description
    platforms
    seedKeywords
    minFollowers
    maxFollowers
    isActive
    lastScrapedAt
    contentCount
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetListeningTopicsQuery__
 *
 * To run a query within a React component, call `useGetListeningTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListeningTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListeningTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListeningTopicsQuery(baseOptions?: Apollo.QueryHookOptions<GetListeningTopicsQuery, GetListeningTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListeningTopicsQuery, GetListeningTopicsQueryVariables>(GetListeningTopicsDocument, options);
      }
export function useGetListeningTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListeningTopicsQuery, GetListeningTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListeningTopicsQuery, GetListeningTopicsQueryVariables>(GetListeningTopicsDocument, options);
        }
export type GetListeningTopicsQueryHookResult = ReturnType<typeof useGetListeningTopicsQuery>;
export type GetListeningTopicsLazyQueryHookResult = ReturnType<typeof useGetListeningTopicsLazyQuery>;
export type GetListeningTopicsQueryResult = Apollo.QueryResult<GetListeningTopicsQuery, GetListeningTopicsQueryVariables>;
export const GetListeningTopicDocument = gql`
    query GetListeningTopic($id: ID!) {
  getListeningTopic(id: $id) {
    id
    name
    description
    platforms
    seedKeywords
    minFollowers
    maxFollowers
    isActive
    lastScrapedAt
    contentCount
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetListeningTopicQuery__
 *
 * To run a query within a React component, call `useGetListeningTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListeningTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListeningTopicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetListeningTopicQuery(baseOptions: Apollo.QueryHookOptions<GetListeningTopicQuery, GetListeningTopicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListeningTopicQuery, GetListeningTopicQueryVariables>(GetListeningTopicDocument, options);
      }
export function useGetListeningTopicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListeningTopicQuery, GetListeningTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListeningTopicQuery, GetListeningTopicQueryVariables>(GetListeningTopicDocument, options);
        }
export type GetListeningTopicQueryHookResult = ReturnType<typeof useGetListeningTopicQuery>;
export type GetListeningTopicLazyQueryHookResult = ReturnType<typeof useGetListeningTopicLazyQuery>;
export type GetListeningTopicQueryResult = Apollo.QueryResult<GetListeningTopicQuery, GetListeningTopicQueryVariables>;
export const GetListeningTopicFeedDocument = gql`
    query GetListeningTopicFeed($input: ListeningTopicFeedInput!) {
  getListeningTopicFeed(input: $input) {
    content {
      id
      platform
      contentId
      caption
      summary
      authorUsername
      authorDisplayName
      authorAvatarUrl
      contentUrl
      thumbnailUrl
      contentType
      likes
      comments
      shares
      views
      hashtags
      mentions
      authorFollowerCount
      preGeneratedComment
      postedAt
      scrapedAt
      similarity
      relevanceScore
      interactedWith
    }
    totalCount
    hasMore
  }
}
    `;

/**
 * __useGetListeningTopicFeedQuery__
 *
 * To run a query within a React component, call `useGetListeningTopicFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListeningTopicFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListeningTopicFeedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetListeningTopicFeedQuery(baseOptions: Apollo.QueryHookOptions<GetListeningTopicFeedQuery, GetListeningTopicFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListeningTopicFeedQuery, GetListeningTopicFeedQueryVariables>(GetListeningTopicFeedDocument, options);
      }
export function useGetListeningTopicFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListeningTopicFeedQuery, GetListeningTopicFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListeningTopicFeedQuery, GetListeningTopicFeedQueryVariables>(GetListeningTopicFeedDocument, options);
        }
export type GetListeningTopicFeedQueryHookResult = ReturnType<typeof useGetListeningTopicFeedQuery>;
export type GetListeningTopicFeedLazyQueryHookResult = ReturnType<typeof useGetListeningTopicFeedLazyQuery>;
export type GetListeningTopicFeedQueryResult = Apollo.QueryResult<GetListeningTopicFeedQuery, GetListeningTopicFeedQueryVariables>;
export const GetEngagementStatsDocument = gql`
    query GetEngagementStats {
  getEngagementStats {
    today
    thisWeek
    thisMonth
    total
    streakDays
  }
}
    `;

/**
 * __useGetEngagementStatsQuery__
 *
 * To run a query within a React component, call `useGetEngagementStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEngagementStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetEngagementStatsQuery, GetEngagementStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEngagementStatsQuery, GetEngagementStatsQueryVariables>(GetEngagementStatsDocument, options);
      }
export function useGetEngagementStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEngagementStatsQuery, GetEngagementStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEngagementStatsQuery, GetEngagementStatsQueryVariables>(GetEngagementStatsDocument, options);
        }
export type GetEngagementStatsQueryHookResult = ReturnType<typeof useGetEngagementStatsQuery>;
export type GetEngagementStatsLazyQueryHookResult = ReturnType<typeof useGetEngagementStatsLazyQuery>;
export type GetEngagementStatsQueryResult = Apollo.QueryResult<GetEngagementStatsQuery, GetEngagementStatsQueryVariables>;
export const GetCreatorPostsDocument = gql`
    query GetCreatorPosts($username: String!, $limit: Int) {
  getCreatorPosts(username: $username, limit: $limit) {
    id
    platform
    contentId
    caption
    summary
    authorUsername
    authorDisplayName
    authorAvatarUrl
    contentUrl
    thumbnailUrl
    contentType
    likes
    comments
    shares
    views
    hashtags
    mentions
    postedAt
    scrapedAt
    similarity
    interactedWith
  }
}
    `;

/**
 * __useGetCreatorPostsQuery__
 *
 * To run a query within a React component, call `useGetCreatorPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorPostsQuery({
 *   variables: {
 *      username: // value for 'username'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCreatorPostsQuery(baseOptions: Apollo.QueryHookOptions<GetCreatorPostsQuery, GetCreatorPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorPostsQuery, GetCreatorPostsQueryVariables>(GetCreatorPostsDocument, options);
      }
export function useGetCreatorPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorPostsQuery, GetCreatorPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorPostsQuery, GetCreatorPostsQueryVariables>(GetCreatorPostsDocument, options);
        }
export type GetCreatorPostsQueryHookResult = ReturnType<typeof useGetCreatorPostsQuery>;
export type GetCreatorPostsLazyQueryHookResult = ReturnType<typeof useGetCreatorPostsLazyQuery>;
export type GetCreatorPostsQueryResult = Apollo.QueryResult<GetCreatorPostsQuery, GetCreatorPostsQueryVariables>;
export const GetSuggestedProfilesDocument = gql`
    query GetSuggestedProfiles($topicId: ID, $limit: Int, $offset: Int) {
  getSuggestedProfiles(topicId: $topicId, limit: $limit, offset: $offset) {
    profiles {
      authorUsername
      authorDisplayName
      authorAvatarUrl
      followerCount
      primaryPlatform
      postCount
      topicAppearances
      avgLikes
      avgComments
      totalLikes
      totalComments
      timesEngaged
      lastEngagedAt
      latestContentUrl
      profileScore
      engagementRate
      topicNames
      lastPostedAt
      isGuestCandidate
      guestStatus
      guestNotes
      discoveredVia
      commentFrequency
    }
    totalCount
  }
}
    `;

/**
 * __useGetSuggestedProfilesQuery__
 *
 * To run a query within a React component, call `useGetSuggestedProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedProfilesQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSuggestedProfilesQuery(baseOptions?: Apollo.QueryHookOptions<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>(GetSuggestedProfilesDocument, options);
      }
export function useGetSuggestedProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>(GetSuggestedProfilesDocument, options);
        }
export type GetSuggestedProfilesQueryHookResult = ReturnType<typeof useGetSuggestedProfilesQuery>;
export type GetSuggestedProfilesLazyQueryHookResult = ReturnType<typeof useGetSuggestedProfilesLazyQuery>;
export type GetSuggestedProfilesQueryResult = Apollo.QueryResult<GetSuggestedProfilesQuery, GetSuggestedProfilesQueryVariables>;
export const GenerateTopicKeywordsDocument = gql`
    query GenerateTopicKeywords($description: String!, $platforms: [Platform!]!) {
  generateTopicKeywords(description: $description, platforms: $platforms) {
    keywords
  }
}
    `;

/**
 * __useGenerateTopicKeywordsQuery__
 *
 * To run a query within a React component, call `useGenerateTopicKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateTopicKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateTopicKeywordsQuery({
 *   variables: {
 *      description: // value for 'description'
 *      platforms: // value for 'platforms'
 *   },
 * });
 */
export function useGenerateTopicKeywordsQuery(baseOptions: Apollo.QueryHookOptions<GenerateTopicKeywordsQuery, GenerateTopicKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateTopicKeywordsQuery, GenerateTopicKeywordsQueryVariables>(GenerateTopicKeywordsDocument, options);
      }
export function useGenerateTopicKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateTopicKeywordsQuery, GenerateTopicKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateTopicKeywordsQuery, GenerateTopicKeywordsQueryVariables>(GenerateTopicKeywordsDocument, options);
        }
export type GenerateTopicKeywordsQueryHookResult = ReturnType<typeof useGenerateTopicKeywordsQuery>;
export type GenerateTopicKeywordsLazyQueryHookResult = ReturnType<typeof useGenerateTopicKeywordsLazyQuery>;
export type GenerateTopicKeywordsQueryResult = Apollo.QueryResult<GenerateTopicKeywordsQuery, GenerateTopicKeywordsQueryVariables>;
export const CreateListeningTopicDocument = gql`
    mutation CreateListeningTopic($input: CreateListeningTopicInput!) {
  createListeningTopic(input: $input) {
    id
    name
    description
    platforms
    seedKeywords
    isActive
    contentCount
    createdAt
    updatedAt
  }
}
    `;
export type CreateListeningTopicMutationFn = Apollo.MutationFunction<CreateListeningTopicMutation, CreateListeningTopicMutationVariables>;

/**
 * __useCreateListeningTopicMutation__
 *
 * To run a mutation, you first call `useCreateListeningTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListeningTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListeningTopicMutation, { data, loading, error }] = useCreateListeningTopicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListeningTopicMutation(baseOptions?: Apollo.MutationHookOptions<CreateListeningTopicMutation, CreateListeningTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListeningTopicMutation, CreateListeningTopicMutationVariables>(CreateListeningTopicDocument, options);
      }
export type CreateListeningTopicMutationHookResult = ReturnType<typeof useCreateListeningTopicMutation>;
export type CreateListeningTopicMutationResult = Apollo.MutationResult<CreateListeningTopicMutation>;
export type CreateListeningTopicMutationOptions = Apollo.BaseMutationOptions<CreateListeningTopicMutation, CreateListeningTopicMutationVariables>;
export const UpdateListeningTopicDocument = gql`
    mutation UpdateListeningTopic($input: UpdateListeningTopicInput!) {
  updateListeningTopic(input: $input) {
    id
    name
    description
    platforms
    seedKeywords
    isActive
    contentCount
    createdAt
    updatedAt
  }
}
    `;
export type UpdateListeningTopicMutationFn = Apollo.MutationFunction<UpdateListeningTopicMutation, UpdateListeningTopicMutationVariables>;

/**
 * __useUpdateListeningTopicMutation__
 *
 * To run a mutation, you first call `useUpdateListeningTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListeningTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListeningTopicMutation, { data, loading, error }] = useUpdateListeningTopicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListeningTopicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListeningTopicMutation, UpdateListeningTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListeningTopicMutation, UpdateListeningTopicMutationVariables>(UpdateListeningTopicDocument, options);
      }
export type UpdateListeningTopicMutationHookResult = ReturnType<typeof useUpdateListeningTopicMutation>;
export type UpdateListeningTopicMutationResult = Apollo.MutationResult<UpdateListeningTopicMutation>;
export type UpdateListeningTopicMutationOptions = Apollo.BaseMutationOptions<UpdateListeningTopicMutation, UpdateListeningTopicMutationVariables>;
export const DeleteListeningTopicDocument = gql`
    mutation DeleteListeningTopic($id: ID!) {
  deleteListeningTopic(id: $id)
}
    `;
export type DeleteListeningTopicMutationFn = Apollo.MutationFunction<DeleteListeningTopicMutation, DeleteListeningTopicMutationVariables>;

/**
 * __useDeleteListeningTopicMutation__
 *
 * To run a mutation, you first call `useDeleteListeningTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListeningTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListeningTopicMutation, { data, loading, error }] = useDeleteListeningTopicMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteListeningTopicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListeningTopicMutation, DeleteListeningTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListeningTopicMutation, DeleteListeningTopicMutationVariables>(DeleteListeningTopicDocument, options);
      }
export type DeleteListeningTopicMutationHookResult = ReturnType<typeof useDeleteListeningTopicMutation>;
export type DeleteListeningTopicMutationResult = Apollo.MutationResult<DeleteListeningTopicMutation>;
export type DeleteListeningTopicMutationOptions = Apollo.BaseMutationOptions<DeleteListeningTopicMutation, DeleteListeningTopicMutationVariables>;
export const RefreshListeningTopicDocument = gql`
    mutation RefreshListeningTopic($id: ID!) {
  refreshListeningTopic(id: $id)
}
    `;
export type RefreshListeningTopicMutationFn = Apollo.MutationFunction<RefreshListeningTopicMutation, RefreshListeningTopicMutationVariables>;

/**
 * __useRefreshListeningTopicMutation__
 *
 * To run a mutation, you first call `useRefreshListeningTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshListeningTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshListeningTopicMutation, { data, loading, error }] = useRefreshListeningTopicMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshListeningTopicMutation(baseOptions?: Apollo.MutationHookOptions<RefreshListeningTopicMutation, RefreshListeningTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshListeningTopicMutation, RefreshListeningTopicMutationVariables>(RefreshListeningTopicDocument, options);
      }
export type RefreshListeningTopicMutationHookResult = ReturnType<typeof useRefreshListeningTopicMutation>;
export type RefreshListeningTopicMutationResult = Apollo.MutationResult<RefreshListeningTopicMutation>;
export type RefreshListeningTopicMutationOptions = Apollo.BaseMutationOptions<RefreshListeningTopicMutation, RefreshListeningTopicMutationVariables>;
export const MarkTopicContentInteractedDocument = gql`
    mutation MarkTopicContentInteracted($contentId: ID!) {
  markTopicContentInteracted(contentId: $contentId)
}
    `;
export type MarkTopicContentInteractedMutationFn = Apollo.MutationFunction<MarkTopicContentInteractedMutation, MarkTopicContentInteractedMutationVariables>;

/**
 * __useMarkTopicContentInteractedMutation__
 *
 * To run a mutation, you first call `useMarkTopicContentInteractedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTopicContentInteractedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTopicContentInteractedMutation, { data, loading, error }] = useMarkTopicContentInteractedMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useMarkTopicContentInteractedMutation(baseOptions?: Apollo.MutationHookOptions<MarkTopicContentInteractedMutation, MarkTopicContentInteractedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkTopicContentInteractedMutation, MarkTopicContentInteractedMutationVariables>(MarkTopicContentInteractedDocument, options);
      }
export type MarkTopicContentInteractedMutationHookResult = ReturnType<typeof useMarkTopicContentInteractedMutation>;
export type MarkTopicContentInteractedMutationResult = Apollo.MutationResult<MarkTopicContentInteractedMutation>;
export type MarkTopicContentInteractedMutationOptions = Apollo.BaseMutationOptions<MarkTopicContentInteractedMutation, MarkTopicContentInteractedMutationVariables>;
export const HideTopicContentDocument = gql`
    mutation HideTopicContent($contentId: ID!) {
  hideTopicContent(contentId: $contentId)
}
    `;
export type HideTopicContentMutationFn = Apollo.MutationFunction<HideTopicContentMutation, HideTopicContentMutationVariables>;

/**
 * __useHideTopicContentMutation__
 *
 * To run a mutation, you first call `useHideTopicContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideTopicContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideTopicContentMutation, { data, loading, error }] = useHideTopicContentMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useHideTopicContentMutation(baseOptions?: Apollo.MutationHookOptions<HideTopicContentMutation, HideTopicContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideTopicContentMutation, HideTopicContentMutationVariables>(HideTopicContentDocument, options);
      }
export type HideTopicContentMutationHookResult = ReturnType<typeof useHideTopicContentMutation>;
export type HideTopicContentMutationResult = Apollo.MutationResult<HideTopicContentMutation>;
export type HideTopicContentMutationOptions = Apollo.BaseMutationOptions<HideTopicContentMutation, HideTopicContentMutationVariables>;
export const SaveContentCommentDocument = gql`
    mutation SaveContentComment($contentId: ID!, $comment: String!) {
  saveContentComment(contentId: $contentId, comment: $comment)
}
    `;
export type SaveContentCommentMutationFn = Apollo.MutationFunction<SaveContentCommentMutation, SaveContentCommentMutationVariables>;

/**
 * __useSaveContentCommentMutation__
 *
 * To run a mutation, you first call `useSaveContentCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveContentCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveContentCommentMutation, { data, loading, error }] = useSaveContentCommentMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSaveContentCommentMutation(baseOptions?: Apollo.MutationHookOptions<SaveContentCommentMutation, SaveContentCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveContentCommentMutation, SaveContentCommentMutationVariables>(SaveContentCommentDocument, options);
      }
export type SaveContentCommentMutationHookResult = ReturnType<typeof useSaveContentCommentMutation>;
export type SaveContentCommentMutationResult = Apollo.MutationResult<SaveContentCommentMutation>;
export type SaveContentCommentMutationOptions = Apollo.BaseMutationOptions<SaveContentCommentMutation, SaveContentCommentMutationVariables>;
export const ExploreAudienceDocument = gql`
    mutation ExploreAudience($authorUsername: String!) {
  exploreAudience(authorUsername: $authorUsername) {
    username
    fullName
    profilePicUrl
    followerCount
    commentFrequency
    isVerified
  }
}
    `;
export type ExploreAudienceMutationFn = Apollo.MutationFunction<ExploreAudienceMutation, ExploreAudienceMutationVariables>;

/**
 * __useExploreAudienceMutation__
 *
 * To run a mutation, you first call `useExploreAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExploreAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exploreAudienceMutation, { data, loading, error }] = useExploreAudienceMutation({
 *   variables: {
 *      authorUsername: // value for 'authorUsername'
 *   },
 * });
 */
export function useExploreAudienceMutation(baseOptions?: Apollo.MutationHookOptions<ExploreAudienceMutation, ExploreAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExploreAudienceMutation, ExploreAudienceMutationVariables>(ExploreAudienceDocument, options);
      }
export type ExploreAudienceMutationHookResult = ReturnType<typeof useExploreAudienceMutation>;
export type ExploreAudienceMutationResult = Apollo.MutationResult<ExploreAudienceMutation>;
export type ExploreAudienceMutationOptions = Apollo.BaseMutationOptions<ExploreAudienceMutation, ExploreAudienceMutationVariables>;
export const UpdateGuestStatusDocument = gql`
    mutation UpdateGuestStatus($username: String!, $status: String, $notes: String) {
  updateGuestStatus(username: $username, status: $status, notes: $notes)
}
    `;
export type UpdateGuestStatusMutationFn = Apollo.MutationFunction<UpdateGuestStatusMutation, UpdateGuestStatusMutationVariables>;

/**
 * __useUpdateGuestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateGuestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuestStatusMutation, { data, loading, error }] = useUpdateGuestStatusMutation({
 *   variables: {
 *      username: // value for 'username'
 *      status: // value for 'status'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateGuestStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGuestStatusMutation, UpdateGuestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGuestStatusMutation, UpdateGuestStatusMutationVariables>(UpdateGuestStatusDocument, options);
      }
export type UpdateGuestStatusMutationHookResult = ReturnType<typeof useUpdateGuestStatusMutation>;
export type UpdateGuestStatusMutationResult = Apollo.MutationResult<UpdateGuestStatusMutation>;
export type UpdateGuestStatusMutationOptions = Apollo.BaseMutationOptions<UpdateGuestStatusMutation, UpdateGuestStatusMutationVariables>;
export const GenerateGuestPitchDocument = gql`
    mutation GenerateGuestPitch($authorUsername: String!, $podcastName: String!, $podcastDescription: String!) {
  generateGuestPitch(
    authorUsername: $authorUsername
    podcastName: $podcastName
    podcastDescription: $podcastDescription
  )
}
    `;
export type GenerateGuestPitchMutationFn = Apollo.MutationFunction<GenerateGuestPitchMutation, GenerateGuestPitchMutationVariables>;

/**
 * __useGenerateGuestPitchMutation__
 *
 * To run a mutation, you first call `useGenerateGuestPitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateGuestPitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateGuestPitchMutation, { data, loading, error }] = useGenerateGuestPitchMutation({
 *   variables: {
 *      authorUsername: // value for 'authorUsername'
 *      podcastName: // value for 'podcastName'
 *      podcastDescription: // value for 'podcastDescription'
 *   },
 * });
 */
export function useGenerateGuestPitchMutation(baseOptions?: Apollo.MutationHookOptions<GenerateGuestPitchMutation, GenerateGuestPitchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateGuestPitchMutation, GenerateGuestPitchMutationVariables>(GenerateGuestPitchDocument, options);
      }
export type GenerateGuestPitchMutationHookResult = ReturnType<typeof useGenerateGuestPitchMutation>;
export type GenerateGuestPitchMutationResult = Apollo.MutationResult<GenerateGuestPitchMutation>;
export type GenerateGuestPitchMutationOptions = Apollo.BaseMutationOptions<GenerateGuestPitchMutation, GenerateGuestPitchMutationVariables>;
export const GetAudienceInsightsDocument = gql`
    query GetAudienceInsights {
  getAudienceInsights {
    totalCreators
    totalEngagements
    platformBreakdown {
      platform
      count
      percentage
    }
    followerTiers {
      tier
      count
      percentage
    }
    topTopics
    engagementTrend {
      date
      count
    }
  }
}
    `;

/**
 * __useGetAudienceInsightsQuery__
 *
 * To run a query within a React component, call `useGetAudienceInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudienceInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudienceInsightsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAudienceInsightsQuery(baseOptions?: Apollo.QueryHookOptions<GetAudienceInsightsQuery, GetAudienceInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAudienceInsightsQuery, GetAudienceInsightsQueryVariables>(GetAudienceInsightsDocument, options);
      }
export function useGetAudienceInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAudienceInsightsQuery, GetAudienceInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAudienceInsightsQuery, GetAudienceInsightsQueryVariables>(GetAudienceInsightsDocument, options);
        }
export type GetAudienceInsightsQueryHookResult = ReturnType<typeof useGetAudienceInsightsQuery>;
export type GetAudienceInsightsLazyQueryHookResult = ReturnType<typeof useGetAudienceInsightsLazyQuery>;
export type GetAudienceInsightsQueryResult = Apollo.QueryResult<GetAudienceInsightsQuery, GetAudienceInsightsQueryVariables>;
export const GetEpisodePerformanceDocument = gql`
    query GetEpisodePerformance {
  getEpisodePerformance {
    topicId
    topicName
    contentCount
    engagementCount
    createdAt
  }
}
    `;

/**
 * __useGetEpisodePerformanceQuery__
 *
 * To run a query within a React component, call `useGetEpisodePerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodePerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodePerformanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEpisodePerformanceQuery(baseOptions?: Apollo.QueryHookOptions<GetEpisodePerformanceQuery, GetEpisodePerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEpisodePerformanceQuery, GetEpisodePerformanceQueryVariables>(GetEpisodePerformanceDocument, options);
      }
export function useGetEpisodePerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEpisodePerformanceQuery, GetEpisodePerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEpisodePerformanceQuery, GetEpisodePerformanceQueryVariables>(GetEpisodePerformanceDocument, options);
        }
export type GetEpisodePerformanceQueryHookResult = ReturnType<typeof useGetEpisodePerformanceQuery>;
export type GetEpisodePerformanceLazyQueryHookResult = ReturnType<typeof useGetEpisodePerformanceLazyQuery>;
export type GetEpisodePerformanceQueryResult = Apollo.QueryResult<GetEpisodePerformanceQuery, GetEpisodePerformanceQueryVariables>;
export const GetNicheCategoriesDocument = gql`
    query GetNicheCategories {
  getNicheCategories {
    id
    slug
    displayName
    description
    iconEmoji
    isActive
    contentCount
  }
}
    `;

/**
 * __useGetNicheCategoriesQuery__
 *
 * To run a query within a React component, call `useGetNicheCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNicheCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNicheCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNicheCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetNicheCategoriesQuery, GetNicheCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNicheCategoriesQuery, GetNicheCategoriesQueryVariables>(GetNicheCategoriesDocument, options);
      }
export function useGetNicheCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNicheCategoriesQuery, GetNicheCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNicheCategoriesQuery, GetNicheCategoriesQueryVariables>(GetNicheCategoriesDocument, options);
        }
export type GetNicheCategoriesQueryHookResult = ReturnType<typeof useGetNicheCategoriesQuery>;
export type GetNicheCategoriesLazyQueryHookResult = ReturnType<typeof useGetNicheCategoriesLazyQuery>;
export type GetNicheCategoriesQueryResult = Apollo.QueryResult<GetNicheCategoriesQuery, GetNicheCategoriesQueryVariables>;
export const GetNicheCategoryDocument = gql`
    query GetNicheCategory($slug: String!) {
  getNicheCategory(slug: $slug) {
    id
    slug
    displayName
    description
    iconEmoji
    isActive
    contentCount
  }
}
    `;

/**
 * __useGetNicheCategoryQuery__
 *
 * To run a query within a React component, call `useGetNicheCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNicheCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNicheCategoryQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetNicheCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetNicheCategoryQuery, GetNicheCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNicheCategoryQuery, GetNicheCategoryQueryVariables>(GetNicheCategoryDocument, options);
      }
export function useGetNicheCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNicheCategoryQuery, GetNicheCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNicheCategoryQuery, GetNicheCategoryQueryVariables>(GetNicheCategoryDocument, options);
        }
export type GetNicheCategoryQueryHookResult = ReturnType<typeof useGetNicheCategoryQuery>;
export type GetNicheCategoryLazyQueryHookResult = ReturnType<typeof useGetNicheCategoryLazyQuery>;
export type GetNicheCategoryQueryResult = Apollo.QueryResult<GetNicheCategoryQuery, GetNicheCategoryQueryVariables>;
export const SearchNicheContentDocument = gql`
    query SearchNicheContent($input: NicheSearchInput!) {
  searchNicheContent(input: $input) {
    content {
      id
      nicheCategoryId
      platform
      contentId
      caption
      summary
      authorUsername
      authorDisplayName
      authorAvatarUrl
      contentUrl
      thumbnailUrl
      contentType
      likes
      comments
      shares
      views
      saves
      hashtags
      mentions
      postedAt
      scrapedAt
      similarity
    }
    totalCount
    hasMore
  }
}
    `;

/**
 * __useSearchNicheContentQuery__
 *
 * To run a query within a React component, call `useSearchNicheContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchNicheContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchNicheContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchNicheContentQuery(baseOptions: Apollo.QueryHookOptions<SearchNicheContentQuery, SearchNicheContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchNicheContentQuery, SearchNicheContentQueryVariables>(SearchNicheContentDocument, options);
      }
export function useSearchNicheContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchNicheContentQuery, SearchNicheContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchNicheContentQuery, SearchNicheContentQueryVariables>(SearchNicheContentDocument, options);
        }
export type SearchNicheContentQueryHookResult = ReturnType<typeof useSearchNicheContentQuery>;
export type SearchNicheContentLazyQueryHookResult = ReturnType<typeof useSearchNicheContentLazyQuery>;
export type SearchNicheContentQueryResult = Apollo.QueryResult<SearchNicheContentQuery, SearchNicheContentQueryVariables>;
export const BrowseNicheContentDocument = gql`
    query BrowseNicheContent($input: NicheBrowseInput!) {
  browseNicheContent(input: $input) {
    content {
      id
      nicheCategoryId
      platform
      contentId
      caption
      summary
      authorUsername
      authorDisplayName
      authorAvatarUrl
      contentUrl
      thumbnailUrl
      contentType
      likes
      comments
      shares
      views
      saves
      hashtags
      mentions
      postedAt
      scrapedAt
      similarity
    }
    totalCount
    hasMore
  }
}
    `;

/**
 * __useBrowseNicheContentQuery__
 *
 * To run a query within a React component, call `useBrowseNicheContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrowseNicheContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrowseNicheContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrowseNicheContentQuery(baseOptions: Apollo.QueryHookOptions<BrowseNicheContentQuery, BrowseNicheContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrowseNicheContentQuery, BrowseNicheContentQueryVariables>(BrowseNicheContentDocument, options);
      }
export function useBrowseNicheContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrowseNicheContentQuery, BrowseNicheContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrowseNicheContentQuery, BrowseNicheContentQueryVariables>(BrowseNicheContentDocument, options);
        }
export type BrowseNicheContentQueryHookResult = ReturnType<typeof useBrowseNicheContentQuery>;
export type BrowseNicheContentLazyQueryHookResult = ReturnType<typeof useBrowseNicheContentLazyQuery>;
export type BrowseNicheContentQueryResult = Apollo.QueryResult<BrowseNicheContentQuery, BrowseNicheContentQueryVariables>;
export const GlobalNicheSearchDocument = gql`
    query GlobalNicheSearch($query: String!, $platforms: [Platform!], $limit: Int) {
  globalNicheSearch(query: $query, platforms: $platforms, limit: $limit) {
    content {
      id
      nicheCategoryId
      platform
      contentId
      caption
      summary
      authorUsername
      authorDisplayName
      authorAvatarUrl
      contentUrl
      thumbnailUrl
      contentType
      likes
      comments
      shares
      views
      saves
      hashtags
      mentions
      postedAt
      scrapedAt
      similarity
    }
    totalCount
    hasMore
  }
}
    `;

/**
 * __useGlobalNicheSearchQuery__
 *
 * To run a query within a React component, call `useGlobalNicheSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalNicheSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalNicheSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      platforms: // value for 'platforms'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGlobalNicheSearchQuery(baseOptions: Apollo.QueryHookOptions<GlobalNicheSearchQuery, GlobalNicheSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalNicheSearchQuery, GlobalNicheSearchQueryVariables>(GlobalNicheSearchDocument, options);
      }
export function useGlobalNicheSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalNicheSearchQuery, GlobalNicheSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalNicheSearchQuery, GlobalNicheSearchQueryVariables>(GlobalNicheSearchDocument, options);
        }
export type GlobalNicheSearchQueryHookResult = ReturnType<typeof useGlobalNicheSearchQuery>;
export type GlobalNicheSearchLazyQueryHookResult = ReturnType<typeof useGlobalNicheSearchLazyQuery>;
export type GlobalNicheSearchQueryResult = Apollo.QueryResult<GlobalNicheSearchQuery, GlobalNicheSearchQueryVariables>;
export const GetOauthTokensDocument = gql`
    query getOauthTokens($code: String!, $platform: OauthPlatform!) {
  oauth(code: $code, platform: $platform) {
    accessToken
    refreshToken
  }
}
    `;

/**
 * __useGetOauthTokensQuery__
 *
 * To run a query within a React component, call `useGetOauthTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOauthTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOauthTokensQuery({
 *   variables: {
 *      code: // value for 'code'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetOauthTokensQuery(baseOptions: Apollo.QueryHookOptions<GetOauthTokensQuery, GetOauthTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOauthTokensQuery, GetOauthTokensQueryVariables>(GetOauthTokensDocument, options);
      }
export function useGetOauthTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOauthTokensQuery, GetOauthTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOauthTokensQuery, GetOauthTokensQueryVariables>(GetOauthTokensDocument, options);
        }
export type GetOauthTokensQueryHookResult = ReturnType<typeof useGetOauthTokensQuery>;
export type GetOauthTokensLazyQueryHookResult = ReturnType<typeof useGetOauthTokensLazyQuery>;
export type GetOauthTokensQueryResult = Apollo.QueryResult<GetOauthTokensQuery, GetOauthTokensQueryVariables>;
export const AddMediaAccountDocument = gql`
    mutation addMediaAccount($accessToken: String!, $platform: Platform!, $refreshToken: String) {
  addMediaAccount(
    accessToken: $accessToken
    platform: $platform
    refreshToken: $refreshToken
  ) {
    id
    accountName
    platform
    igUserId
    nickname
    privacy_level_options
    max_video_duration
    comments_disabled
    duet_disabled
    stitch_disabled
  }
}
    `;
export type AddMediaAccountMutationFn = Apollo.MutationFunction<AddMediaAccountMutation, AddMediaAccountMutationVariables>;

/**
 * __useAddMediaAccountMutation__
 *
 * To run a mutation, you first call `useAddMediaAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMediaAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMediaAccountMutation, { data, loading, error }] = useAddMediaAccountMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      platform: // value for 'platform'
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useAddMediaAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddMediaAccountMutation, AddMediaAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMediaAccountMutation, AddMediaAccountMutationVariables>(AddMediaAccountDocument, options);
      }
export type AddMediaAccountMutationHookResult = ReturnType<typeof useAddMediaAccountMutation>;
export type AddMediaAccountMutationResult = Apollo.MutationResult<AddMediaAccountMutation>;
export type AddMediaAccountMutationOptions = Apollo.BaseMutationOptions<AddMediaAccountMutation, AddMediaAccountMutationVariables>;
export const RemoveMediaAccountDocument = gql`
    mutation RemoveMediaAccount($accountId: Int!) {
  removeMediaAccount(accountId: $accountId)
}
    `;
export type RemoveMediaAccountMutationFn = Apollo.MutationFunction<RemoveMediaAccountMutation, RemoveMediaAccountMutationVariables>;

/**
 * __useRemoveMediaAccountMutation__
 *
 * To run a mutation, you first call `useRemoveMediaAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMediaAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMediaAccountMutation, { data, loading, error }] = useRemoveMediaAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRemoveMediaAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMediaAccountMutation, RemoveMediaAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMediaAccountMutation, RemoveMediaAccountMutationVariables>(RemoveMediaAccountDocument, options);
      }
export type RemoveMediaAccountMutationHookResult = ReturnType<typeof useRemoveMediaAccountMutation>;
export type RemoveMediaAccountMutationResult = Apollo.MutationResult<RemoveMediaAccountMutation>;
export type RemoveMediaAccountMutationOptions = Apollo.BaseMutationOptions<RemoveMediaAccountMutation, RemoveMediaAccountMutationVariables>;
export const ValidateAccountConnectionDocument = gql`
    mutation ValidateAccountConnection($accountId: Int!) {
  validateAccountConnection(accountId: $accountId) {
    accountId
    platform
    isValid
    lastValidated
    needsReconnection
    message
  }
}
    `;
export type ValidateAccountConnectionMutationFn = Apollo.MutationFunction<ValidateAccountConnectionMutation, ValidateAccountConnectionMutationVariables>;

/**
 * __useValidateAccountConnectionMutation__
 *
 * To run a mutation, you first call `useValidateAccountConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAccountConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAccountConnectionMutation, { data, loading, error }] = useValidateAccountConnectionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useValidateAccountConnectionMutation(baseOptions?: Apollo.MutationHookOptions<ValidateAccountConnectionMutation, ValidateAccountConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateAccountConnectionMutation, ValidateAccountConnectionMutationVariables>(ValidateAccountConnectionDocument, options);
      }
export type ValidateAccountConnectionMutationHookResult = ReturnType<typeof useValidateAccountConnectionMutation>;
export type ValidateAccountConnectionMutationResult = Apollo.MutationResult<ValidateAccountConnectionMutation>;
export type ValidateAccountConnectionMutationOptions = Apollo.BaseMutationOptions<ValidateAccountConnectionMutation, ValidateAccountConnectionMutationVariables>;
export const PublishInstagramDocument = gql`
    mutation publishInstagram($mediaURLs: [String!]!, $caption: String, $accountId: Int!, $postType: PostType!) {
  publishInstagram(
    mediaURLs: $mediaURLs
    caption: $caption
    accountId: $accountId
    postType: $postType
  )
}
    `;
export type PublishInstagramMutationFn = Apollo.MutationFunction<PublishInstagramMutation, PublishInstagramMutationVariables>;

/**
 * __usePublishInstagramMutation__
 *
 * To run a mutation, you first call `usePublishInstagramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishInstagramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishInstagramMutation, { data, loading, error }] = usePublishInstagramMutation({
 *   variables: {
 *      mediaURLs: // value for 'mediaURLs'
 *      caption: // value for 'caption'
 *      accountId: // value for 'accountId'
 *      postType: // value for 'postType'
 *   },
 * });
 */
export function usePublishInstagramMutation(baseOptions?: Apollo.MutationHookOptions<PublishInstagramMutation, PublishInstagramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishInstagramMutation, PublishInstagramMutationVariables>(PublishInstagramDocument, options);
      }
export type PublishInstagramMutationHookResult = ReturnType<typeof usePublishInstagramMutation>;
export type PublishInstagramMutationResult = Apollo.MutationResult<PublishInstagramMutation>;
export type PublishInstagramMutationOptions = Apollo.BaseMutationOptions<PublishInstagramMutation, PublishInstagramMutationVariables>;
export const PublishFacebookDocument = gql`
    mutation publishFacebook($accountId: Int!, $caption: String!, $mediaURL: String!, $published: Boolean!, $isVideo: Boolean!, $scheduledDate: String) {
  publishFacebook(
    accountId: $accountId
    caption: $caption
    mediaURL: $mediaURL
    published: $published
    scheduledDate: $scheduledDate
    isVideo: $isVideo
  )
}
    `;
export type PublishFacebookMutationFn = Apollo.MutationFunction<PublishFacebookMutation, PublishFacebookMutationVariables>;

/**
 * __usePublishFacebookMutation__
 *
 * To run a mutation, you first call `usePublishFacebookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishFacebookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishFacebookMutation, { data, loading, error }] = usePublishFacebookMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      caption: // value for 'caption'
 *      mediaURL: // value for 'mediaURL'
 *      published: // value for 'published'
 *      isVideo: // value for 'isVideo'
 *      scheduledDate: // value for 'scheduledDate'
 *   },
 * });
 */
export function usePublishFacebookMutation(baseOptions?: Apollo.MutationHookOptions<PublishFacebookMutation, PublishFacebookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishFacebookMutation, PublishFacebookMutationVariables>(PublishFacebookDocument, options);
      }
export type PublishFacebookMutationHookResult = ReturnType<typeof usePublishFacebookMutation>;
export type PublishFacebookMutationResult = Apollo.MutationResult<PublishFacebookMutation>;
export type PublishFacebookMutationOptions = Apollo.BaseMutationOptions<PublishFacebookMutation, PublishFacebookMutationVariables>;
export const PublishTikTokDocument = gql`
    mutation publishTikTok($mediaURL: String!, $caption: String, $accountId: Int!, $privacy_level: String!, $allow_comments: Boolean!, $allow_duet: Boolean!, $allow_stitch: Boolean!, $brand_content: Boolean!, $brand_organic: Boolean!) {
  publishTikTok(
    mediaURL: $mediaURL
    caption: $caption
    accountId: $accountId
    privacy_level: $privacy_level
    allow_comments: $allow_comments
    allow_duet: $allow_duet
    allow_stitch: $allow_stitch
    brand_content: $brand_content
    brand_organic: $brand_organic
  )
}
    `;
export type PublishTikTokMutationFn = Apollo.MutationFunction<PublishTikTokMutation, PublishTikTokMutationVariables>;

/**
 * __usePublishTikTokMutation__
 *
 * To run a mutation, you first call `usePublishTikTokMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTikTokMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTikTokMutation, { data, loading, error }] = usePublishTikTokMutation({
 *   variables: {
 *      mediaURL: // value for 'mediaURL'
 *      caption: // value for 'caption'
 *      accountId: // value for 'accountId'
 *      privacy_level: // value for 'privacy_level'
 *      allow_comments: // value for 'allow_comments'
 *      allow_duet: // value for 'allow_duet'
 *      allow_stitch: // value for 'allow_stitch'
 *      brand_content: // value for 'brand_content'
 *      brand_organic: // value for 'brand_organic'
 *   },
 * });
 */
export function usePublishTikTokMutation(baseOptions?: Apollo.MutationHookOptions<PublishTikTokMutation, PublishTikTokMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishTikTokMutation, PublishTikTokMutationVariables>(PublishTikTokDocument, options);
      }
export type PublishTikTokMutationHookResult = ReturnType<typeof usePublishTikTokMutation>;
export type PublishTikTokMutationResult = Apollo.MutationResult<PublishTikTokMutation>;
export type PublishTikTokMutationOptions = Apollo.BaseMutationOptions<PublishTikTokMutation, PublishTikTokMutationVariables>;
export const CreateScheduledPostDocument = gql`
    mutation CreateScheduledPost($videoMediaURL: [String]!, $imageMediaURL: [String]!, $caption: String, $platform: Platform!, $postType: PostType!, $postDate: String!, $mediaAccountId: Int!, $privacy_level: String, $allow_comments: Boolean, $allow_duet: Boolean, $allow_stitch: Boolean, $brand_organic: Boolean, $brand_content: Boolean) {
  schedulePost(
    videoMediaURL: $videoMediaURL
    imageMediaURL: $imageMediaURL
    caption: $caption
    platform: $platform
    postType: $postType
    postDate: $postDate
    mediaAccountId: $mediaAccountId
    privacy_level: $privacy_level
    allow_comments: $allow_comments
    allow_duet: $allow_duet
    allow_stitch: $allow_stitch
    brand_content: $brand_content
    brand_organic: $brand_organic
  )
}
    `;
export type CreateScheduledPostMutationFn = Apollo.MutationFunction<CreateScheduledPostMutation, CreateScheduledPostMutationVariables>;

/**
 * __useCreateScheduledPostMutation__
 *
 * To run a mutation, you first call `useCreateScheduledPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledPostMutation, { data, loading, error }] = useCreateScheduledPostMutation({
 *   variables: {
 *      videoMediaURL: // value for 'videoMediaURL'
 *      imageMediaURL: // value for 'imageMediaURL'
 *      caption: // value for 'caption'
 *      platform: // value for 'platform'
 *      postType: // value for 'postType'
 *      postDate: // value for 'postDate'
 *      mediaAccountId: // value for 'mediaAccountId'
 *      privacy_level: // value for 'privacy_level'
 *      allow_comments: // value for 'allow_comments'
 *      allow_duet: // value for 'allow_duet'
 *      allow_stitch: // value for 'allow_stitch'
 *      brand_organic: // value for 'brand_organic'
 *      brand_content: // value for 'brand_content'
 *   },
 * });
 */
export function useCreateScheduledPostMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledPostMutation, CreateScheduledPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledPostMutation, CreateScheduledPostMutationVariables>(CreateScheduledPostDocument, options);
      }
export type CreateScheduledPostMutationHookResult = ReturnType<typeof useCreateScheduledPostMutation>;
export type CreateScheduledPostMutationResult = Apollo.MutationResult<CreateScheduledPostMutation>;
export type CreateScheduledPostMutationOptions = Apollo.BaseMutationOptions<CreateScheduledPostMutation, CreateScheduledPostMutationVariables>;
export const MediaAccountsDocument = gql`
    query mediaAccounts($platform: Platform) {
  mediaAccounts(platform: $platform) {
    id
    igUserId
    accountName
    platform
    nickname
    privacy_level_options
    max_video_duration
    comments_disabled
    duet_disabled
    stitch_disabled
    followerCount
    lastFollowerSync
    hasApiKey
    apiKeyAddedAt
  }
}
    `;

/**
 * __useMediaAccountsQuery__
 *
 * To run a query within a React component, call `useMediaAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAccountsQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useMediaAccountsQuery(baseOptions?: Apollo.QueryHookOptions<MediaAccountsQuery, MediaAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaAccountsQuery, MediaAccountsQueryVariables>(MediaAccountsDocument, options);
      }
export function useMediaAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaAccountsQuery, MediaAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaAccountsQuery, MediaAccountsQueryVariables>(MediaAccountsDocument, options);
        }
export type MediaAccountsQueryHookResult = ReturnType<typeof useMediaAccountsQuery>;
export type MediaAccountsLazyQueryHookResult = ReturnType<typeof useMediaAccountsLazyQuery>;
export type MediaAccountsQueryResult = Apollo.QueryResult<MediaAccountsQuery, MediaAccountsQueryVariables>;
export const SyncFollowerCountsDocument = gql`
    mutation syncFollowerCounts {
  syncFollowerCounts {
    platform
    accountName
    followerCount
    lastSynced
  }
}
    `;
export type SyncFollowerCountsMutationFn = Apollo.MutationFunction<SyncFollowerCountsMutation, SyncFollowerCountsMutationVariables>;

/**
 * __useSyncFollowerCountsMutation__
 *
 * To run a mutation, you first call `useSyncFollowerCountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncFollowerCountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncFollowerCountsMutation, { data, loading, error }] = useSyncFollowerCountsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncFollowerCountsMutation(baseOptions?: Apollo.MutationHookOptions<SyncFollowerCountsMutation, SyncFollowerCountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncFollowerCountsMutation, SyncFollowerCountsMutationVariables>(SyncFollowerCountsDocument, options);
      }
export type SyncFollowerCountsMutationHookResult = ReturnType<typeof useSyncFollowerCountsMutation>;
export type SyncFollowerCountsMutationResult = Apollo.MutationResult<SyncFollowerCountsMutation>;
export type SyncFollowerCountsMutationOptions = Apollo.BaseMutationOptions<SyncFollowerCountsMutation, SyncFollowerCountsMutationVariables>;
export const UserPostsDocument = gql`
    query userPosts {
  userPosts {
    old {
      id
      platform
      postDate
      caption
      imageMediaURLs
      videoMediaURLs
      postType
      accountName
    }
    scheduled {
      id
      platform
      postDate
      caption
      imageMediaURLs
      videoMediaURLs
      postType
      accountName
    }
  }
}
    `;

/**
 * __useUserPostsQuery__
 *
 * To run a query within a React component, call `useUserPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPostsQuery(baseOptions?: Apollo.QueryHookOptions<UserPostsQuery, UserPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPostsQuery, UserPostsQueryVariables>(UserPostsDocument, options);
      }
export function useUserPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPostsQuery, UserPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPostsQuery, UserPostsQueryVariables>(UserPostsDocument, options);
        }
export type UserPostsQueryHookResult = ReturnType<typeof useUserPostsQuery>;
export type UserPostsLazyQueryHookResult = ReturnType<typeof useUserPostsLazyQuery>;
export type UserPostsQueryResult = Apollo.QueryResult<UserPostsQuery, UserPostsQueryVariables>;
export const CancelPostDocument = gql`
    mutation cancelPost($postId: Int!) {
  cancelPost(postId: $postId)
}
    `;
export type CancelPostMutationFn = Apollo.MutationFunction<CancelPostMutation, CancelPostMutationVariables>;

/**
 * __useCancelPostMutation__
 *
 * To run a mutation, you first call `useCancelPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPostMutation, { data, loading, error }] = useCancelPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useCancelPostMutation(baseOptions?: Apollo.MutationHookOptions<CancelPostMutation, CancelPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPostMutation, CancelPostMutationVariables>(CancelPostDocument, options);
      }
export type CancelPostMutationHookResult = ReturnType<typeof useCancelPostMutation>;
export type CancelPostMutationResult = Apollo.MutationResult<CancelPostMutation>;
export type CancelPostMutationOptions = Apollo.BaseMutationOptions<CancelPostMutation, CancelPostMutationVariables>;
export const GetResponseDocument = gql`
    query getResponse($videoId: String, $platform: Platform!, $content: String) {
  respond(videoId: $videoId, platform: $platform, content: $content)
}
    `;

/**
 * __useGetResponseQuery__
 *
 * To run a query within a React component, call `useGetResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponseQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *      platform: // value for 'platform'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useGetResponseQuery(baseOptions: Apollo.QueryHookOptions<GetResponseQuery, GetResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResponseQuery, GetResponseQueryVariables>(GetResponseDocument, options);
      }
export function useGetResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResponseQuery, GetResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResponseQuery, GetResponseQueryVariables>(GetResponseDocument, options);
        }
export type GetResponseQueryHookResult = ReturnType<typeof useGetResponseQuery>;
export type GetResponseLazyQueryHookResult = ReturnType<typeof useGetResponseLazyQuery>;
export type GetResponseQueryResult = Apollo.QueryResult<GetResponseQuery, GetResponseQueryVariables>;
export const CreateSubscriptionDocument = gql`
    mutation createSubscription($session_id: String!, $planId: String!, $productId: String!, $subscriptionId: String!, $productName: String!, $customer_id: String!, $endDate: String!) {
  createSubscription(
    session_id: $session_id
    planId: $planId
    productId: $productId
    productName: $productName
    subscriptionId: $subscriptionId
    customer_id: $customer_id
    endDate: $endDate
  )
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      session_id: // value for 'session_id'
 *      planId: // value for 'planId'
 *      productId: // value for 'productId'
 *      subscriptionId: // value for 'subscriptionId'
 *      productName: // value for 'productName'
 *      customer_id: // value for 'customer_id'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation updateSubscription($type: String!, $endDate: String!, $subscriptionId: String!) {
  updateSubscription(
    type: $type
    endDate: $endDate
    subscriptionId: $subscriptionId
  )
}
    `;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      type: // value for 'type'
 *      endDate: // value for 'endDate'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const GetSubscriptionDocument = gql`
    query getSubscription {
  getSubscription {
    planName
    status
    stripeCheckoutSessionId
    stripeSubscriptionId
    planId
    productId
    endDate
    customerId
  }
}
    `;

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionQueryResult = Apollo.QueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const GetSuperFansDocument = gql`
    query GetSuperFans($mediaAccountId: Int, $filters: SuperFanFilters, $limit: Int, $offset: Int) {
  getSuperFans(
    mediaAccountId: $mediaAccountId
    filters: $filters
    limit: $limit
    offset: $offset
  ) {
    id
    followerPlatformId
    followerUsername
    followerDisplayName
    followerAvatarUrl
    platform
    totalLikes
    totalComments
    totalShares
    totalSaves
    postsLiked
    postsCommented
    postsShared
    postsSaved
    firstInteraction
    lastInteraction
    daysSinceFirst
    consistencyScore
    depthScore
    recencyScore
    overallScore
    tier
    hasSpecialActions
    specialActions {
      id
      actionType
      actionDescription
      actionValue
      relatedPostId
      relatedPostUrl
      detectedAt
    }
    lastCalculated
  }
}
    `;

/**
 * __useGetSuperFansQuery__
 *
 * To run a query within a React component, call `useGetSuperFansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuperFansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuperFansQuery({
 *   variables: {
 *      mediaAccountId: // value for 'mediaAccountId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSuperFansQuery(baseOptions?: Apollo.QueryHookOptions<GetSuperFansQuery, GetSuperFansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuperFansQuery, GetSuperFansQueryVariables>(GetSuperFansDocument, options);
      }
export function useGetSuperFansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuperFansQuery, GetSuperFansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuperFansQuery, GetSuperFansQueryVariables>(GetSuperFansDocument, options);
        }
export type GetSuperFansQueryHookResult = ReturnType<typeof useGetSuperFansQuery>;
export type GetSuperFansLazyQueryHookResult = ReturnType<typeof useGetSuperFansLazyQuery>;
export type GetSuperFansQueryResult = Apollo.QueryResult<GetSuperFansQuery, GetSuperFansQueryVariables>;
export const GetSuperFanStatsDocument = gql`
    query GetSuperFanStats($mediaAccountId: Int) {
  getSuperFanStats(mediaAccountId: $mediaAccountId) {
    totalSuperFans
    megaFans
    superFans
    activeFans
    casualFans
    avgConsistencyScore
    avgDepthScore
    avgRecencyScore
    topSuperFans {
      id
      followerPlatformId
      followerUsername
      followerDisplayName
      followerAvatarUrl
      platform
      totalLikes
      totalComments
      totalShares
      totalSaves
      consistencyScore
      depthScore
      recencyScore
      overallScore
      tier
      lastInteraction
    }
  }
}
    `;

/**
 * __useGetSuperFanStatsQuery__
 *
 * To run a query within a React component, call `useGetSuperFanStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuperFanStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuperFanStatsQuery({
 *   variables: {
 *      mediaAccountId: // value for 'mediaAccountId'
 *   },
 * });
 */
export function useGetSuperFanStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetSuperFanStatsQuery, GetSuperFanStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuperFanStatsQuery, GetSuperFanStatsQueryVariables>(GetSuperFanStatsDocument, options);
      }
export function useGetSuperFanStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuperFanStatsQuery, GetSuperFanStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuperFanStatsQuery, GetSuperFanStatsQueryVariables>(GetSuperFanStatsDocument, options);
        }
export type GetSuperFanStatsQueryHookResult = ReturnType<typeof useGetSuperFanStatsQuery>;
export type GetSuperFanStatsLazyQueryHookResult = ReturnType<typeof useGetSuperFanStatsLazyQuery>;
export type GetSuperFanStatsQueryResult = Apollo.QueryResult<GetSuperFanStatsQuery, GetSuperFanStatsQueryVariables>;
export const GetSuperFanBreakdownDocument = gql`
    query GetSuperFanBreakdown {
  getSuperFanBreakdown {
    platform
    totalFans
    megaFans
    superFans
    activeFans
    avgScore
  }
}
    `;

/**
 * __useGetSuperFanBreakdownQuery__
 *
 * To run a query within a React component, call `useGetSuperFanBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuperFanBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuperFanBreakdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuperFanBreakdownQuery(baseOptions?: Apollo.QueryHookOptions<GetSuperFanBreakdownQuery, GetSuperFanBreakdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuperFanBreakdownQuery, GetSuperFanBreakdownQueryVariables>(GetSuperFanBreakdownDocument, options);
      }
export function useGetSuperFanBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuperFanBreakdownQuery, GetSuperFanBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuperFanBreakdownQuery, GetSuperFanBreakdownQueryVariables>(GetSuperFanBreakdownDocument, options);
        }
export type GetSuperFanBreakdownQueryHookResult = ReturnType<typeof useGetSuperFanBreakdownQuery>;
export type GetSuperFanBreakdownLazyQueryHookResult = ReturnType<typeof useGetSuperFanBreakdownLazyQuery>;
export type GetSuperFanBreakdownQueryResult = Apollo.QueryResult<GetSuperFanBreakdownQuery, GetSuperFanBreakdownQueryVariables>;
export const CalculateSuperFansDocument = gql`
    mutation CalculateSuperFans($mediaAccountId: Int!) {
  calculateSuperFans(mediaAccountId: $mediaAccountId) {
    totalSuperFans
    megaFans
    superFans
    activeFans
    casualFans
    avgConsistencyScore
    avgDepthScore
    avgRecencyScore
    topSuperFans {
      id
      followerUsername
      overallScore
      tier
    }
  }
}
    `;
export type CalculateSuperFansMutationFn = Apollo.MutationFunction<CalculateSuperFansMutation, CalculateSuperFansMutationVariables>;

/**
 * __useCalculateSuperFansMutation__
 *
 * To run a mutation, you first call `useCalculateSuperFansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateSuperFansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateSuperFansMutation, { data, loading, error }] = useCalculateSuperFansMutation({
 *   variables: {
 *      mediaAccountId: // value for 'mediaAccountId'
 *   },
 * });
 */
export function useCalculateSuperFansMutation(baseOptions?: Apollo.MutationHookOptions<CalculateSuperFansMutation, CalculateSuperFansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateSuperFansMutation, CalculateSuperFansMutationVariables>(CalculateSuperFansDocument, options);
      }
export type CalculateSuperFansMutationHookResult = ReturnType<typeof useCalculateSuperFansMutation>;
export type CalculateSuperFansMutationResult = Apollo.MutationResult<CalculateSuperFansMutation>;
export type CalculateSuperFansMutationOptions = Apollo.BaseMutationOptions<CalculateSuperFansMutation, CalculateSuperFansMutationVariables>;
export const RecordSuperFanActionDocument = gql`
    mutation RecordSuperFanAction($followerMetricsId: ID!, $actionType: String!, $actionDescription: String, $actionValue: Int!, $relatedPostId: String, $relatedPostUrl: String) {
  recordSuperFanAction(
    followerMetricsId: $followerMetricsId
    actionType: $actionType
    actionDescription: $actionDescription
    actionValue: $actionValue
    relatedPostId: $relatedPostId
    relatedPostUrl: $relatedPostUrl
  ) {
    id
    actionType
    actionDescription
    actionValue
    detectedAt
  }
}
    `;
export type RecordSuperFanActionMutationFn = Apollo.MutationFunction<RecordSuperFanActionMutation, RecordSuperFanActionMutationVariables>;

/**
 * __useRecordSuperFanActionMutation__
 *
 * To run a mutation, you first call `useRecordSuperFanActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordSuperFanActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordSuperFanActionMutation, { data, loading, error }] = useRecordSuperFanActionMutation({
 *   variables: {
 *      followerMetricsId: // value for 'followerMetricsId'
 *      actionType: // value for 'actionType'
 *      actionDescription: // value for 'actionDescription'
 *      actionValue: // value for 'actionValue'
 *      relatedPostId: // value for 'relatedPostId'
 *      relatedPostUrl: // value for 'relatedPostUrl'
 *   },
 * });
 */
export function useRecordSuperFanActionMutation(baseOptions?: Apollo.MutationHookOptions<RecordSuperFanActionMutation, RecordSuperFanActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordSuperFanActionMutation, RecordSuperFanActionMutationVariables>(RecordSuperFanActionDocument, options);
      }
export type RecordSuperFanActionMutationHookResult = ReturnType<typeof useRecordSuperFanActionMutation>;
export type RecordSuperFanActionMutationResult = Apollo.MutationResult<RecordSuperFanActionMutation>;
export type RecordSuperFanActionMutationOptions = Apollo.BaseMutationOptions<RecordSuperFanActionMutation, RecordSuperFanActionMutationVariables>;
export const CreateHashtagsDocument = gql`
    mutation createHashtags($update: Boolean) {
  createHashtags(update: $update)
}
    `;
export type CreateHashtagsMutationFn = Apollo.MutationFunction<CreateHashtagsMutation, CreateHashtagsMutationVariables>;

/**
 * __useCreateHashtagsMutation__
 *
 * To run a mutation, you first call `useCreateHashtagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHashtagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHashtagsMutation, { data, loading, error }] = useCreateHashtagsMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useCreateHashtagsMutation(baseOptions?: Apollo.MutationHookOptions<CreateHashtagsMutation, CreateHashtagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHashtagsMutation, CreateHashtagsMutationVariables>(CreateHashtagsDocument, options);
      }
export type CreateHashtagsMutationHookResult = ReturnType<typeof useCreateHashtagsMutation>;
export type CreateHashtagsMutationResult = Apollo.MutationResult<CreateHashtagsMutation>;
export type CreateHashtagsMutationOptions = Apollo.BaseMutationOptions<CreateHashtagsMutation, CreateHashtagsMutationVariables>;
export const GetHashtagsDocument = gql`
    query getHashtags {
  getHashtags {
    trends {
      youtube {
        tag
        metrics {
          volume
          growth
          engagement
        }
      }
      instagram {
        tag
        metrics {
          volume
          growth
          engagement
        }
      }
      tiktok {
        tag
        metrics {
          volume
          growth
          engagement
        }
      }
      facebook {
        tag
        metrics {
          volume
          growth
          engagement
        }
      }
      reddit {
        tag
        metrics {
          volume
          growth
          engagement
        }
      }
    }
    createdAt
  }
}
    `;

/**
 * __useGetHashtagsQuery__
 *
 * To run a query within a React component, call `useGetHashtagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHashtagsQuery(baseOptions?: Apollo.QueryHookOptions<GetHashtagsQuery, GetHashtagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHashtagsQuery, GetHashtagsQueryVariables>(GetHashtagsDocument, options);
      }
export function useGetHashtagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHashtagsQuery, GetHashtagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHashtagsQuery, GetHashtagsQueryVariables>(GetHashtagsDocument, options);
        }
export type GetHashtagsQueryHookResult = ReturnType<typeof useGetHashtagsQuery>;
export type GetHashtagsLazyQueryHookResult = ReturnType<typeof useGetHashtagsLazyQuery>;
export type GetHashtagsQueryResult = Apollo.QueryResult<GetHashtagsQuery, GetHashtagsQueryVariables>;
export const GetNewsDocument = gql`
    query getNews {
  getNews {
    updatedAt
    news {
      article_id
      title
      link
      pubDate
      source_id
    }
  }
}
    `;

/**
 * __useGetNewsQuery__
 *
 * To run a query within a React component, call `useGetNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsQuery, GetNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsQuery, GetNewsQueryVariables>(GetNewsDocument, options);
      }
export function useGetNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsQuery, GetNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsQuery, GetNewsQueryVariables>(GetNewsDocument, options);
        }
export type GetNewsQueryHookResult = ReturnType<typeof useGetNewsQuery>;
export type GetNewsLazyQueryHookResult = ReturnType<typeof useGetNewsLazyQuery>;
export type GetNewsQueryResult = Apollo.QueryResult<GetNewsQuery, GetNewsQueryVariables>;
export const CreateTargetCreatorsDocument = gql`
    mutation createTargetCreators($creators: [String!]!) {
  createTargetCreators(creators: $creators)
}
    `;
export type CreateTargetCreatorsMutationFn = Apollo.MutationFunction<CreateTargetCreatorsMutation, CreateTargetCreatorsMutationVariables>;

/**
 * __useCreateTargetCreatorsMutation__
 *
 * To run a mutation, you first call `useCreateTargetCreatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTargetCreatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTargetCreatorsMutation, { data, loading, error }] = useCreateTargetCreatorsMutation({
 *   variables: {
 *      creators: // value for 'creators'
 *   },
 * });
 */
export function useCreateTargetCreatorsMutation(baseOptions?: Apollo.MutationHookOptions<CreateTargetCreatorsMutation, CreateTargetCreatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTargetCreatorsMutation, CreateTargetCreatorsMutationVariables>(CreateTargetCreatorsDocument, options);
      }
export type CreateTargetCreatorsMutationHookResult = ReturnType<typeof useCreateTargetCreatorsMutation>;
export type CreateTargetCreatorsMutationResult = Apollo.MutationResult<CreateTargetCreatorsMutation>;
export type CreateTargetCreatorsMutationOptions = Apollo.BaseMutationOptions<CreateTargetCreatorsMutation, CreateTargetCreatorsMutationVariables>;
export const GetCreatorsDocument = gql`
    query getCreators {
  getCreators {
    creators
    info {
      id
      resultDate
      username
      avatarUrl
      hashtags
      followersCount
      likesCount
      commentsCount
      summary
      relatedProfiles
      taggedUsers
    }
    createdAt
  }
}
    `;

/**
 * __useGetCreatorsQuery__
 *
 * To run a query within a React component, call `useGetCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreatorsQuery(baseOptions?: Apollo.QueryHookOptions<GetCreatorsQuery, GetCreatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorsQuery, GetCreatorsQueryVariables>(GetCreatorsDocument, options);
      }
export function useGetCreatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorsQuery, GetCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorsQuery, GetCreatorsQueryVariables>(GetCreatorsDocument, options);
        }
export type GetCreatorsQueryHookResult = ReturnType<typeof useGetCreatorsQuery>;
export type GetCreatorsLazyQueryHookResult = ReturnType<typeof useGetCreatorsLazyQuery>;
export type GetCreatorsQueryResult = Apollo.QueryResult<GetCreatorsQuery, GetCreatorsQueryVariables>;
export const GetTargetFollowersDocument = gql`
    query getTargetFollowers {
  getTargetFollowers {
    id
    resultsDate
    avatarUrl
    accountName
    popularFollowers {
      username
      avatar
    }
    activeFollowers {
      username
      avatar
    }
    similarFollowers {
      username
      avatar
    }
    account_id
    isProcessing
    processingStatus
    progress
    errorMessage
  }
}
    `;

/**
 * __useGetTargetFollowersQuery__
 *
 * To run a query within a React component, call `useGetTargetFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetFollowersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTargetFollowersQuery(baseOptions?: Apollo.QueryHookOptions<GetTargetFollowersQuery, GetTargetFollowersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTargetFollowersQuery, GetTargetFollowersQueryVariables>(GetTargetFollowersDocument, options);
      }
export function useGetTargetFollowersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTargetFollowersQuery, GetTargetFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTargetFollowersQuery, GetTargetFollowersQueryVariables>(GetTargetFollowersDocument, options);
        }
export type GetTargetFollowersQueryHookResult = ReturnType<typeof useGetTargetFollowersQuery>;
export type GetTargetFollowersLazyQueryHookResult = ReturnType<typeof useGetTargetFollowersLazyQuery>;
export type GetTargetFollowersQueryResult = Apollo.QueryResult<GetTargetFollowersQuery, GetTargetFollowersQueryVariables>;
export const AnalyzeFollowersDocument = gql`
    mutation analyzeFollowers($accountId: Int!) {
  analyzeFollowers(accountId: $accountId)
}
    `;
export type AnalyzeFollowersMutationFn = Apollo.MutationFunction<AnalyzeFollowersMutation, AnalyzeFollowersMutationVariables>;

/**
 * __useAnalyzeFollowersMutation__
 *
 * To run a mutation, you first call `useAnalyzeFollowersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeFollowersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyzeFollowersMutation, { data, loading, error }] = useAnalyzeFollowersMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAnalyzeFollowersMutation(baseOptions?: Apollo.MutationHookOptions<AnalyzeFollowersMutation, AnalyzeFollowersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyzeFollowersMutation, AnalyzeFollowersMutationVariables>(AnalyzeFollowersDocument, options);
      }
export type AnalyzeFollowersMutationHookResult = ReturnType<typeof useAnalyzeFollowersMutation>;
export type AnalyzeFollowersMutationResult = Apollo.MutationResult<AnalyzeFollowersMutation>;
export type AnalyzeFollowersMutationOptions = Apollo.BaseMutationOptions<AnalyzeFollowersMutation, AnalyzeFollowersMutationVariables>;
export const GetTargetResultsDocument = gql`
    query getTargetResults {
  getTargetFollowersResults {
    id
    resultDate
    username
    avatarUrl
    hashtags
    followersCount
    likesCount
    commentsCount
    summary
    relatedProfiles
    taggedUsers
  }
}
    `;

/**
 * __useGetTargetResultsQuery__
 *
 * To run a query within a React component, call `useGetTargetResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetResultsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTargetResultsQuery(baseOptions?: Apollo.QueryHookOptions<GetTargetResultsQuery, GetTargetResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTargetResultsQuery, GetTargetResultsQueryVariables>(GetTargetResultsDocument, options);
      }
export function useGetTargetResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTargetResultsQuery, GetTargetResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTargetResultsQuery, GetTargetResultsQueryVariables>(GetTargetResultsDocument, options);
        }
export type GetTargetResultsQueryHookResult = ReturnType<typeof useGetTargetResultsQuery>;
export type GetTargetResultsLazyQueryHookResult = ReturnType<typeof useGetTargetResultsLazyQuery>;
export type GetTargetResultsQueryResult = Apollo.QueryResult<GetTargetResultsQuery, GetTargetResultsQueryVariables>;
export const CreateInstagramInsightsDocument = gql`
    mutation createInstagramInsights($accountId: Int!) {
  createInstagramInsights(accountId: $accountId)
}
    `;
export type CreateInstagramInsightsMutationFn = Apollo.MutationFunction<CreateInstagramInsightsMutation, CreateInstagramInsightsMutationVariables>;

/**
 * __useCreateInstagramInsightsMutation__
 *
 * To run a mutation, you first call `useCreateInstagramInsightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstagramInsightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstagramInsightsMutation, { data, loading, error }] = useCreateInstagramInsightsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCreateInstagramInsightsMutation(baseOptions?: Apollo.MutationHookOptions<CreateInstagramInsightsMutation, CreateInstagramInsightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInstagramInsightsMutation, CreateInstagramInsightsMutationVariables>(CreateInstagramInsightsDocument, options);
      }
export type CreateInstagramInsightsMutationHookResult = ReturnType<typeof useCreateInstagramInsightsMutation>;
export type CreateInstagramInsightsMutationResult = Apollo.MutationResult<CreateInstagramInsightsMutation>;
export type CreateInstagramInsightsMutationOptions = Apollo.BaseMutationOptions<CreateInstagramInsightsMutation, CreateInstagramInsightsMutationVariables>;
export const GetInstagramInsightsDocument = gql`
    query getInstagramInsights {
  getInstagramInsights {
    id
    startDate
    endDate
    reach
    impressions
    profile_views
  }
}
    `;

/**
 * __useGetInstagramInsightsQuery__
 *
 * To run a query within a React component, call `useGetInstagramInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstagramInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstagramInsightsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInstagramInsightsQuery(baseOptions?: Apollo.QueryHookOptions<GetInstagramInsightsQuery, GetInstagramInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstagramInsightsQuery, GetInstagramInsightsQueryVariables>(GetInstagramInsightsDocument, options);
      }
export function useGetInstagramInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstagramInsightsQuery, GetInstagramInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstagramInsightsQuery, GetInstagramInsightsQueryVariables>(GetInstagramInsightsDocument, options);
        }
export type GetInstagramInsightsQueryHookResult = ReturnType<typeof useGetInstagramInsightsQuery>;
export type GetInstagramInsightsLazyQueryHookResult = ReturnType<typeof useGetInstagramInsightsLazyQuery>;
export type GetInstagramInsightsQueryResult = Apollo.QueryResult<GetInstagramInsightsQuery, GetInstagramInsightsQueryVariables>;
export const RefreshTargetFollowersDocument = gql`
    mutation refreshTargetFollowers($id: Int!, $accountId: Int!) {
  refreshTargetFollowers(id: $id, accountId: $accountId)
}
    `;
export type RefreshTargetFollowersMutationFn = Apollo.MutationFunction<RefreshTargetFollowersMutation, RefreshTargetFollowersMutationVariables>;

/**
 * __useRefreshTargetFollowersMutation__
 *
 * To run a mutation, you first call `useRefreshTargetFollowersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTargetFollowersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTargetFollowersMutation, { data, loading, error }] = useRefreshTargetFollowersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRefreshTargetFollowersMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTargetFollowersMutation, RefreshTargetFollowersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTargetFollowersMutation, RefreshTargetFollowersMutationVariables>(RefreshTargetFollowersDocument, options);
      }
export type RefreshTargetFollowersMutationHookResult = ReturnType<typeof useRefreshTargetFollowersMutation>;
export type RefreshTargetFollowersMutationResult = Apollo.MutationResult<RefreshTargetFollowersMutation>;
export type RefreshTargetFollowersMutationOptions = Apollo.BaseMutationOptions<RefreshTargetFollowersMutation, RefreshTargetFollowersMutationVariables>;
export const RefreshTargetCreatorsDocument = gql`
    mutation refreshTargetCreators($creators: [String!]!) {
  refreshTargetCreators(creators: $creators)
}
    `;
export type RefreshTargetCreatorsMutationFn = Apollo.MutationFunction<RefreshTargetCreatorsMutation, RefreshTargetCreatorsMutationVariables>;

/**
 * __useRefreshTargetCreatorsMutation__
 *
 * To run a mutation, you first call `useRefreshTargetCreatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTargetCreatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTargetCreatorsMutation, { data, loading, error }] = useRefreshTargetCreatorsMutation({
 *   variables: {
 *      creators: // value for 'creators'
 *   },
 * });
 */
export function useRefreshTargetCreatorsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTargetCreatorsMutation, RefreshTargetCreatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTargetCreatorsMutation, RefreshTargetCreatorsMutationVariables>(RefreshTargetCreatorsDocument, options);
      }
export type RefreshTargetCreatorsMutationHookResult = ReturnType<typeof useRefreshTargetCreatorsMutation>;
export type RefreshTargetCreatorsMutationResult = Apollo.MutationResult<RefreshTargetCreatorsMutation>;
export type RefreshTargetCreatorsMutationOptions = Apollo.BaseMutationOptions<RefreshTargetCreatorsMutation, RefreshTargetCreatorsMutationVariables>;
export const FetchFollowerDetailsDocument = gql`
    mutation fetchFollowerDetails($usernames: [String!]!) {
  fetchFollowerDetails(usernames: $usernames) {
    username
    platform
    bio
    profileImage
    tags {
      name
      count
    }
    profileSummary
    commentsSummary
    stats {
      followers
      posts
      following
      likes
      comments
    }
  }
}
    `;
export type FetchFollowerDetailsMutationFn = Apollo.MutationFunction<FetchFollowerDetailsMutation, FetchFollowerDetailsMutationVariables>;

/**
 * __useFetchFollowerDetailsMutation__
 *
 * To run a mutation, you first call `useFetchFollowerDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchFollowerDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchFollowerDetailsMutation, { data, loading, error }] = useFetchFollowerDetailsMutation({
 *   variables: {
 *      usernames: // value for 'usernames'
 *   },
 * });
 */
export function useFetchFollowerDetailsMutation(baseOptions?: Apollo.MutationHookOptions<FetchFollowerDetailsMutation, FetchFollowerDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FetchFollowerDetailsMutation, FetchFollowerDetailsMutationVariables>(FetchFollowerDetailsDocument, options);
      }
export type FetchFollowerDetailsMutationHookResult = ReturnType<typeof useFetchFollowerDetailsMutation>;
export type FetchFollowerDetailsMutationResult = Apollo.MutationResult<FetchFollowerDetailsMutation>;
export type FetchFollowerDetailsMutationOptions = Apollo.BaseMutationOptions<FetchFollowerDetailsMutation, FetchFollowerDetailsMutationVariables>;
export const FetchSimilarAccountsDocument = gql`
    mutation fetchSimilarAccounts($username: String!) {
  fetchSimilarAccounts(username: $username) {
    username
    follower_count
    profile_pic_url
  }
}
    `;
export type FetchSimilarAccountsMutationFn = Apollo.MutationFunction<FetchSimilarAccountsMutation, FetchSimilarAccountsMutationVariables>;

/**
 * __useFetchSimilarAccountsMutation__
 *
 * To run a mutation, you first call `useFetchSimilarAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchSimilarAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchSimilarAccountsMutation, { data, loading, error }] = useFetchSimilarAccountsMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useFetchSimilarAccountsMutation(baseOptions?: Apollo.MutationHookOptions<FetchSimilarAccountsMutation, FetchSimilarAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FetchSimilarAccountsMutation, FetchSimilarAccountsMutationVariables>(FetchSimilarAccountsDocument, options);
      }
export type FetchSimilarAccountsMutationHookResult = ReturnType<typeof useFetchSimilarAccountsMutation>;
export type FetchSimilarAccountsMutationResult = Apollo.MutationResult<FetchSimilarAccountsMutation>;
export type FetchSimilarAccountsMutationOptions = Apollo.BaseMutationOptions<FetchSimilarAccountsMutation, FetchSimilarAccountsMutationVariables>;
export const FetchUserPostsDocument = gql`
    mutation fetchUserPosts($username: String!) {
  fetchUserPosts(username: $username) {
    id
    like_count
    comment_count
    caption {
      text
      hashtags
    }
  }
}
    `;
export type FetchUserPostsMutationFn = Apollo.MutationFunction<FetchUserPostsMutation, FetchUserPostsMutationVariables>;

/**
 * __useFetchUserPostsMutation__
 *
 * To run a mutation, you first call `useFetchUserPostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchUserPostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchUserPostsMutation, { data, loading, error }] = useFetchUserPostsMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useFetchUserPostsMutation(baseOptions?: Apollo.MutationHookOptions<FetchUserPostsMutation, FetchUserPostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FetchUserPostsMutation, FetchUserPostsMutationVariables>(FetchUserPostsDocument, options);
      }
export type FetchUserPostsMutationHookResult = ReturnType<typeof useFetchUserPostsMutation>;
export type FetchUserPostsMutationResult = Apollo.MutationResult<FetchUserPostsMutation>;
export type FetchUserPostsMutationOptions = Apollo.BaseMutationOptions<FetchUserPostsMutation, FetchUserPostsMutationVariables>;
export const GenerateProfileSummaryDocument = gql`
    mutation generateProfileSummary($username: String!, $stats: FollowerStatsInput!) {
  generateProfileSummary(username: $username, stats: $stats)
}
    `;
export type GenerateProfileSummaryMutationFn = Apollo.MutationFunction<GenerateProfileSummaryMutation, GenerateProfileSummaryMutationVariables>;

/**
 * __useGenerateProfileSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateProfileSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProfileSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProfileSummaryMutation, { data, loading, error }] = useGenerateProfileSummaryMutation({
 *   variables: {
 *      username: // value for 'username'
 *      stats: // value for 'stats'
 *   },
 * });
 */
export function useGenerateProfileSummaryMutation(baseOptions?: Apollo.MutationHookOptions<GenerateProfileSummaryMutation, GenerateProfileSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateProfileSummaryMutation, GenerateProfileSummaryMutationVariables>(GenerateProfileSummaryDocument, options);
      }
export type GenerateProfileSummaryMutationHookResult = ReturnType<typeof useGenerateProfileSummaryMutation>;
export type GenerateProfileSummaryMutationResult = Apollo.MutationResult<GenerateProfileSummaryMutation>;
export type GenerateProfileSummaryMutationOptions = Apollo.BaseMutationOptions<GenerateProfileSummaryMutation, GenerateProfileSummaryMutationVariables>;
export const GenerateCommentsSummaryDocument = gql`
    mutation generateCommentsSummary($username: String!, $commentCount: Int!) {
  generateCommentsSummary(username: $username, commentCount: $commentCount)
}
    `;
export type GenerateCommentsSummaryMutationFn = Apollo.MutationFunction<GenerateCommentsSummaryMutation, GenerateCommentsSummaryMutationVariables>;

/**
 * __useGenerateCommentsSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateCommentsSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCommentsSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCommentsSummaryMutation, { data, loading, error }] = useGenerateCommentsSummaryMutation({
 *   variables: {
 *      username: // value for 'username'
 *      commentCount: // value for 'commentCount'
 *   },
 * });
 */
export function useGenerateCommentsSummaryMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCommentsSummaryMutation, GenerateCommentsSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCommentsSummaryMutation, GenerateCommentsSummaryMutationVariables>(GenerateCommentsSummaryDocument, options);
      }
export type GenerateCommentsSummaryMutationHookResult = ReturnType<typeof useGenerateCommentsSummaryMutation>;
export type GenerateCommentsSummaryMutationResult = Apollo.MutationResult<GenerateCommentsSummaryMutation>;
export type GenerateCommentsSummaryMutationOptions = Apollo.BaseMutationOptions<GenerateCommentsSummaryMutation, GenerateCommentsSummaryMutationVariables>;
export const GetUserDocument = gql`
    query getUser {
  user {
    ...FullUserInformation
  }
}
    ${FullUserInformationFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserBasicDocument = gql`
    query getUserBasic {
  user {
    ...CommonUserInformation
  }
}
    ${CommonUserInformationFragmentDoc}`;

/**
 * __useGetUserBasicQuery__
 *
 * To run a query within a React component, call `useGetUserBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBasicQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserBasicQuery(baseOptions?: Apollo.QueryHookOptions<GetUserBasicQuery, GetUserBasicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserBasicQuery, GetUserBasicQueryVariables>(GetUserBasicDocument, options);
      }
export function useGetUserBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserBasicQuery, GetUserBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserBasicQuery, GetUserBasicQueryVariables>(GetUserBasicDocument, options);
        }
export type GetUserBasicQueryHookResult = ReturnType<typeof useGetUserBasicQuery>;
export type GetUserBasicLazyQueryHookResult = ReturnType<typeof useGetUserBasicLazyQuery>;
export type GetUserBasicQueryResult = Apollo.QueryResult<GetUserBasicQuery, GetUserBasicQueryVariables>;
export const GetUserWithSubscriptionDocument = gql`
    query getUserWithSubscription {
  user {
    ...CommonUserInformation
    subscription {
      ...UserSubscriptionInfo
    }
  }
}
    ${CommonUserInformationFragmentDoc}
${UserSubscriptionInfoFragmentDoc}`;

/**
 * __useGetUserWithSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetUserWithSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWithSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWithSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWithSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWithSubscriptionQuery, GetUserWithSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWithSubscriptionQuery, GetUserWithSubscriptionQueryVariables>(GetUserWithSubscriptionDocument, options);
      }
export function useGetUserWithSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWithSubscriptionQuery, GetUserWithSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWithSubscriptionQuery, GetUserWithSubscriptionQueryVariables>(GetUserWithSubscriptionDocument, options);
        }
export type GetUserWithSubscriptionQueryHookResult = ReturnType<typeof useGetUserWithSubscriptionQuery>;
export type GetUserWithSubscriptionLazyQueryHookResult = ReturnType<typeof useGetUserWithSubscriptionLazyQuery>;
export type GetUserWithSubscriptionQueryResult = Apollo.QueryResult<GetUserWithSubscriptionQuery, GetUserWithSubscriptionQueryVariables>;
export const GetUserWithUsageDocument = gql`
    query getUserWithUsage {
  user {
    ...CommonUserInformation
    usage {
      ...UserUsageInfo
    }
  }
}
    ${CommonUserInformationFragmentDoc}
${UserUsageInfoFragmentDoc}`;

/**
 * __useGetUserWithUsageQuery__
 *
 * To run a query within a React component, call `useGetUserWithUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWithUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWithUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWithUsageQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWithUsageQuery, GetUserWithUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWithUsageQuery, GetUserWithUsageQueryVariables>(GetUserWithUsageDocument, options);
      }
export function useGetUserWithUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWithUsageQuery, GetUserWithUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWithUsageQuery, GetUserWithUsageQueryVariables>(GetUserWithUsageDocument, options);
        }
export type GetUserWithUsageQueryHookResult = ReturnType<typeof useGetUserWithUsageQuery>;
export type GetUserWithUsageLazyQueryHookResult = ReturnType<typeof useGetUserWithUsageLazyQuery>;
export type GetUserWithUsageQueryResult = Apollo.QueryResult<GetUserWithUsageQuery, GetUserWithUsageQueryVariables>;
export const GetWeeklyContextStatusDocument = gql`
    query GetWeeklyContextStatus {
  getWeeklyContextStatus {
    hasCurrentWeek
    lastUpdated
    currentContext {
      id
      weekStart
      context
      createdAt
      updatedAt
      isActive
    }
  }
}
    `;

/**
 * __useGetWeeklyContextStatusQuery__
 *
 * To run a query within a React component, call `useGetWeeklyContextStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyContextStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyContextStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWeeklyContextStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetWeeklyContextStatusQuery, GetWeeklyContextStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWeeklyContextStatusQuery, GetWeeklyContextStatusQueryVariables>(GetWeeklyContextStatusDocument, options);
      }
export function useGetWeeklyContextStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWeeklyContextStatusQuery, GetWeeklyContextStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWeeklyContextStatusQuery, GetWeeklyContextStatusQueryVariables>(GetWeeklyContextStatusDocument, options);
        }
export type GetWeeklyContextStatusQueryHookResult = ReturnType<typeof useGetWeeklyContextStatusQuery>;
export type GetWeeklyContextStatusLazyQueryHookResult = ReturnType<typeof useGetWeeklyContextStatusLazyQuery>;
export type GetWeeklyContextStatusQueryResult = Apollo.QueryResult<GetWeeklyContextStatusQuery, GetWeeklyContextStatusQueryVariables>;
export const GetActiveWeeklyContextDocument = gql`
    query GetActiveWeeklyContext {
  getActiveWeeklyContext {
    id
    weekStart
    context
    createdAt
    updatedAt
    isActive
  }
}
    `;

/**
 * __useGetActiveWeeklyContextQuery__
 *
 * To run a query within a React component, call `useGetActiveWeeklyContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveWeeklyContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveWeeklyContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveWeeklyContextQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveWeeklyContextQuery, GetActiveWeeklyContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveWeeklyContextQuery, GetActiveWeeklyContextQueryVariables>(GetActiveWeeklyContextDocument, options);
      }
export function useGetActiveWeeklyContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveWeeklyContextQuery, GetActiveWeeklyContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveWeeklyContextQuery, GetActiveWeeklyContextQueryVariables>(GetActiveWeeklyContextDocument, options);
        }
export type GetActiveWeeklyContextQueryHookResult = ReturnType<typeof useGetActiveWeeklyContextQuery>;
export type GetActiveWeeklyContextLazyQueryHookResult = ReturnType<typeof useGetActiveWeeklyContextLazyQuery>;
export type GetActiveWeeklyContextQueryResult = Apollo.QueryResult<GetActiveWeeklyContextQuery, GetActiveWeeklyContextQueryVariables>;
export const GetWeeklyContextHistoryDocument = gql`
    query GetWeeklyContextHistory($limit: Int) {
  getWeeklyContextHistory(limit: $limit) {
    id
    weekStart
    context
    createdAt
    updatedAt
    isActive
  }
}
    `;

/**
 * __useGetWeeklyContextHistoryQuery__
 *
 * To run a query within a React component, call `useGetWeeklyContextHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyContextHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyContextHistoryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetWeeklyContextHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetWeeklyContextHistoryQuery, GetWeeklyContextHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWeeklyContextHistoryQuery, GetWeeklyContextHistoryQueryVariables>(GetWeeklyContextHistoryDocument, options);
      }
export function useGetWeeklyContextHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWeeklyContextHistoryQuery, GetWeeklyContextHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWeeklyContextHistoryQuery, GetWeeklyContextHistoryQueryVariables>(GetWeeklyContextHistoryDocument, options);
        }
export type GetWeeklyContextHistoryQueryHookResult = ReturnType<typeof useGetWeeklyContextHistoryQuery>;
export type GetWeeklyContextHistoryLazyQueryHookResult = ReturnType<typeof useGetWeeklyContextHistoryLazyQuery>;
export type GetWeeklyContextHistoryQueryResult = Apollo.QueryResult<GetWeeklyContextHistoryQuery, GetWeeklyContextHistoryQueryVariables>;
export const CreateWeeklyContextDocument = gql`
    mutation CreateWeeklyContext($context: WeeklyContextInput!) {
  createWeeklyContext(context: $context)
}
    `;
export type CreateWeeklyContextMutationFn = Apollo.MutationFunction<CreateWeeklyContextMutation, CreateWeeklyContextMutationVariables>;

/**
 * __useCreateWeeklyContextMutation__
 *
 * To run a mutation, you first call `useCreateWeeklyContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWeeklyContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWeeklyContextMutation, { data, loading, error }] = useCreateWeeklyContextMutation({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useCreateWeeklyContextMutation(baseOptions?: Apollo.MutationHookOptions<CreateWeeklyContextMutation, CreateWeeklyContextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWeeklyContextMutation, CreateWeeklyContextMutationVariables>(CreateWeeklyContextDocument, options);
      }
export type CreateWeeklyContextMutationHookResult = ReturnType<typeof useCreateWeeklyContextMutation>;
export type CreateWeeklyContextMutationResult = Apollo.MutationResult<CreateWeeklyContextMutation>;
export type CreateWeeklyContextMutationOptions = Apollo.BaseMutationOptions<CreateWeeklyContextMutation, CreateWeeklyContextMutationVariables>;